export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Client-only directive used for runtime endpoint routing.
   * It is removed from outgoing operations before requests are sent.
   */
  ApiName: { input: unknown; output: unknown; }
  Date: { input: unknown; output: unknown; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  Decimal: { input: unknown; output: unknown; }
  GenericScalar: { input: unknown; output: unknown; }
  IntegrationId: { input: unknown; output: unknown; }
  JSONString: { input: unknown; output: unknown; }
  /** Closed, safe session telemetry heartbeat details. */
  SessionTelemetryDetails: { input: unknown; output: unknown; }
  /** Output-only JSON object containing extracted Core slots. */
  SessionTranscriptionSlots: { input: never; output: Record<string, unknown>; }
  SlotValue: { input: unknown; output: unknown; }
};

export enum A2PStatusEnum {
  Approved = 'APPROVED',
  CustomTwilio = 'CUSTOM_TWILIO',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotRequired = 'NOT_REQUIRED',
  NotStarted = 'NOT_STARTED',
  PartnerTelco = 'PARTNER_TELCO',
  Submitted = 'SUBMITTED'
}

export type AccountCallSettingsMutation = {
  __typename?: 'AccountCallSettingsMutation';
  brokerage?: Maybe<BrokerageType>;
};

export type AcculynxOptionsType = {
  __typename?: 'AcculynxOptionsType';
  appointmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  companyId?: Maybe<Scalars['String']['output']>;
  jobCategories?: Maybe<Array<IntegrationSlotType>>;
  leadSources?: Maybe<Array<Scalars['String']['output']>>;
  milestones?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  priorities?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  tradeTypes?: Maybe<Array<Scalars['String']['output']>>;
  workTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type ActivateCustomIntentMutation = {
  __typename?: 'ActivateCustomIntentMutation';
  activatedIntent?: Maybe<Scalars['Boolean']['output']>;
  defaultDeactivatedId?: Maybe<Scalars['ID']['output']>;
};

export type ActivateCustomIntentVersionMutation = {
  __typename?: 'ActivateCustomIntentVersionMutation';
  activatedLatestVersion?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivateCustomScriptMutation = {
  __typename?: 'ActivateCustomScriptMutation';
  activatedLatestVersion?: Maybe<Scalars['Boolean']['output']>;
  activatedScript?: Maybe<Scalars['Boolean']['output']>;
  customDeactivatedId?: Maybe<Scalars['ID']['output']>;
  defaultDeactivatedId?: Maybe<Scalars['ID']['output']>;
};

export type ActivateCustomScriptVersionMutation = {
  __typename?: 'ActivateCustomScriptVersionMutation';
  activatedLatestVersion?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivateDefaultScriptMutation = {
  __typename?: 'ActivateDefaultScriptMutation';
  activatedScript?: Maybe<Scalars['Boolean']['output']>;
  customDeactivatedId?: Maybe<Scalars['ID']['output']>;
};

export type ActivatePartnerUserTestModeMutation = {
  __typename?: 'ActivatePartnerUserTestModeMutation';
  result?: Maybe<ConnectPortalAuthenticationType>;
};

export type AddAgentToBrokerageMutation = {
  __typename?: 'AddAgentToBrokerageMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddAgentToTeamMutation = {
  __typename?: 'AddAgentToTeamMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddBonzoTwilioIntegrationMutation = {
  __typename?: 'AddBonzoTwilioIntegrationMutation';
  result?: Maybe<BonzoTwilioPlatformType>;
};

export type AddCommioIntegrationMutation = {
  __typename?: 'AddCommioIntegrationMutation';
  result?: Maybe<CommioPlatformType>;
};

export type AddCustomTwilioIntegrationMutation = {
  __typename?: 'AddCustomTwilioIntegrationMutation';
  customTwilioToken?: Maybe<TwilioAuthTokenType>;
};

export type AddCustomerFilterMutation = {
  __typename?: 'AddCustomerFilterMutation';
  customerFilter?: Maybe<CustomerFilterType>;
};

export type AddFacebookIntegrationMutation = {
  __typename?: 'AddFacebookIntegrationMutation';
  facebook?: Maybe<FacebookIntegrationType>;
};

export type AddFauxIntegrationMutation = {
  __typename?: 'AddFauxIntegrationMutation';
  agent?: Maybe<AgentType>;
};

export type AddMailgunDomainMutation = {
  __typename?: 'AddMailgunDomainMutation';
  mailgunDomains?: Maybe<MailgunDomainType>;
};

export type AddMailgunIntegrationMutation = {
  __typename?: 'AddMailgunIntegrationMutation';
  mailgun?: Maybe<MailgunIntegrationType>;
};

export type AddMessageBirdIntegrationMutation = {
  __typename?: 'AddMessageBirdIntegrationMutation';
  result?: Maybe<MessageBirdPlatformType>;
};

export type AddNoteMutation = {
  __typename?: 'AddNoteMutation';
  note?: Maybe<ChatbotHistoryType>;
};

export type AddTaskMutation = {
  __typename?: 'AddTaskMutation';
  task?: Maybe<TaskType>;
};

export type AddTeamToBrokerageMutation = {
  __typename?: 'AddTeamToBrokerageMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTelnyxIntegrationMutation = {
  __typename?: 'AddTelnyxIntegrationMutation';
  result?: Maybe<TelnyxPlatformType>;
};

export type AddTwilioIntegrationMutation = {
  __typename?: 'AddTwilioIntegrationMutation';
  twilio?: Maybe<TwilioIntegrationType>;
};

export type AddVonageIntegrationMutation = {
  __typename?: 'AddVonageIntegrationMutation';
  result?: Maybe<VonagePlatformType>;
};

export type AddWebchatIntegrationMutation = {
  __typename?: 'AddWebchatIntegrationMutation';
  webchat?: Maybe<WebchatIntegrationType>;
};

export type AddressType = {
  __typename?: 'AddressType';
  address?: Maybe<Scalars['String']['output']>;
  mlsId?: Maybe<Scalars['String']['output']>;
};

export type AdminAuthenticationType = {
  __typename?: 'AdminAuthenticationType';
  additionalScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  adminId?: Maybe<Scalars['ID']['output']>;
  authJwt?: Maybe<Scalars['String']['output']>;
};

export type AdminClaimTwilioPhoneNumberMutation = {
  __typename?: 'AdminClaimTwilioPhoneNumberMutation';
  result?: Maybe<CommunicationChannelType>;
};

export type AdminClaimVonagePhoneNumberMutation = {
  __typename?: 'AdminClaimVonagePhoneNumberMutation';
  result?: Maybe<CommunicationChannelType>;
};

export type AdminProvisionAllUsAreaCodesForTwilioMutation = {
  __typename?: 'AdminProvisionAllUsAreaCodesForTwilioMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminType = {
  __typename?: 'AdminType';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  superUser: Scalars['Boolean']['output'];
};

export type AdminUpdateAccountOpsMutation = {
  __typename?: 'AdminUpdateAccountOpsMutation';
  result?: Maybe<BrokerageType>;
};

export type AdminUpdateFeatureFlagsMutation = {
  __typename?: 'AdminUpdateFeatureFlagsMutation';
  brokerage?: Maybe<BrokerageType>;
};

export type AdminUpdateInvoiceTypeMutation = {
  __typename?: 'AdminUpdateInvoiceTypeMutation';
  invoice: BillingInvoiceType;
};

export type AdminUpdateStripeConfiguration = {
  __typename?: 'AdminUpdateStripeConfiguration';
  brokerage?: Maybe<BrokerageType>;
};

export type AdvancedBehaviorInputType = {
  actions?: InputMaybe<Array<AdvancedBehavioralInputActionType>>;
  clearDelay?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuppressedBy?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<BehavioralDelayInputType>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  integrationName?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  suppressedBy?: InputMaybe<BehavioralTriggerInputType>;
  triggeredBy?: InputMaybe<BehavioralTriggerInputType>;
};

export type AdvancedBehaviorType = {
  __typename?: 'AdvancedBehaviorType';
  actions: Array<AdvancedBehavioralActionType>;
  delay?: Maybe<BehavioralDelayType>;
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationName: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  suppressedBy?: Maybe<BehavioralTriggerType>;
  triggeredBy: BehavioralTriggerType;
};

export type AdvancedBehavioralActionType = EnrollmentActionType | MuteActionType;

export type AdvancedBehavioralInputActionType = {
  actionType: Scalars['String']['input'];
  chatbotMuted?: InputMaybe<Scalars['Boolean']['input']>;
  chatbotVoiceMuted?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<BehavioralDelayInputType>;
  fastStart?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type AdvancedCallRoutingInputType = {
  name: Scalars['String']['input'];
  rules?: InputMaybe<Array<AdvancedCallRoutingRuleInputType>>;
};

export type AdvancedCallRoutingRuleInputType = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  targetAgentId?: InputMaybe<Scalars['ID']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  targetPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  targetType: RoutingRuleTargetTypeEnum;
  transferWhisperTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type AdvancedCallRoutingRuleType = {
  __typename?: 'AdvancedCallRoutingRuleType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  targetAgent?: Maybe<AgentReferenceType>;
  targetName?: Maybe<Scalars['String']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<RoutingRuleTargetTypeEnum>;
  transferWhisperTemplate?: Maybe<Scalars['String']['output']>;
};

export type AdvancedCallRoutingType = {
  __typename?: 'AdvancedCallRoutingType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<AdvancedCallRoutingRuleType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdvancedCallRoutingUpdateInputType = {
  name?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<AdvancedCallRoutingRuleInputType>>;
};

export type AgentCustomerUpdatesType = {
  __typename?: 'AgentCustomerUpdatesType';
  customer?: Maybe<CustomerType>;
  type?: Maybe<CustomerEventEnum>;
};

export type AgentDialerRecordingsType = {
  __typename?: 'AgentDialerRecordingsType';
  id?: Maybe<Scalars['String']['output']>;
  isGreeting?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  presignedRecordingUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentDialerSettingsInputType = {
  automaticallyRegisterForInboundCalls?: InputMaybe<Scalars['Boolean']['input']>;
  automaticallyStartDialing?: InputMaybe<Scalars['Boolean']['input']>;
  cooldownSecondsBetweenCallFailures?: InputMaybe<Scalars['Int']['input']>;
  cooldownSecondsBetweenCalls?: InputMaybe<Scalars['Int']['input']>;
  defaultLeadList?: InputMaybe<Scalars['String']['input']>;
};

export type AgentDialerSettingsMutation = {
  __typename?: 'AgentDialerSettingsMutation';
  agent?: Maybe<AgentType>;
};

export type AgentDialerSettingsType = {
  __typename?: 'AgentDialerSettingsType';
  automaticallyRegisterForInboundCalls?: Maybe<Scalars['Boolean']['output']>;
  automaticallyStartDialing?: Maybe<Scalars['Boolean']['output']>;
  cooldownSecondsBetweenCallFailures?: Maybe<Scalars['Int']['output']>;
  cooldownSecondsBetweenCalls?: Maybe<Scalars['Int']['output']>;
  defaultLeadList?: Maybe<Scalars['String']['output']>;
  recordings?: Maybe<Array<AgentDialerRecordingsType>>;
};

export type AgentInputType = {
  agencyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  mlsNeeded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mlsProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<AgentSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};

export type AgentInviteType = {
  email: Scalars['String']['input'];
  isLender?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type AgentLegendEmailPlatformType = {
  __typename?: 'AgentLegendEmailPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AgentLegendOptionsType = {
  __typename?: 'AgentLegendOptionsType';
  accountId?: Maybe<Scalars['String']['output']>;
  apiEndpoint?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
};

export type AgentLegendTwilioPlatformType = {
  __typename?: 'AgentLegendTwilioPlatformType';
  accountSid: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
};

export type AgentMutation = {
  __typename?: 'AgentMutation';
  agent?: Maybe<AgentType>;
};

export type AgentReferenceType = {
  __typename?: 'AgentReferenceType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type AgentSettingsInputType = {
  callingHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotAllowedDomains?: InputMaybe<ChatbotAllowedDomainsInputType>;
  chatbotDomains?: InputMaybe<Array<InputMaybe<Domain>>>;
  chatbotDripCampaigns?: InputMaybe<ChatbotDripCampaignsInputType>;
  chatbotEmailResponseDelay?: InputMaybe<Scalars['Int']['input']>;
  chatbotHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotLeadTypes?: InputMaybe<ChatbotLeadTypesInputType>;
  chatbotTimezone?: InputMaybe<Scalars['String']['input']>;
  defaultChatbotName?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<AgentSettingsNotificationInputType>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSettingsNotificationEmailInputType = {
  assignLead?: InputMaybe<Scalars['Boolean']['input']>;
  brokerageLeadClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  ccEmail?: InputMaybe<Scalars['String']['input']>;
  leadAppointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  leadClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  leadLiveTransferred?: InputMaybe<Scalars['Boolean']['input']>;
  leadOverage?: InputMaybe<Scalars['Boolean']['input']>;
  needsFollowUpReminder?: InputMaybe<Scalars['Boolean']['input']>;
  newLead?: InputMaybe<Scalars['Boolean']['input']>;
  newLeadMessage?: InputMaybe<Scalars['Boolean']['input']>;
  newNeedsFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  receivedAssignedLead?: InputMaybe<Scalars['Boolean']['input']>;
  taskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  taskNew?: InputMaybe<Scalars['Boolean']['input']>;
  taskReminder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgentSettingsNotificationEmailType = {
  __typename?: 'AgentSettingsNotificationEmailType';
  assignLead?: Maybe<Scalars['Boolean']['output']>;
  brokerageLeadClaimed?: Maybe<Scalars['Boolean']['output']>;
  ccEmail?: Maybe<Scalars['String']['output']>;
  leadAppointmentScheduled?: Maybe<Scalars['Boolean']['output']>;
  leadClaimed?: Maybe<Scalars['Boolean']['output']>;
  leadLiveTransferred?: Maybe<Scalars['Boolean']['output']>;
  leadOverage?: Maybe<Scalars['Boolean']['output']>;
  needsFollowUpReminder?: Maybe<Scalars['Boolean']['output']>;
  newLead?: Maybe<Scalars['Boolean']['output']>;
  newLeadMessage?: Maybe<Scalars['Boolean']['output']>;
  newNeedsFollowUp?: Maybe<Scalars['Boolean']['output']>;
  receivedAssignedLead?: Maybe<Scalars['Boolean']['output']>;
  taskAssigned?: Maybe<Scalars['Boolean']['output']>;
  taskNew?: Maybe<Scalars['Boolean']['output']>;
  taskReminder?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentSettingsNotificationInputType = {
  email?: InputMaybe<AgentSettingsNotificationEmailInputType>;
  push?: InputMaybe<AgentSettingsNotificationPushInputType>;
  sms?: InputMaybe<AgentSettingsNotificationSmsInputType>;
};

export type AgentSettingsNotificationPushInputType = {
  needsFollowUpReminder?: InputMaybe<Scalars['Boolean']['input']>;
  newHolmesMessage?: InputMaybe<Scalars['Boolean']['input']>;
  newLead?: InputMaybe<Scalars['Boolean']['input']>;
  newLeadMessage?: InputMaybe<Scalars['Boolean']['input']>;
  newNeedsFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  receivedAssignedLead?: InputMaybe<Scalars['Boolean']['input']>;
  taskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  taskNew?: InputMaybe<Scalars['Boolean']['input']>;
  taskReminder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgentSettingsNotificationPushType = {
  __typename?: 'AgentSettingsNotificationPushType';
  needsFollowUpReminder?: Maybe<Scalars['Boolean']['output']>;
  newHolmesMessage?: Maybe<Scalars['Boolean']['output']>;
  newLead?: Maybe<Scalars['Boolean']['output']>;
  newLeadMessage?: Maybe<Scalars['Boolean']['output']>;
  newNeedsFollowUp?: Maybe<Scalars['Boolean']['output']>;
  receivedAssignedLead?: Maybe<Scalars['Boolean']['output']>;
  taskAssigned?: Maybe<Scalars['Boolean']['output']>;
  taskNew?: Maybe<Scalars['Boolean']['output']>;
  taskReminder?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentSettingsNotificationSmsInputType = {
  leadLiveTransferred?: InputMaybe<Scalars['Boolean']['input']>;
  newNeedsFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSettingsNotificationSmsType = {
  __typename?: 'AgentSettingsNotificationSMSType';
  leadLiveTransferred?: Maybe<Scalars['Boolean']['output']>;
  newNeedsFollowUp?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AgentSettingsNotificationType = {
  __typename?: 'AgentSettingsNotificationType';
  email?: Maybe<AgentSettingsNotificationEmailType>;
  push?: Maybe<AgentSettingsNotificationPushType>;
  sms?: Maybe<AgentSettingsNotificationSmsType>;
};

export type AgentSettingsType = {
  __typename?: 'AgentSettingsType';
  callingHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  /** @deprecated Use chatbot_domains instead */
  chatbotAllowedDomains?: Maybe<ChatbotAllowedDomainsType>;
  chatbotDomains?: Maybe<Array<Maybe<Domain>>>;
  chatbotDripCampaigns?: Maybe<ChatbotDripCampaignsType>;
  chatbotEmailResponseDelay?: Maybe<Scalars['Int']['output']>;
  chatbotHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  chatbotLeadTypes?: Maybe<ChatbotLeadTypesType>;
  chatbotTimezone?: Maybe<Scalars['String']['output']>;
  defaultChatbotName?: Maybe<Scalars['String']['output']>;
  dialerSettings?: Maybe<AgentDialerSettingsType>;
  notifications?: Maybe<AgentSettingsNotificationType>;
  schedulingLink?: Maybe<Scalars['String']['output']>;
};

export type AgentType = RealtorEntityType & {
  __typename?: 'AgentType';
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  a2pStatus?: Maybe<A2PStatusEnum>;
  accountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  activeLeadTypes?: Maybe<Array<Scalars['String']['output']>>;
  advancedBehaviors?: Maybe<Array<AdvancedBehaviorType>>;
  advancedCallRouting?: Maybe<Array<AdvancedCallRoutingType>>;
  agencyName?: Maybe<Scalars['String']['output']>;
  allowAgentLegendIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowAiAgentAdvancedTab?: Maybe<Scalars['Boolean']['output']>;
  allowAiTextAgents?: Maybe<Scalars['Boolean']['output']>;
  allowAiVoiceAgents?: Maybe<Scalars['Boolean']['output']>;
  allowBiReporting?: Maybe<Scalars['Boolean']['output']>;
  allowBonzoIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowCalendlyScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowCampaigns?: Maybe<Scalars['Boolean']['output']>;
  allowCustomScripts?: Maybe<Scalars['Boolean']['output']>;
  allowCustomSlots?: Maybe<Scalars['Boolean']['output']>;
  allowCustomStages?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTools?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTwilio?: Maybe<Scalars['Boolean']['output']>;
  allowExperimentalUi?: Maybe<Scalars['Boolean']['output']>;
  allowHardAppointmentScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowIntercom?: Maybe<Scalars['Boolean']['output']>;
  allowMailgun?: Maybe<Scalars['Boolean']['output']>;
  allowMessagingChannels?: Maybe<Scalars['Boolean']['output']>;
  allowMultiConversations?: Maybe<Scalars['Boolean']['output']>;
  allowMultiSmsChannels?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialer?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialerExperimentalSettings?: Maybe<Scalars['Boolean']['output']>;
  allowPortalBetaAccess?: Maybe<Scalars['Boolean']['output']>;
  allowRemarketing?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceChannels?: Maybe<Scalars['Boolean']['output']>;
  allowedEmailDomains?: Maybe<Array<Maybe<DomainType>>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  behaviors?: Maybe<Array<BehaviorType>>;
  billingInvoices: Array<BillingInvoiceType>;
  brokerage?: Maybe<OrganizationType>;
  brokerageId?: Maybe<Scalars['ID']['output']>;
  builtinSlots?: Maybe<Array<BrainSlotType>>;
  callDispositions?: Maybe<Array<Scalars['String']['output']>>;
  calls?: Maybe<VoiceCallPagination>;
  callsPerDay?: Maybe<Scalars['Int']['output']>;
  campaigns?: Maybe<Array<CampaignType>>;
  clearbit?: Maybe<ClearbitInfoType>;
  communicationChannels?: Maybe<Array<CommunicationChannelType>>;
  communicationProfiles?: Maybe<Array<CommunicationProfileType>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  customIntents?: Maybe<Array<Maybe<CustomIntentType>>>;
  customReportCsvs?: Maybe<Array<DirectPlatformCustomReportType>>;
  customScripts?: Maybe<Array<Maybe<CustomScriptType>>>;
  customSlots?: Maybe<Array<CustomizedSlotType>>;
  customStages?: Maybe<Array<CustomizedStageType>>;
  customTools?: Maybe<Array<CustomToolDefinitionType>>;
  customTwilioToken?: Maybe<TwilioAuthTokenType>;
  customerFilters?: Maybe<Array<Maybe<CustomerFilterType>>>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  email?: Maybe<Scalars['String']['output']>;
  enableTextAiCampaignEnrollment?: Maybe<Scalars['Boolean']['output']>;
  externalCampaignMatcher?: Maybe<Scalars['String']['output']>;
  fauxAgentsInheritHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  forceVoiceOrchestration?: Maybe<Scalars['Boolean']['output']>;
  generatedApiKey?: Maybe<Scalars['String']['output']>;
  hasEmailChannel?: Maybe<Scalars['Boolean']['output']>;
  hasHolmesApp?: Maybe<Scalars['Boolean']['output']>;
  hasSmsChannel?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integrations?: Maybe<AppIntegrationsType>;
  intercomJwt?: Maybe<Scalars['String']['output']>;
  isBroker?: Maybe<Scalars['Boolean']['output']>;
  isFauxAgent?: Maybe<Scalars['Boolean']['output']>;
  isHighScale?: Maybe<Scalars['Boolean']['output']>;
  isLender?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  isResellerAccount: Scalars['Boolean']['output'];
  isTeamLead?: Maybe<Scalars['Boolean']['output']>;
  isThirdPartyAccount?: Maybe<Scalars['Boolean']['output']>;
  isZendesk?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadEnrollmentRules?: Maybe<Array<Maybe<LeadEnrollmentRuleType>>>;
  leadQualification?: Maybe<LeadQualificationType>;
  leadRouting: LeadRoutingSettingsType;
  listCustomers?: Maybe<CustomerPaginationType>;
  liveTransferAnalytics?: Maybe<Array<VoiceCallType>>;
  liveTransferWhisperDelaySeconds?: Maybe<Scalars['Float']['output']>;
  localPresenceSettings: LocalPresenceSettingsType;
  mlsProviders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  multiConversationsCanBeActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  paragonConnectJwt?: Maybe<ParagonTokenType>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredAreaCode?: Maybe<Scalars['String']['output']>;
  priceAvg?: Maybe<Scalars['Int']['output']>;
  pubSubSubscriptions?: Maybe<Array<PubSubSubscriptionType>>;
  recentlyCreatedTasks?: Maybe<Array<Maybe<TaskType>>>;
  reseller?: Maybe<ResellerSubscriptionPlanType>;
  resellerId?: Maybe<Scalars['ID']['output']>;
  scheduledCallingStatus?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<AgentSettingsType>;
  smoochId?: Maybe<Scalars['String']['output']>;
  structurelyRoi?: Maybe<StructurelyRoiType>;
  subscription?: Maybe<SubscriptionType>;
  team?: Maybe<OrganizationType>;
  teamId?: Maybe<Scalars['ID']['output']>;
  textAiAgents?: Maybe<Array<TextAiAgentType>>;
  thirdPartyApiKeys?: Maybe<ThirdPartyApiKeysType>;
  thirdPartyOptions?: Maybe<ThirdPartyOptionsType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  totalCustomersCount?: Maybe<Scalars['Int']['output']>;
  totalUnreadCount?: Maybe<Scalars['Int']['output']>;
  twilioVoiceGrant?: Maybe<Scalars['String']['output']>;
  upcomingReminderTasks?: Maybe<Array<Maybe<TaskType>>>;
  userIntegrations: UserIntegrationsType;
  voiceAiAgents?: Maybe<Array<VoiceAiAgentType>>;
  voiceCallSummary?: Maybe<VoiceCallSummaryType>;
};


export type AgentTypeAdvancedBehaviorsArgs = {
  integrationName: Scalars['String']['input'];
};


export type AgentTypeBillingInvoicesArgs = {
  billingInterval?: InputMaybe<BillingInvoiceInterval>;
};


export type AgentTypeCallsArgs = {
  cursorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AgentTypeCustomFlowsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type AgentTypeCustomIntentsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type AgentTypeCustomScriptsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadTypes?: InputMaybe<Array<InputMaybe<ScriptLeadTypes>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<ScriptSourceTypes>>>;
};


export type AgentTypeCustomersArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<CursorInputType>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AgentTypeLeadEnrollmentRulesArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type AgentTypeLeadQualificationArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgentTypeListCustomersArgs = {
  currentCampaign?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  customSlots?: InputMaybe<Scalars['JSONString']['input']>;
  customStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AgentTypeLiveTransferAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type AgentTypePubSubSubscriptionsArgs = {
  integration: Scalars['String']['input'];
};


export type AgentTypeRecentlyCreatedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AgentTypeStructurelyRoiArgs = {
  appointmentSetToCloseRatio?: InputMaybe<Scalars['Float']['input']>;
  averageCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  averageSellingPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type AgentTypeTotalCustomersCountArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AgentTypeUpcomingReminderTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AiAgentCustomToolAttachmentType = {
  __typename?: 'AiAgentCustomToolAttachmentType';
  enabled: Scalars['Boolean']['output'];
  tool?: Maybe<CustomToolDefinitionType>;
  toolId: Scalars['ID']['output'];
};

export type AnalyticsAgentMessageType = AnalyticsConversationMessageType & {
  __typename?: 'AnalyticsAgentMessageType';
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsConversationMessageAdditionType = {
  __typename?: 'AnalyticsConversationMessageAdditionType';
  message?: Maybe<AnalyticsConversationMessageType>;
};

export type AnalyticsConversationMessageType = {
  id?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsConversationType = {
  __typename?: 'AnalyticsConversationType';
  id?: Maybe<Scalars['ID']['output']>;
  messages?: Maybe<Array<Maybe<AnalyticsConversationMessageType>>>;
};

export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  accountId: Scalars['String']['output'];
  groups: Array<AnalyticsInsightGroup>;
  stats: Array<AnalyticsDashboardStat>;
};

export enum AnalyticsDashboardDateRangePreset {
  AllTime = 'ALL_TIME',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS'
}

export type AnalyticsDashboardStat = {
  __typename?: 'AnalyticsDashboardStat';
  caption?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AnalyticsInsight = {
  __typename?: 'AnalyticsInsight';
  id: Scalars['String']['output'];
  items?: Maybe<Array<AnalyticsInsightOption>>;
  kind: Scalars['String']['output'];
  options?: Maybe<Array<AnalyticsInsightOption>>;
  responseCount?: Maybe<Scalars['Int']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  visitCount: Scalars['Int']['output'];
};

export type AnalyticsInsightGroup = {
  __typename?: 'AnalyticsInsightGroup';
  description?: Maybe<Scalars['String']['output']>;
  insights: Array<AnalyticsInsight>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsInsightOption = {
  __typename?: 'AnalyticsInsightOption';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsMessageType = AnalyticsConversationMessageType & {
  __typename?: 'AnalyticsMessageType';
  contexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  conversationMuted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intents?: Maybe<Array<Maybe<IntentType>>>;
  labelledText?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsResponseType = AnalyticsConversationMessageType & {
  __typename?: 'AnalyticsResponseType';
  id?: Maybe<Scalars['ID']['output']>;
  outgoingContexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export enum ApiModeEnum {
  Lite = 'LITE',
  Spartan = 'SPARTAN',
  Standard = 'STANDARD'
}

export type AppIntegrationsType = {
  __typename?: 'AppIntegrationsType';
  email?: Maybe<EmailIntegrationType>;
  facebook?: Maybe<FacebookIntegrationType>;
  mailgun?: Maybe<MailgunIntegrationType>;
  messageBird?: Maybe<MessageBirdIntegrationType>;
  twilio?: Maybe<TwilioIntegrationType>;
  webchat?: Maybe<WebchatIntegrationType>;
};

export type AppointmentSchedulingRuleInputType = {
  mode: Scalars['String']['input'];
  startTime: Scalars['Int']['input'];
};

export type AppointmentSchedulingRuleType = {
  __typename?: 'AppointmentSchedulingRuleType';
  endTime: Scalars['Int']['output'];
  mode: Scalars['String']['output'];
  startTime: Scalars['Int']['output'];
};

export type AppointmentSchedulingSettingsType = {
  __typename?: 'AppointmentSchedulingSettingsType';
  appointmentDuration: Scalars['Int']['output'];
  friday: Array<AppointmentSchedulingRuleType>;
  monday: Array<AppointmentSchedulingRuleType>;
  saturday: Array<AppointmentSchedulingRuleType>;
  sunday: Array<AppointmentSchedulingRuleType>;
  thursday: Array<AppointmentSchedulingRuleType>;
  tuesday: Array<AppointmentSchedulingRuleType>;
  wednesday: Array<AppointmentSchedulingRuleType>;
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  availability?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use availability string to check if customer is available */
  available?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use availability string to get date/time */
  date?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use availability string to get date/time */
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ArchiveAgentMutation = {
  __typename?: 'ArchiveAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveBrokerageMutation = {
  __typename?: 'ArchiveBrokerageMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveTeamMutation = {
  __typename?: 'ArchiveTeamMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignCampaignToCustomerMutation = {
  __typename?: 'AssignCampaignToCustomerMutation';
  customerCampaign?: Maybe<CustomerCampaignType>;
};

export type AssignCustomerToAgentMutation = {
  __typename?: 'AssignCustomerToAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignCustomerToTeamMutation = {
  __typename?: 'AssignCustomerToTeamMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignTaskToAgentMutation = {
  __typename?: 'AssignTaskToAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignTcrBrandMutation = {
  __typename?: 'AssignTcrBrandMutation';
  result?: Maybe<TcrBrandType>;
};

export type AssignTcrCampaignMutation = {
  __typename?: 'AssignTcrCampaignMutation';
  result?: Maybe<TcrCampaignType>;
};

export type AudioSegmentUploadMetadataInput = {
  captureEndedAt: Scalars['DateTime']['input'];
  captureGeneration: Scalars['ID']['input'];
  capturedAt: Scalars['DateTime']['input'];
  durationMs: Scalars['Int']['input'];
  interrupted: Scalars['Boolean']['input'];
  segmentId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type AuthenticationType = {
  __typename?: 'AuthenticationType';
  agentId?: Maybe<Scalars['ID']['output']>;
  authJwt?: Maybe<Scalars['String']['output']>;
  /** @deprecated JWT is replacing old url serialized tokens */
  authToken?: Maybe<Scalars['String']['output']>;
  brokerageId?: Maybe<Scalars['ID']['output']>;
  isBroker?: Maybe<Scalars['Boolean']['output']>;
  isTeamLead?: Maybe<Scalars['Boolean']['output']>;
  isZendesk?: Maybe<Scalars['Boolean']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type BathsType = {
  __typename?: 'BathsType';
  approx?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Half and full fields are no longer supported by chatbot */
  full?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Half and full fields are no longer supported by chatbot */
  half?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type BehaviorInputType = {
  behaviorType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  sideEffects: Array<BehavioralActionInputType>;
  suppressedBy?: InputMaybe<BehavioralTriggerInputType>;
  triggeredBy?: InputMaybe<BehavioralTriggerInputType>;
};

export type BehaviorType = {
  __typename?: 'BehaviorType';
  behaviorType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  sideEffects: Array<BehavioralActionType>;
  suppressedBy?: Maybe<BehavioralTriggerType>;
  triggeredBy?: Maybe<BehavioralTriggerType>;
};

export type BehavioralActionInputType = {
  action: Scalars['String']['input'];
  delay?: InputMaybe<BehavioralDelayInputType>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata: Scalars['GenericScalar']['input'];
};

export type BehavioralActionType = {
  __typename?: 'BehavioralActionType';
  action: Scalars['String']['output'];
  delay?: Maybe<BehavioralDelayType>;
  id: Scalars['ID']['output'];
  metadata: Scalars['GenericScalar']['output'];
};

export type BehavioralDelayInputType = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  minutes?: InputMaybe<Scalars['Int']['input']>;
  weeks?: InputMaybe<Scalars['Int']['input']>;
};

export type BehavioralDelayType = {
  __typename?: 'BehavioralDelayType';
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  hourOfDay?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  weeks?: Maybe<Scalars['Int']['output']>;
};

export type BehavioralTriggerInputType = {
  condition: Scalars['GenericScalar']['input'];
  conditionVersion: Scalars['String']['input'];
};

export type BehavioralTriggerType = {
  __typename?: 'BehavioralTriggerType';
  condition: Scalars['GenericScalar']['output'];
  conditionVersion: Scalars['String']['output'];
};

export enum BillingInvoiceCategory {
  LeadPurchase = 'LeadPurchase',
  LeadUsage = 'LeadUsage',
  PlatformFee = 'PlatformFee',
  SetupFee = 'SetupFee',
  Subscription = 'Subscription',
  TokenUsage = 'TokenUsage',
  Unknown = 'Unknown'
}

export enum BillingInvoiceInterval {
  All = 'ALL',
  LastBillingInterval = 'LAST_BILLING_INTERVAL',
  ThisBillingInterval = 'THIS_BILLING_INTERVAL'
}

export type BillingInvoiceLineItemInvoiceTypeOverrideInput = {
  invoiceType: BillingInvoiceCategory;
  lineItemId: Scalars['ID']['input'];
};

export type BillingInvoiceLineItemType = {
  __typename?: 'BillingInvoiceLineItemType';
  amountCents?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  invoiceType: BillingInvoiceCategory;
  invoiceTypeOverrides?: Maybe<BillingInvoiceCategory>;
  lineItemId?: Maybe<Scalars['String']['output']>;
  lineItemType?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['GenericScalar']['output']>;
  periodEnd?: Maybe<Scalars['Int']['output']>;
  periodStart?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitAmountCents?: Maybe<Scalars['Int']['output']>;
};

export type BillingInvoiceType = {
  __typename?: 'BillingInvoiceType';
  billingIntervalEnd?: Maybe<Scalars['Int']['output']>;
  billingIntervalStart?: Maybe<Scalars['Int']['output']>;
  invoiceAmountCents: Scalars['Int']['output'];
  invoiceDescription?: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['String']['output'];
  invoiceMetadata?: Maybe<Scalars['GenericScalar']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  lineItems: Array<BillingInvoiceLineItemType>;
  stripeInvoiceCreatedAt?: Maybe<Scalars['Int']['output']>;
  stripeInvoicePdfUrl?: Maybe<Scalars['String']['output']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']['output']>;
  vendorName: Scalars['String']['output'];
};

export type BillingUsageReport = {
  __typename?: 'BillingUsageReport';
  averageCallsPerLead: Scalars['Float']['output'];
  averageCallsPerLeadChange: Scalars['Float']['output'];
  averageCallsPerLeadDelta: Scalars['Float']['output'];
  averageEmailsPerLead: Scalars['Float']['output'];
  averageEmailsPerLeadChange: Scalars['Float']['output'];
  averageEmailsPerLeadDelta: Scalars['Float']['output'];
  averageSmsPerLead: Scalars['Float']['output'];
  averageSmsPerLeadChange: Scalars['Float']['output'];
  averageSmsPerLeadDelta: Scalars['Float']['output'];
  callTokens: Scalars['Int']['output'];
  callTokensChange: Scalars['Float']['output'];
  callTokensDelta: Scalars['Int']['output'];
  comparisonEnd: Scalars['DateTime']['output'];
  comparisonStart: Scalars['DateTime']['output'];
  currentEnd: Scalars['DateTime']['output'];
  currentStart: Scalars['DateTime']['output'];
  dashboardPeriod: DashboardPeriod;
  emailTokens: Scalars['Int']['output'];
  emailTokensChange: Scalars['Float']['output'];
  emailTokensDelta: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  hasSubscription?: Maybe<Scalars['Boolean']['output']>;
  leadOverage: Scalars['Int']['output'];
  leadOverageChange: Scalars['Float']['output'];
  leadOverageDelta: Scalars['Int']['output'];
  smsTokens: Scalars['Int']['output'];
  smsTokensChange: Scalars['Float']['output'];
  smsTokensDelta: Scalars['Int']['output'];
  tokenBased?: Maybe<Scalars['Boolean']['output']>;
  tokenOverage: Scalars['Int']['output'];
  tokenOverageChange: Scalars['Float']['output'];
  tokenOverageDelta: Scalars['Int']['output'];
  totalAiCallMinutes: Scalars['Int']['output'];
  totalAiCallMinutesChange: Scalars['Float']['output'];
  totalAiCallMinutesDelta: Scalars['Int']['output'];
  totalAppointmentsSet: Scalars['Int']['output'];
  totalAppointmentsSetChange: Scalars['Float']['output'];
  totalAppointmentsSetDelta: Scalars['Int']['output'];
  totalCallMinutes: Scalars['Int']['output'];
  totalCallMinutesChange: Scalars['Float']['output'];
  totalCallMinutesDelta: Scalars['Int']['output'];
  totalCallbacksScheduled: Scalars['Int']['output'];
  totalCallbacksScheduledChange: Scalars['Float']['output'];
  totalCallbacksScheduledDelta: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalCallsAnswered: Scalars['Int']['output'];
  totalCallsAnsweredChange: Scalars['Float']['output'];
  totalCallsAnsweredDelta: Scalars['Int']['output'];
  totalCallsChange: Scalars['Float']['output'];
  totalCallsDelta: Scalars['Int']['output'];
  totalCallsDidNotLeaveVm: Scalars['Int']['output'];
  totalCallsDidNotLeaveVmChange: Scalars['Float']['output'];
  totalCallsDidNotLeaveVmDelta: Scalars['Int']['output'];
  totalCallsLeftVm: Scalars['Int']['output'];
  totalCallsLeftVmChange: Scalars['Float']['output'];
  totalCallsLeftVmDelta: Scalars['Int']['output'];
  totalDoorVisits: Scalars['Int']['output'];
  totalDoorVisitsChange: Scalars['Float']['output'];
  totalDoorVisitsDelta: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalEmailsChange: Scalars['Float']['output'];
  totalEmailsDelta: Scalars['Int']['output'];
  totalLeads: Scalars['Int']['output'];
  totalLeadsChange: Scalars['Float']['output'];
  totalLeadsDelta: Scalars['Int']['output'];
  totalLiveTransfers: Scalars['Int']['output'];
  totalLiveTransfersChange: Scalars['Float']['output'];
  totalLiveTransfersDelta: Scalars['Int']['output'];
  totalLiveTransfersSuccessful: Scalars['Int']['output'];
  totalLiveTransfersSuccessfulChange: Scalars['Float']['output'];
  totalLiveTransfersSuccessfulDelta: Scalars['Int']['output'];
  totalSms: Scalars['Int']['output'];
  totalSmsChange: Scalars['Float']['output'];
  totalSmsDelta: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
  totalTokensChange: Scalars['Float']['output'];
  totalTokensDelta: Scalars['Int']['output'];
};

export type BlueprintPromptUnlessInputType = {
  condition?: InputMaybe<Scalars['JSONString']['input']>;
  promptedFor?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetedChannels?: InputMaybe<Array<InputMaybe<Channel>>>;
};

export type BlueprintPromptUnlessType = {
  __typename?: 'BlueprintPromptUnlessType';
  condition?: Maybe<Scalars['JSONString']['output']>;
  promptedFor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetedChannels?: Maybe<Array<Maybe<Channel>>>;
};

export type BlueprintSlotInputType = {
  answers?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
  askPriority?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  promptChannels?: InputMaybe<Array<InputMaybe<Channel>>>;
  promptUnless?: InputMaybe<BlueprintPromptUnlessInputType>;
  promptUnlessCondition?: InputMaybe<Scalars['JSONString']['input']>;
  prompts?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
  repromptPriority?: InputMaybe<RepromptPriority>;
};

export type BlueprintSlotType = {
  __typename?: 'BlueprintSlotType';
  answers?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  askPriority?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  promptChannels?: Maybe<Array<Maybe<Channel>>>;
  promptUnless?: Maybe<BlueprintPromptUnlessType>;
  /** @deprecated Use promptUnless.condition field */
  promptUnlessCondition?: Maybe<Scalars['JSONString']['output']>;
  prompts?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  repromptPriority: RepromptPriority;
};

export type BlueprintTemplateInputType = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BlueprintTemplateSetInputType = {
  condition?: InputMaybe<Scalars['JSONString']['input']>;
  targetedChannel?: InputMaybe<Channel>;
  templates?: InputMaybe<Array<InputMaybe<BlueprintTemplateInputType>>>;
};

export type BlueprintTemplateSetType = {
  __typename?: 'BlueprintTemplateSetType';
  condition?: Maybe<Scalars['JSONString']['output']>;
  filledFromIntent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  targetedChannel?: Maybe<Channel>;
  templates?: Maybe<Array<Maybe<BlueprintTemplateType>>>;
};

export type BlueprintTemplateType = {
  __typename?: 'BlueprintTemplateType';
  id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BonzoEmailPlatformType = {
  __typename?: 'BonzoEmailPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BonzoOptionsType = {
  __typename?: 'BonzoOptionsType';
  autoCreateFauxAgents?: Maybe<Scalars['Boolean']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  createContactsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  disableAssignmentMirroringAfterEnrollment?: Maybe<Scalars['Boolean']['output']>;
  searchForLeadsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  workflowSchemas?: Maybe<Array<Maybe<WorkflowSchemaType>>>;
};

export type BonzoTwilioPlatformType = {
  __typename?: 'BonzoTwilioPlatformType';
  accountSid: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
};

export type BooleanSlotValueType = SlotValueType & {
  __typename?: 'BooleanSlotValueType';
  bValue?: Maybe<Scalars['Boolean']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type BoomTownTagType = {
  __typename?: 'BoomTownTagType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BoomTownUserType = {
  __typename?: 'BoomTownUserType';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BoomtownOptionsType = {
  __typename?: 'BoomtownOptionsType';
  emailAddress?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  serviceArea?: Maybe<Scalars['String']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<BoomTownTagType>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<BoomTownUserType>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrainSlotType = {
  __typename?: 'BrainSlotType';
  base?: Maybe<Scalars['String']['output']>;
  defaultPrompt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domains?: Maybe<Array<Maybe<Domain>>>;
  isMergeField?: Maybe<Scalars['Boolean']['output']>;
  isQualifier?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  multipleValues?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oneTimeUse?: Maybe<Scalars['Boolean']['output']>;
  promptChannels?: Maybe<Channel>;
  promptUnless?: Maybe<BlueprintPromptUnlessType>;
  specialValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<SlotType>;
};

export type BrokerageCustomerUpdatesType = {
  __typename?: 'BrokerageCustomerUpdatesType';
  agentId?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<CustomerType>;
  teamId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CustomerEventEnum>;
};

export type BrokerageFeatureFlagsType = {
  __typename?: 'BrokerageFeatureFlagsType';
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  allowAgentLegendIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowAiAgentAdvancedTab?: Maybe<Scalars['Boolean']['output']>;
  allowAppointmentSchedulingToInviteLeads?: Maybe<Scalars['Boolean']['output']>;
  allowBiReporting?: Maybe<Scalars['Boolean']['output']>;
  allowBonzoIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowCampaigns?: Maybe<Scalars['Boolean']['output']>;
  allowCustomSlots?: Maybe<Scalars['Boolean']['output']>;
  allowCustomStages?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTools?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTwilio?: Maybe<Scalars['Boolean']['output']>;
  allowEmailChannel?: Maybe<Scalars['Boolean']['output']>;
  allowExperimentalUi?: Maybe<Scalars['Boolean']['output']>;
  allowFauxAgentNotifications?: Maybe<Scalars['Boolean']['output']>;
  allowMultiConversations?: Maybe<Scalars['Boolean']['output']>;
  allowPortalBetaAccess?: Maybe<Scalars['Boolean']['output']>;
  allowRemarketing?: Maybe<Scalars['Boolean']['output']>;
  allowTextAiAgents?: Maybe<Scalars['Boolean']['output']>;
  allowTextAnnotations?: Maybe<Scalars['Boolean']['output']>;
  allowTextMessaging?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceAiAgents?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceAnnotations?: Maybe<Scalars['Boolean']['output']>;
  asyncAmd?: Maybe<Scalars['Boolean']['output']>;
  asyncAmdDelaySeconds?: Maybe<Scalars['Int']['output']>;
  callsPerDay?: Maybe<Scalars['Int']['output']>;
  disableCallRecording?: Maybe<Scalars['Boolean']['output']>;
  disableEnrollAndOutreach?: Maybe<Scalars['Boolean']['output']>;
  enableCrmCustomSchema?: Maybe<Scalars['Boolean']['output']>;
  enableFastEnrollment?: Maybe<Scalars['Boolean']['output']>;
  enableFastResponses?: Maybe<Scalars['Boolean']['output']>;
  enableScheduledCalling?: Maybe<Scalars['Boolean']['output']>;
  enableTextAiCampaignEnrollment?: Maybe<Scalars['Boolean']['output']>;
  externalCampaignMatcher?: Maybe<Scalars['String']['output']>;
  fauxAgentsInheritHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  forceVoiceOrchestration?: Maybe<Scalars['Boolean']['output']>;
  ignoreUnknownCalls?: Maybe<Scalars['Boolean']['output']>;
  ignoreUnknownTexts?: Maybe<Scalars['Boolean']['output']>;
  isDemoAccount?: Maybe<Scalars['Boolean']['output']>;
  leadListEnrollmentRate?: Maybe<Scalars['Int']['output']>;
  liveTransferPreservesCallerId?: Maybe<Scalars['Boolean']['output']>;
  liveTransferWhisperDelaySeconds?: Maybe<Scalars['Float']['output']>;
  machineDetectionSilenceTimeout?: Maybe<Scalars['Int']['output']>;
  machineDetectionTimeout?: Maybe<Scalars['Int']['output']>;
  scaleTier?: Maybe<Scalars['String']['output']>;
  useVoiceAiForScheduledCallbacks?: Maybe<Scalars['Boolean']['output']>;
};

export type BrokerageInputType = {
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<BrokerageSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};

export type BrokerageMutation = {
  __typename?: 'BrokerageMutation';
  brokerage?: Maybe<BrokerageType>;
};

export type BrokerageSettingsInputType = {
  callingHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotAllowedDomains?: InputMaybe<ChatbotAllowedDomainsInputType>;
  chatbotDomains?: InputMaybe<Array<InputMaybe<Domain>>>;
  chatbotDripCampaigns?: InputMaybe<ChatbotDripCampaignsInputType>;
  chatbotEmailResponseDelay?: InputMaybe<Scalars['Int']['input']>;
  chatbotHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotLeadTypes?: InputMaybe<ChatbotLeadTypesInputType>;
  chatbotTimezone?: InputMaybe<Scalars['String']['input']>;
  defaultChatbotName?: InputMaybe<Scalars['String']['input']>;
  firstToClaimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  overrideHoursOfOperation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
};

export type BrokerageSettingsType = {
  __typename?: 'BrokerageSettingsType';
  callingHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  /** @deprecated Use chatbot_domains instead */
  chatbotAllowedDomains?: Maybe<ChatbotAllowedDomainsType>;
  chatbotDomains?: Maybe<Array<Maybe<Domain>>>;
  chatbotDripCampaigns?: Maybe<ChatbotDripCampaignsType>;
  chatbotEmailResponseDelay?: Maybe<Scalars['Int']['output']>;
  chatbotHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  chatbotLeadTypes?: Maybe<ChatbotLeadTypesType>;
  chatbotTimezone?: Maybe<Scalars['String']['output']>;
  defaultChatbotName?: Maybe<Scalars['String']['output']>;
  firstToClaimEnabled?: Maybe<Scalars['Boolean']['output']>;
  overrideHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  schedulingLink?: Maybe<Scalars['String']['output']>;
};

export type BrokerageType = RealtorEntityType & {
  __typename?: 'BrokerageType';
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  a2pStatus?: Maybe<A2PStatusEnum>;
  accountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  activeLeadTypes?: Maybe<Array<Scalars['String']['output']>>;
  advancedBehaviors?: Maybe<Array<AdvancedBehaviorType>>;
  advancedCallRouting?: Maybe<Array<AdvancedCallRoutingType>>;
  agents?: Maybe<Array<Maybe<AgentType>>>;
  allowAgentLegendIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowAiAgentAdvancedTab?: Maybe<Scalars['Boolean']['output']>;
  allowAiTextAgents?: Maybe<Scalars['Boolean']['output']>;
  allowAiVoiceAgents?: Maybe<Scalars['Boolean']['output']>;
  allowBiReporting?: Maybe<Scalars['Boolean']['output']>;
  allowBonzoIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowCalendlyScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowCampaigns?: Maybe<Scalars['Boolean']['output']>;
  allowCustomScripts?: Maybe<Scalars['Boolean']['output']>;
  allowCustomSlots?: Maybe<Scalars['Boolean']['output']>;
  allowCustomStages?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTools?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTwilio?: Maybe<Scalars['Boolean']['output']>;
  allowExperimentalUi?: Maybe<Scalars['Boolean']['output']>;
  allowHardAppointmentScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowIntercom?: Maybe<Scalars['Boolean']['output']>;
  allowMailgun?: Maybe<Scalars['Boolean']['output']>;
  allowMembersTesting?: Maybe<Scalars['Boolean']['output']>;
  allowMessagingChannels?: Maybe<Scalars['Boolean']['output']>;
  allowMultiConversations?: Maybe<Scalars['Boolean']['output']>;
  allowMultiSmsChannels?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialer?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialerExperimentalSettings?: Maybe<Scalars['Boolean']['output']>;
  allowPortalBetaAccess?: Maybe<Scalars['Boolean']['output']>;
  allowRemarketing?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceChannels?: Maybe<Scalars['Boolean']['output']>;
  allowedEmailDomains?: Maybe<Array<Maybe<DomainType>>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  behaviors?: Maybe<Array<BehaviorType>>;
  billingInvoices: Array<BillingInvoiceType>;
  /** @deprecated Use the joined list `agents` instead */
  brokers?: Maybe<Array<Maybe<AgentType>>>;
  builtinSlots?: Maybe<Array<BrainSlotType>>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessOps?: Maybe<OperationalMetadataType>;
  callDispositions?: Maybe<Array<Scalars['String']['output']>>;
  callsPerDay?: Maybe<Scalars['Int']['output']>;
  campaigns?: Maybe<Array<CampaignType>>;
  communicationChannels?: Maybe<Array<CommunicationChannelType>>;
  communicationProfiles?: Maybe<Array<CommunicationProfileType>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  customIntents?: Maybe<Array<Maybe<CustomIntentType>>>;
  customReportCsvs?: Maybe<Array<DirectPlatformCustomReportType>>;
  customScripts?: Maybe<Array<Maybe<CustomScriptType>>>;
  customSlots?: Maybe<Array<CustomizedSlotType>>;
  customStages?: Maybe<Array<CustomizedStageType>>;
  customTools?: Maybe<Array<CustomToolDefinitionType>>;
  customTwilioToken?: Maybe<TwilioAuthTokenType>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  email?: Maybe<Scalars['String']['output']>;
  enableTextAiCampaignEnrollment?: Maybe<Scalars['Boolean']['output']>;
  externalCampaignMatcher?: Maybe<Scalars['String']['output']>;
  fauxAgentsInheritHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  featureFlags?: Maybe<BrokerageFeatureFlagsType>;
  forceVoiceOrchestration?: Maybe<Scalars['Boolean']['output']>;
  generatedApiKey?: Maybe<Scalars['String']['output']>;
  hasEmailChannel?: Maybe<Scalars['Boolean']['output']>;
  hasSmsChannel?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integrations?: Maybe<AppIntegrationsType>;
  isHighScale?: Maybe<Scalars['Boolean']['output']>;
  isResellerAccount: Scalars['Boolean']['output'];
  isZendesk?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadEnrollmentRules?: Maybe<Array<Maybe<LeadEnrollmentRuleType>>>;
  leadQualification?: Maybe<LeadQualificationType>;
  leadRouting: LeadRoutingSettingsType;
  listCustomers?: Maybe<CustomerPaginationType>;
  liveTransferAnalytics?: Maybe<Array<VoiceCallType>>;
  liveTransferWhisperDelaySeconds?: Maybe<Scalars['Float']['output']>;
  localPresenceSettings: LocalPresenceSettingsType;
  /** @deprecated Use the joined list `agents` instead */
  members?: Maybe<Array<Maybe<AgentType>>>;
  multiConversationsCanBeActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  paragonConnectJwt?: Maybe<ParagonTokenType>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredAreaCode?: Maybe<Scalars['String']['output']>;
  priceAvg?: Maybe<Scalars['Int']['output']>;
  pubSubSubscriptions?: Maybe<Array<PubSubSubscriptionType>>;
  recentlyCreatedTasks?: Maybe<Array<Maybe<TaskType>>>;
  reseller?: Maybe<ResellerSubscriptionPlanType>;
  scheduledCallingStatus?: Maybe<Scalars['String']['output']>;
  schedulingSettings?: Maybe<SchedulingSettingsType>;
  settings?: Maybe<BrokerageSettingsType>;
  smoochId?: Maybe<Scalars['String']['output']>;
  structurelyRoi?: Maybe<StructurelyRoiType>;
  subscription?: Maybe<SubscriptionType>;
  teams?: Maybe<Array<Maybe<TeamType>>>;
  textAiAgents?: Maybe<Array<TextAiAgentType>>;
  thirdPartyApiKeys?: Maybe<ThirdPartyApiKeysType>;
  thirdPartyOptions?: Maybe<ThirdPartyOptionsType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  totalCustomersCount?: Maybe<Scalars['Int']['output']>;
  totalUnreadCount?: Maybe<Scalars['Int']['output']>;
  upcomingReminderTasks?: Maybe<Array<Maybe<TaskType>>>;
  userIntegrations: UserIntegrationsType;
  voiceAiAgents?: Maybe<Array<VoiceAiAgentType>>;
  voiceCallSummary?: Maybe<VoiceCallSummaryType>;
};


export type BrokerageTypeAdvancedBehaviorsArgs = {
  integrationName: Scalars['String']['input'];
};


export type BrokerageTypeBillingInvoicesArgs = {
  billingInterval?: InputMaybe<BillingInvoiceInterval>;
};


export type BrokerageTypeCustomFlowsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type BrokerageTypeCustomIntentsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type BrokerageTypeCustomScriptsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadTypes?: InputMaybe<Array<InputMaybe<ScriptLeadTypes>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<ScriptSourceTypes>>>;
};


export type BrokerageTypeCustomersArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<CursorInputType>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BrokerageTypeLeadEnrollmentRulesArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type BrokerageTypeLeadQualificationArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrokerageTypeListCustomersArgs = {
  currentCampaign?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  customSlots?: InputMaybe<Scalars['JSONString']['input']>;
  customStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BrokerageTypeLiveTransferAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type BrokerageTypePubSubSubscriptionsArgs = {
  integration: Scalars['String']['input'];
};


export type BrokerageTypeRecentlyCreatedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BrokerageTypeStructurelyRoiArgs = {
  appointmentSetToCloseRatio?: InputMaybe<Scalars['Float']['input']>;
  averageCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  averageSellingPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type BrokerageTypeTotalCustomersCountArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BrokerageTypeUpcomingReminderTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BufferedGeographicBounds = {
  __typename?: 'BufferedGeographicBounds';
  crossesAntimeridian: Scalars['Boolean']['output'];
  east: Scalars['Float']['output'];
  north: Scalars['Float']['output'];
  south: Scalars['Float']['output'];
  west: Scalars['Float']['output'];
};

export type BulkActionInput = {
  archive?: InputMaybe<BulkArchiveInput>;
  assignment?: InputMaybe<BulkAssignmentInput>;
  enrollment?: InputMaybe<BulkEnrollmentInput>;
  message?: InputMaybe<BulkMessageInput>;
  mute?: InputMaybe<BulkMuteInput>;
  powerDialing?: InputMaybe<BulkPowerDialingInput>;
  unassignment?: InputMaybe<BulkUnassignmentInput>;
};

export type BulkAddTagsInputType = {
  tags: Array<InputMaybe<Scalars['String']['input']>>;
};

export type BulkAddTaskInputType = {
  task: InputTaskType;
};

export type BulkArchiveInput = {
  archived: Scalars['Boolean']['input'];
};

export type BulkAssignAgentInputType = {
  agentId: Scalars['ID']['input'];
};

export type BulkAssignTeamInputType = {
  teamId: Scalars['ID']['input'];
};

export type BulkAssignmentInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkCanvassingSessionTranscriptionFilter = {
  calendar?: InputMaybe<CanvassingSessionCalendarFilter>;
  canvasserId?: InputMaybe<Scalars['String']['input']>;
  captureStatus?: InputMaybe<CanvassingSessionCaptureStatusFilter>;
  processingStatus?: InputMaybe<CanvassingSessionProcessingStatus>;
  sort?: InputMaybe<CanvassingSessionListSort>;
};

export type BulkCanvassingSessionTranscriptionStartResult = {
  __typename?: 'BulkCanvassingSessionTranscriptionStartResult';
  status: BulkCanvassingSessionTranscriptionStartStatus;
};

export enum BulkCanvassingSessionTranscriptionStartStatus {
  NoMatches = 'NO_MATCHES',
  Started = 'STARTED'
}

export type BulkEnrollmentInput = {
  campaignId: Scalars['ID']['input'];
};

export enum BulkMessageChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type BulkMessageInput = {
  channel: BulkMessageChannel;
  prompt: Scalars['String']['input'];
};

export enum BulkMuteChannel {
  Both = 'BOTH',
  Text = 'TEXT',
  Voice = 'VOICE'
}

export type BulkMuteInput = {
  channel: BulkMuteChannel;
  muted: Scalars['Boolean']['input'];
};

export type BulkPowerDialingInput = {
  voiceAiAgentId: Scalars['ID']['input'];
};

export type BulkSendMessageInputType = {
  agentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type BulkUnassignmentInput = {
  target: BulkUnassignmentTarget;
};

export enum BulkUnassignmentTarget {
  Agent = 'AGENT',
  All = 'ALL',
  Team = 'TEAM'
}

export type BulkUpdateArchivedInputType = {
  archived: Scalars['Boolean']['input'];
};

export type BulkUpdateMutedInputType = {
  chatbotMuted: Scalars['Boolean']['input'];
};

export type CaasSettings = {
  __typename?: 'CaasSettings';
  clientDomain?: Maybe<Scalars['String']['output']>;
  clientKey?: Maybe<Scalars['String']['output']>;
  enforceA2pCompliance?: Maybe<Scalars['Boolean']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCustomTwilio: Scalars['Boolean']['output'];
  secureAccountProvisioning?: Maybe<Scalars['Boolean']['output']>;
  selfManagedTelco?: Maybe<Scalars['Boolean']['output']>;
  sendA2pOptOut?: Maybe<Scalars['Boolean']['output']>;
  trustedDomains?: Maybe<Array<Scalars['String']['output']>>;
  twilioAccountSid?: Maybe<Scalars['String']['output']>;
  twilioApiKey?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventErrorType = {
  __typename?: 'CalendarEventErrorType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventType = {
  __typename?: 'CalendarEventType';
  endAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAllDay: Scalars['Boolean']['output'];
  metadata: Scalars['GenericScalar']['output'];
  provider: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventsPayloadType = {
  __typename?: 'CalendarEventsPayloadType';
  errors: Array<CalendarEventErrorType>;
  events: Array<CalendarEventType>;
};

export type CallDispositionType = {
  __typename?: 'CallDispositionType';
  actor: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  isFailure: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CallInsightsIntentType = {
  __typename?: 'CallInsightsIntentType';
  confidence?: Maybe<Scalars['Float']['output']>;
  intentName?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<CallInsightsSlotType>>;
};

export type CallInsightsSlotType = {
  __typename?: 'CallInsightsSlotType';
  slotName: Scalars['String']['output'];
  slotValues?: Maybe<Array<Scalars['GenericScalar']['output']>>;
};

export type CallInsightsType = {
  __typename?: 'CallInsightsType';
  callDisposition?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  intents?: Maybe<Array<CallInsightsIntentType>>;
};

export type CallSuccessOutcomesInputType = {
  canLiveTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  continueConversationAfterScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleCalendarAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  sendSmsDescription?: InputMaybe<Scalars['String']['input']>;
  sendSmsStartMessage?: InputMaybe<Scalars['String']['input']>;
  sendSmsTemplate?: InputMaybe<Scalars['String']['input']>;
  useCallAiForCallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CallSuccessOutcomesType = {
  __typename?: 'CallSuccessOutcomesType';
  canLiveTransfer?: Maybe<Scalars['Boolean']['output']>;
  continueConversationAfterScheduling?: Maybe<Scalars['Boolean']['output']>;
  scheduleCalendarAppointment?: Maybe<Scalars['Boolean']['output']>;
  sendSmsDescription?: Maybe<Scalars['String']['output']>;
  sendSmsStartMessage?: Maybe<Scalars['String']['output']>;
  sendSmsTemplate?: Maybe<Scalars['String']['output']>;
  useCallAiForCallback?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignAgentInputType = {
  callCadence?: InputMaybe<BehaviorInputType>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  textAiAgentId?: InputMaybe<Scalars['ID']['input']>;
  voiceAiAgentId?: InputMaybe<Scalars['ID']['input']>;
  voiceAiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignInputType = {
  callCadence?: InputMaybe<BehaviorInputType>;
  description?: InputMaybe<Scalars['String']['input']>;
  disqualificationCriteria?: InputMaybe<Scalars['GenericScalar']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  inboundCallRouting?: InputMaybe<InboundCallRoutingEnum>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  qualificationCriteria?: InputMaybe<Scalars['GenericScalar']['input']>;
  selectionCriteria?: InputMaybe<Scalars['GenericScalar']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  textAiAgent?: InputMaybe<TextAiAgentInputType>;
  voiceAiAgent?: InputMaybe<VoiceAiAgentInputType>;
  voiceAiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CampaignStageEnum {
  Completed = 'COMPLETED',
  Disqualified = 'DISQUALIFIED',
  Engaged = 'ENGAGED',
  New = 'NEW',
  Qualified = 'QUALIFIED'
}

export type CampaignType = {
  __typename?: 'CampaignType';
  callCadence?: Maybe<BehaviorType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disqualificationCriteria?: Maybe<Scalars['GenericScalar']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inboundCallRouting: InboundCallRoutingEnum;
  isDefault: Scalars['Boolean']['output'];
  isDisabledByAdmin: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  qualificationCriteria?: Maybe<Scalars['GenericScalar']['output']>;
  selectionCriteria?: Maybe<Scalars['GenericScalar']['output']>;
  smsEnabled: Scalars['Boolean']['output'];
  textAiAgent?: Maybe<TextAiAgentType>;
  updatedAt: Scalars['DateTime']['output'];
  voiceAiAgent?: Maybe<VoiceAiAgentType>;
  voiceAiEnabled: Scalars['Boolean']['output'];
};

export type CampaignUsageReport = {
  __typename?: 'CampaignUsageReport';
  averageCallsPerLead: Scalars['Float']['output'];
  averageCallsPerLeadChange: Scalars['Float']['output'];
  averageCallsPerLeadDelta: Scalars['Float']['output'];
  averageEmailsPerLead: Scalars['Float']['output'];
  averageEmailsPerLeadChange: Scalars['Float']['output'];
  averageEmailsPerLeadDelta: Scalars['Float']['output'];
  averageSmsPerLead: Scalars['Float']['output'];
  averageSmsPerLeadChange: Scalars['Float']['output'];
  averageSmsPerLeadDelta: Scalars['Float']['output'];
  callTokens: Scalars['Int']['output'];
  callTokensChange: Scalars['Float']['output'];
  callTokensDelta: Scalars['Int']['output'];
  comparisonEnd: Scalars['DateTime']['output'];
  comparisonStart: Scalars['DateTime']['output'];
  currentEnd: Scalars['DateTime']['output'];
  currentStart: Scalars['DateTime']['output'];
  dashboardPeriod: DashboardPeriod;
  emailTokens: Scalars['Int']['output'];
  emailTokensChange: Scalars['Float']['output'];
  emailTokensDelta: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  hasSubscription?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  leadOverage: Scalars['Int']['output'];
  leadOverageChange: Scalars['Float']['output'];
  leadOverageDelta: Scalars['Int']['output'];
  smsTokens: Scalars['Int']['output'];
  smsTokensChange: Scalars['Float']['output'];
  smsTokensDelta: Scalars['Int']['output'];
  tokenBased?: Maybe<Scalars['Boolean']['output']>;
  tokenOverage: Scalars['Int']['output'];
  tokenOverageChange: Scalars['Float']['output'];
  tokenOverageDelta: Scalars['Int']['output'];
  totalAiCallMinutes: Scalars['Int']['output'];
  totalAiCallMinutesChange: Scalars['Float']['output'];
  totalAiCallMinutesDelta: Scalars['Int']['output'];
  totalAppointmentsSet: Scalars['Int']['output'];
  totalAppointmentsSetChange: Scalars['Float']['output'];
  totalAppointmentsSetDelta: Scalars['Int']['output'];
  totalCallMinutes: Scalars['Int']['output'];
  totalCallMinutesChange: Scalars['Float']['output'];
  totalCallMinutesDelta: Scalars['Int']['output'];
  totalCallbacksScheduled: Scalars['Int']['output'];
  totalCallbacksScheduledChange: Scalars['Float']['output'];
  totalCallbacksScheduledDelta: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalCallsAnswered: Scalars['Int']['output'];
  totalCallsAnsweredChange: Scalars['Float']['output'];
  totalCallsAnsweredDelta: Scalars['Int']['output'];
  totalCallsChange: Scalars['Float']['output'];
  totalCallsDelta: Scalars['Int']['output'];
  totalCallsDidNotLeaveVm: Scalars['Int']['output'];
  totalCallsDidNotLeaveVmChange: Scalars['Float']['output'];
  totalCallsDidNotLeaveVmDelta: Scalars['Int']['output'];
  totalCallsLeftVm: Scalars['Int']['output'];
  totalCallsLeftVmChange: Scalars['Float']['output'];
  totalCallsLeftVmDelta: Scalars['Int']['output'];
  totalDoorVisits: Scalars['Int']['output'];
  totalDoorVisitsChange: Scalars['Float']['output'];
  totalDoorVisitsDelta: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalEmailsChange: Scalars['Float']['output'];
  totalEmailsDelta: Scalars['Int']['output'];
  totalLeads: Scalars['Int']['output'];
  totalLeadsChange: Scalars['Float']['output'];
  totalLeadsDelta: Scalars['Int']['output'];
  totalLiveTransfers: Scalars['Int']['output'];
  totalLiveTransfersChange: Scalars['Float']['output'];
  totalLiveTransfersDelta: Scalars['Int']['output'];
  totalLiveTransfersSuccessful: Scalars['Int']['output'];
  totalLiveTransfersSuccessfulChange: Scalars['Float']['output'];
  totalLiveTransfersSuccessfulDelta: Scalars['Int']['output'];
  totalSms: Scalars['Int']['output'];
  totalSmsChange: Scalars['Float']['output'];
  totalSmsDelta: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
  totalTokensChange: Scalars['Float']['output'];
  totalTokensDelta: Scalars['Int']['output'];
};

export type CandidateSentiment = {
  __typename?: 'CandidateSentiment';
  candidateName: Scalars['String']['output'];
  sentiment: Scalars['String']['output'];
};

export type CanvasserOnboardingTokenType = {
  __typename?: 'CanvasserOnboardingTokenType';
  expiresAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type CanvassingSessionActivity = {
  __typename?: 'CanvassingSessionActivity';
  kind: CanvassingSessionActivityKind;
  occurredAt: Scalars['DateTime']['output'];
  stage?: Maybe<CanvassingSessionPipelineStage>;
  status?: Maybe<CanvassingSessionPipelineJobStatus>;
};

export enum CanvassingSessionActivityKind {
  FirstAudioConfirmed = 'FIRST_AUDIO_CONFIRMED',
  FirstGpsReceived = 'FIRST_GPS_RECEIVED',
  FirstPass1Submitted = 'FIRST_PASS1_SUBMITTED',
  FirstPass2Submitted = 'FIRST_PASS2_SUBMITTED',
  FirstVisitCreated = 'FIRST_VISIT_CREATED',
  LatestAudioConfirmed = 'LATEST_AUDIO_CONFIRMED',
  LatestGpsReceived = 'LATEST_GPS_RECEIVED',
  LatestPass1Submitted = 'LATEST_PASS1_SUBMITTED',
  LatestPass2Submitted = 'LATEST_PASS2_SUBMITTED',
  LatestVisitCreated = 'LATEST_VISIT_CREATED',
  PipelineStageFirstCreated = 'PIPELINE_STAGE_FIRST_CREATED',
  PipelineStageLatestUpdated = 'PIPELINE_STAGE_LATEST_UPDATED',
  SessionEnded = 'SESSION_ENDED',
  SessionStarted = 'SESSION_STARTED'
}

export type CanvassingSessionCalendarFilter = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  preset: CanvassingSessionCalendarPreset;
  throughDate?: InputMaybe<Scalars['String']['input']>;
};

export enum CanvassingSessionCalendarPreset {
  All = 'ALL',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export enum CanvassingSessionCaptureStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Unknown = 'UNKNOWN'
}

export enum CanvassingSessionCaptureStatusFilter {
  Active = 'ACTIVE',
  Ended = 'ENDED'
}

export type CanvassingSessionDetail = {
  __typename?: 'CanvassingSessionDetail';
  activity: Array<CanvassingSessionActivity>;
  appVersion?: Maybe<Scalars['String']['output']>;
  canvasserId: Scalars['String']['output'];
  captureStatus: CanvassingSessionCaptureStatus;
  doorVisitCount: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  expectedAudioSegments?: Maybe<Scalars['Int']['output']>;
  hasMergedRecording?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metrics: CanvassingSessionMetrics;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<SessionTelemetryPlatform>;
  pollingRecommended: Scalars['Boolean']['output'];
  processingErrorAvailable: Scalars['Boolean']['output'];
  processingStatus: CanvassingSessionProcessingStatus;
  receivedAudioSegments: Scalars['Int']['output'];
  receivedGpsPoints: Scalars['Int']['output'];
  reportedGpsPoints?: Maybe<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type CanvassingSessionDoorVisit = {
  __typename?: 'CanvassingSessionDoorVisit';
  dwellEndedAt: Scalars['DateTime']['output'];
  dwellStartedAt: Scalars['DateTime']['output'];
  hasClip: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isCoreAccepted: Scalars['Boolean']['output'];
  isCoreRecordingConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isPartial: Scalars['Boolean']['output'];
  isReprocessed: Scalars['Boolean']['output'];
  isVoterMatched: Scalars['Boolean']['output'];
  predictedAddress?: Maybe<Scalars['String']['output']>;
  sourceDoorVisitId?: Maybe<Scalars['Int']['output']>;
  status: CanvassingSessionDoorVisitStatus;
  trackPass1At?: Maybe<Scalars['DateTime']['output']>;
  trackPass2At?: Maybe<Scalars['DateTime']['output']>;
  voterName?: Maybe<Scalars['String']['output']>;
};

export type CanvassingSessionDoorVisitListResult = {
  __typename?: 'CanvassingSessionDoorVisitListResult';
  items: Array<CanvassingSessionDoorVisit>;
  total: Scalars['Int']['output'];
};

export type CanvassingSessionDoorVisitMapPoint = {
  __typename?: 'CanvassingSessionDoorVisitMapPoint';
  doorVisitId: Scalars['Int']['output'];
  dwellEndedAt: Scalars['DateTime']['output'];
  dwellStartedAt: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  matchedVoterRecordId?: Maybe<Scalars['ID']['output']>;
  predictedAddress?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  voterName?: Maybe<Scalars['String']['output']>;
};

export type CanvassingSessionDoorVisitMapResult = {
  __typename?: 'CanvassingSessionDoorVisitMapResult';
  items: Array<CanvassingSessionDoorVisitMapPoint>;
  pageInfo: MapCursorPageInfo;
};

export enum CanvassingSessionDoorVisitStatus {
  NoSpeech = 'NO_SPEECH',
  Pending = 'PENDING',
  SubmittedP1 = 'SUBMITTED_P1',
  SubmittedP2 = 'SUBMITTED_P2',
  SubmittingP1 = 'SUBMITTING_P1',
  SubmittingP2 = 'SUBMITTING_P2',
  Unknown = 'UNKNOWN'
}

export type CanvassingSessionDoorVisitStatusCount = {
  __typename?: 'CanvassingSessionDoorVisitStatusCount';
  count: Scalars['Int']['output'];
  status: CanvassingSessionDoorVisitStatus;
};

export type CanvassingSessionExport = {
  __typename?: 'CanvassingSessionExport';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failureSummary?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CanvassingSessionExportStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CanvassingSessionExportDownload = {
  __typename?: 'CanvassingSessionExportDownload';
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CanvassingSessionExportFilter = {
  calendar?: InputMaybe<CanvassingSessionCalendarFilter>;
  canvasserId?: InputMaybe<Scalars['String']['input']>;
  captureStatus?: InputMaybe<CanvassingSessionCaptureStatusFilter>;
  processingStatus?: InputMaybe<CanvassingSessionProcessingStatus>;
  sort?: InputMaybe<CanvassingSessionListSort>;
};

export enum CanvassingSessionExportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NoMatches = 'NO_MATCHES',
  Running = 'RUNNING'
}

export type CanvassingSessionFilterOptions = {
  __typename?: 'CanvassingSessionFilterOptions';
  canvasserIds: Array<Scalars['String']['output']>;
};

export enum CanvassingSessionGpsTraceMode {
  Full = 'FULL',
  Sampled = 'SAMPLED'
}

export type CanvassingSessionGpsTracePageInfo = {
  __typename?: 'CanvassingSessionGpsTracePageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  nextOffset?: Maybe<Scalars['Int']['output']>;
  snapshot: Scalars['String']['output'];
};

export type CanvassingSessionGpsTracePoint = {
  __typename?: 'CanvassingSessionGpsTracePoint';
  capturedAt: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CanvassingSessionGpsTraceResult = {
  __typename?: 'CanvassingSessionGpsTraceResult';
  bounds?: Maybe<GeographicBounds>;
  pageInfo: CanvassingSessionGpsTracePageInfo;
  points: Array<CanvassingSessionGpsTracePoint>;
  sampled: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CanvassingSessionListItem = {
  __typename?: 'CanvassingSessionListItem';
  canvasserId: Scalars['String']['output'];
  captureStatus: CanvassingSessionCaptureStatus;
  doorVisitCount: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  expectedAudioSegments?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processingStatus: CanvassingSessionProcessingStatus;
  receivedAudioSegments: Scalars['Int']['output'];
  receivedGpsPoints: Scalars['Int']['output'];
  reportedGpsPoints?: Maybe<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type CanvassingSessionListResult = {
  __typename?: 'CanvassingSessionListResult';
  calendarTimeZone: Scalars['String']['output'];
  items: Array<CanvassingSessionListItem>;
  total: Scalars['Int']['output'];
};

export enum CanvassingSessionListSort {
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export type CanvassingSessionMetrics = {
  __typename?: 'CanvassingSessionMetrics';
  captureDurationSeconds: Scalars['Int']['output'];
  clipBearingDoorVisitCount: Scalars['Int']['output'];
  confirmedAudioDurationMs: Scalars['Int']['output'];
  coreAcceptedDoorVisitCount: Scalars['Int']['output'];
  doorVisitCount: Scalars['Int']['output'];
  doorVisitStatusCounts: Array<CanvassingSessionDoorVisitStatusCount>;
  expectedAudioSegments?: Maybe<Scalars['Int']['output']>;
  partialDoorVisitCount: Scalars['Int']['output'];
  pipelineStatusCounts: Array<CanvassingSessionPipelineJobCount>;
  receivedAudioSegments: Scalars['Int']['output'];
  receivedGpsPoints: Scalars['Int']['output'];
  reportedGpsPoints?: Maybe<Scalars['Int']['output']>;
  voterMatchedDoorVisitCount: Scalars['Int']['output'];
};

export type CanvassingSessionPipelineJob = {
  __typename?: 'CanvassingSessionPipelineJob';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  doorVisitId?: Maybe<Scalars['Int']['output']>;
  errorSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  leaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  stage: CanvassingSessionPipelineStage;
  status: CanvassingSessionPipelineJobStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CanvassingSessionPipelineJobCount = {
  __typename?: 'CanvassingSessionPipelineJobCount';
  count: Scalars['Int']['output'];
  stage: CanvassingSessionPipelineStage;
  status: CanvassingSessionPipelineJobStatus;
};

export type CanvassingSessionPipelineJobListResult = {
  __typename?: 'CanvassingSessionPipelineJobListResult';
  items: Array<CanvassingSessionPipelineJob>;
  total: Scalars['Int']['output'];
};

export enum CanvassingSessionPipelineJobStatus {
  Dead = 'DEAD',
  Done = 'DONE',
  FailedLegacy = 'FAILED_LEGACY',
  Leased = 'LEASED',
  Queued = 'QUEUED',
  Unknown = 'UNKNOWN'
}

export enum CanvassingSessionPipelineStage {
  Merge = 'MERGE',
  Segment = 'SEGMENT',
  Submit = 'SUBMIT',
  Unknown = 'UNKNOWN'
}

export enum CanvassingSessionProcessingStatus {
  Active = 'ACTIVE',
  AudioPending = 'AUDIO_PENDING',
  Failed = 'FAILED',
  Merged = 'MERGED',
  Partial = 'PARTIAL',
  Segmented = 'SEGMENTED',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN'
}

export type CanvassingSessionRecordingAccess = {
  __typename?: 'CanvassingSessionRecordingAccess';
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum CanvassingSessionRecordingPurpose {
  Download = 'DOWNLOAD',
  Playback = 'PLAYBACK'
}

export type CanvassingSessionRecordingResult = {
  __typename?: 'CanvassingSessionRecordingResult';
  access?: Maybe<CanvassingSessionRecordingAccess>;
  status: CanvassingSessionRecordingStatus;
  warnings: Array<CanvassingSessionRecordingWarning>;
};

export enum CanvassingSessionRecordingStatus {
  NotMerged = 'NOT_MERGED',
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE'
}

export enum CanvassingSessionRecordingWarning {
  CompletenessUnknown = 'COMPLETENESS_UNKNOWN',
  Gaps = 'GAPS',
  Partial = 'PARTIAL'
}

export type CanvassingSessionTelemetryItem = {
  __typename?: 'CanvassingSessionTelemetryItem';
  details: Scalars['SessionTelemetryDetails']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorName?: Maybe<Scalars['String']['output']>;
  errorTruncated: Scalars['Boolean']['output'];
  eventId: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  outcome: SessionTelemetryOutcome;
  receivedAt: Scalars['DateTime']['output'];
  sequence: Scalars['Int']['output'];
  source: SessionTelemetrySource;
  stackTrace?: Maybe<Scalars['String']['output']>;
  type: SessionTelemetryEventType;
};

export type CanvassingSessionTelemetryLatestHeartbeat = {
  __typename?: 'CanvassingSessionTelemetryLatestHeartbeat';
  audioState: SessionTelemetryAudioState;
  confirmedUploadCount: Scalars['Int']['output'];
  connectivity: SessionTelemetryConnectivity;
  gpsState: SessionTelemetryGpsState;
  lastSegmentCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  pendingUploadCount: Scalars['Int']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

export type CanvassingSessionTelemetryResult = {
  __typename?: 'CanvassingSessionTelemetryResult';
  items: Array<CanvassingSessionTelemetryItem>;
  snapshot: Scalars['String']['output'];
  summary: CanvassingSessionTelemetrySummary;
  total: Scalars['Int']['output'];
};

export type CanvassingSessionTelemetrySummary = {
  __typename?: 'CanvassingSessionTelemetrySummary';
  latestHeartbeat?: Maybe<CanvassingSessionTelemetryLatestHeartbeat>;
  latestReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  total: Scalars['Int']['output'];
};

export type CanvassingSessionTranscriptionDto = {
  __typename?: 'CanvassingSessionTranscriptionDto';
  eligibility: SessionTranscriptionEligibility;
  enabled: Scalars['Boolean']['output'];
  latestRun?: Maybe<SessionTranscriptionRunDto>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedRevision: Scalars['Int']['output'];
  publishedRunId?: Maybe<Scalars['ID']['output']>;
  result?: Maybe<SessionTranscriptionResultDto>;
  resultUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sessionId: Scalars['ID']['output'];
};

export type ChangePasswordMutation = {
  __typename?: 'ChangePasswordMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangeSubscriptionPackageMutation = {
  __typename?: 'ChangeSubscriptionPackageMutation';
  subscription?: Maybe<SubscriptionType>;
};

export enum Channel {
  Default = 'DEFAULT',
  Mailgun = 'MAILGUN',
  Testing = 'TESTING',
  Twilio = 'TWILIO'
}

export enum ChannelTypeEnum {
  Email = 'EMAIL',
  Form = 'FORM',
  LiveChat = 'LIVE_CHAT',
  Sms = 'SMS',
  Unknown = 'UNKNOWN'
}

export type ChatCompletionMessageInputType = {
  content?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ChatCompletionMessageType = {
  __typename?: 'ChatCompletionMessageType';
  content?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ChatbotAllowedDomainsInputType = {
  automotive?: InputMaybe<Scalars['Boolean']['input']>;
  financialServices?: InputMaybe<Scalars['Boolean']['input']>;
  homeServices?: InputMaybe<Scalars['Boolean']['input']>;
  insurance?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  realEstate?: InputMaybe<Scalars['Boolean']['input']>;
  recruiting?: InputMaybe<Scalars['Boolean']['input']>;
  software?: InputMaybe<Scalars['Boolean']['input']>;
  solar?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  travel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatbotAllowedDomainsType = {
  __typename?: 'ChatbotAllowedDomainsType';
  automotive?: Maybe<Scalars['Boolean']['output']>;
  financialServices?: Maybe<Scalars['Boolean']['output']>;
  homeServices?: Maybe<Scalars['Boolean']['output']>;
  insurance?: Maybe<Scalars['Boolean']['output']>;
  mortgage?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  realEstate?: Maybe<Scalars['Boolean']['output']>;
  recruiting?: Maybe<Scalars['Boolean']['output']>;
  software?: Maybe<Scalars['Boolean']['output']>;
  solar?: Maybe<Scalars['Boolean']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
  travel?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatbotDripCampaignsInputType = {
  longTerm?: InputMaybe<Scalars['Boolean']['input']>;
  midTerm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatbotDripCampaignsType = {
  __typename?: 'ChatbotDripCampaignsType';
  longTerm?: Maybe<Scalars['Boolean']['output']>;
  midTerm?: Maybe<Scalars['Boolean']['output']>;
};

export enum ChatbotHistoryActorSource {
  Ai = 'AI',
  Api = 'API',
  App = 'APP',
  EventMonitoring = 'EVENT_MONITORING',
  Integration = 'INTEGRATION',
  Unknown = 'UNKNOWN'
}

export type ChatbotHistoryActorType = {
  __typename?: 'ChatbotHistoryActorType';
  agentId?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ChatbotHistoryActorSource>;
};

export type ChatbotHistoryType = {
  __typename?: 'ChatbotHistoryType';
  actor?: Maybe<ChatbotHistoryActorType>;
  data?: Maybe<Scalars['JSONString']['output']>;
  message?: Maybe<MessageType>;
  reason?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ChatbotHoursOfOperationInputType = {
  days?: InputMaybe<Array<InputMaybe<Array<InputMaybe<HoursOfOperationModeInputType>>>>>;
};

export type ChatbotHoursOfOperationType = {
  __typename?: 'ChatbotHoursOfOperationType';
  days?: Maybe<Array<Maybe<Array<Maybe<HoursOfOperationModeType>>>>>;
};

export type ChatbotLeadTypesInputType = {
  autoInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  bathroom?: InputMaybe<Scalars['Boolean']['input']>;
  buyer?: InputMaybe<Scalars['Boolean']['input']>;
  cropInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  deck?: InputMaybe<Scalars['Boolean']['input']>;
  door?: InputMaybe<Scalars['Boolean']['input']>;
  flooring?: InputMaybe<Scalars['Boolean']['input']>;
  gutterGuard?: InputMaybe<Scalars['Boolean']['input']>;
  gutters?: InputMaybe<Scalars['Boolean']['input']>;
  homeInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  homeRefinance?: InputMaybe<Scalars['Boolean']['input']>;
  inboundRecruit?: InputMaybe<Scalars['Boolean']['input']>;
  lifeInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  longTermDisabilityInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  mortgageInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  newHomeLoan?: InputMaybe<Scalars['Boolean']['input']>;
  newVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  outboundRecruit?: InputMaybe<Scalars['Boolean']['input']>;
  patio?: InputMaybe<Scalars['Boolean']['input']>;
  petInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  recruitingInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  rentToOwn?: InputMaybe<Scalars['Boolean']['input']>;
  renter?: InputMaybe<Scalars['Boolean']['input']>;
  rentersInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  roofing?: InputMaybe<Scalars['Boolean']['input']>;
  screenedPorchSunroom?: InputMaybe<Scalars['Boolean']['input']>;
  seller?: InputMaybe<Scalars['Boolean']['input']>;
  siding?: InputMaybe<Scalars['Boolean']['input']>;
  solar?: InputMaybe<Scalars['Boolean']['input']>;
  travelInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  umbrellaInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  usedVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  wealthManagement?: InputMaybe<Scalars['Boolean']['input']>;
  windows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatbotLeadTypesType = {
  __typename?: 'ChatbotLeadTypesType';
  autoInsurance?: Maybe<Scalars['Boolean']['output']>;
  bathroom?: Maybe<Scalars['Boolean']['output']>;
  buyer?: Maybe<Scalars['Boolean']['output']>;
  cropInsurance?: Maybe<Scalars['Boolean']['output']>;
  deck?: Maybe<Scalars['Boolean']['output']>;
  door?: Maybe<Scalars['Boolean']['output']>;
  flooring?: Maybe<Scalars['Boolean']['output']>;
  gutterGuard?: Maybe<Scalars['Boolean']['output']>;
  gutters?: Maybe<Scalars['Boolean']['output']>;
  homeInsurance?: Maybe<Scalars['Boolean']['output']>;
  homeRefinance?: Maybe<Scalars['Boolean']['output']>;
  inboundRecruit?: Maybe<Scalars['Boolean']['output']>;
  lifeInsurance?: Maybe<Scalars['Boolean']['output']>;
  longTermDisabilityInsurance?: Maybe<Scalars['Boolean']['output']>;
  mortgageInsurance?: Maybe<Scalars['Boolean']['output']>;
  newHomeLoan?: Maybe<Scalars['Boolean']['output']>;
  newVehicle?: Maybe<Scalars['Boolean']['output']>;
  outboundRecruit?: Maybe<Scalars['Boolean']['output']>;
  patio?: Maybe<Scalars['Boolean']['output']>;
  petInsurance?: Maybe<Scalars['Boolean']['output']>;
  recruitingInsurance?: Maybe<Scalars['Boolean']['output']>;
  rentToOwn?: Maybe<Scalars['Boolean']['output']>;
  renter?: Maybe<Scalars['Boolean']['output']>;
  rentersInsurance?: Maybe<Scalars['Boolean']['output']>;
  roofing?: Maybe<Scalars['Boolean']['output']>;
  screenedPorchSunroom?: Maybe<Scalars['Boolean']['output']>;
  seller?: Maybe<Scalars['Boolean']['output']>;
  siding?: Maybe<Scalars['Boolean']['output']>;
  solar?: Maybe<Scalars['Boolean']['output']>;
  travelInsurance?: Maybe<Scalars['Boolean']['output']>;
  umbrellaInsurance?: Maybe<Scalars['Boolean']['output']>;
  usedVehicle?: Maybe<Scalars['Boolean']['output']>;
  wealthManagement?: Maybe<Scalars['Boolean']['output']>;
  windows?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckActivateCustomScriptType = {
  __typename?: 'CheckActivateCustomScriptType';
  activateLatestVersion?: Maybe<Scalars['Boolean']['output']>;
  activateScript?: Maybe<Scalars['Boolean']['output']>;
  customDeactivateId?: Maybe<Scalars['ID']['output']>;
  defaultDeactivateId?: Maybe<Scalars['ID']['output']>;
};

export type CheckActivateDefaultScriptType = {
  __typename?: 'CheckActivateDefaultScriptType';
  activateScript?: Maybe<Scalars['Boolean']['output']>;
  customDeactivateId?: Maybe<Scalars['ID']['output']>;
};

export type ClaimLeadListItemMutation = {
  __typename?: 'ClaimLeadListItemMutation';
  result?: Maybe<LeadListItemType>;
};

export type ClearCustomerCampaignMutation = {
  __typename?: 'ClearCustomerCampaignMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ClearbitInfoType = {
  __typename?: 'ClearbitInfoType';
  avatar?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type ClientLogoutMutation = {
  __typename?: 'ClientLogoutMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CloneDoorVisitResult = {
  __typename?: 'CloneDoorVisitResult';
  doorVisitId: Scalars['Int']['output'];
};

export type CloudwatchLog = {
  __typename?: 'CloudwatchLog';
  id?: Maybe<Scalars['ID']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type CommioPlatformType = {
  __typename?: 'CommioPlatformType';
  byocTrunkSid?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  commioNumberId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  messagingWebhookUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  statusWebhookUrl?: Maybe<Scalars['String']['output']>;
  twilioNumberVerified: Scalars['Boolean']['output'];
};

export type CommioProfileType = {
  __typename?: 'CommioProfileType';
  byocOriginationSid?: Maybe<Scalars['String']['output']>;
  byocTerminationSid?: Maybe<Scalars['String']['output']>;
  byocTrunkSid?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  groupCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CommunicationChannelMetricsType = {
  __typename?: 'CommunicationChannelMetricsType';
  lastCalculated?: Maybe<Scalars['DateTime']['output']>;
  week1?: Maybe<WeeklyCommunicationChannelMetricsType>;
  week2?: Maybe<WeeklyCommunicationChannelMetricsType>;
  week3?: Maybe<WeeklyCommunicationChannelMetricsType>;
  week4?: Maybe<WeeklyCommunicationChannelMetricsType>;
};

export type CommunicationChannelPlatformType = AgentLegendEmailPlatformType | AgentLegendTwilioPlatformType | BonzoEmailPlatformType | BonzoTwilioPlatformType | CommioPlatformType | LiveChatPlatformType | MailgunPlatformType | MessageBirdPlatformType | SierraInteractiveEmailPlatformType | SierraInteractiveTwilioPlatformType | SmoochMailgunPlatformType | SmoochMessageBirdPlatformType | SmoochTwilioPlatformType | TelnyxPlatformType | TestingPlatformType | TwilioPlatformType | VonagePlatformType;

export type CommunicationChannelType = {
  __typename?: 'CommunicationChannelType';
  campaignId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  metrics?: Maybe<CommunicationChannelMetricsType>;
  platform: CommunicationChannelPlatformType;
  voiceAiAgent?: Maybe<VoiceAiAgentType>;
};

export type CommunicationProfilePlatformType = CommioProfileType | CustomTwilioProfileType | TelnyxProfileType | TwilioProfileType | VonageProfileType;

export type CommunicationProfileType = {
  __typename?: 'CommunicationProfileType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  platform: CommunicationProfilePlatformType;
};

export type CompileCincLeadReport = {
  __typename?: 'CompileCincLeadReport';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CompileLionDeskLeadReport = {
  __typename?: 'CompileLionDeskLeadReport';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmSegmentUploadInput = {
  capturedAt: Scalars['DateTime']['input'];
  durationMs: Scalars['Int']['input'];
  segmentNumber: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};

export type ConnectPortalAuthenticationType = {
  __typename?: 'ConnectPortalAuthenticationType';
  authJwt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isCaasEnabled?: Maybe<Scalars['Boolean']['output']>;
  isCrossPlatform?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isPartnerAdmin?: Maybe<Scalars['Boolean']['output']>;
  isReseller?: Maybe<Scalars['Boolean']['output']>;
  isResellerAdmin?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['ID']['output']>;
  resellerId?: Maybe<Scalars['ID']['output']>;
  sessionId: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ConversationMessageAdditionType = {
  __typename?: 'ConversationMessageAdditionType';
  message?: Maybe<MessageType>;
};

export type ConversationType = {
  __typename?: 'ConversationType';
  givenName?: Maybe<Scalars['String']['output']>;
  initialMessage?: Maybe<MessageType>;
  latestMessage?: Maybe<MessageType>;
  messages?: Maybe<Array<Maybe<MessageType>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};


export type ConversationTypeMessagesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConvertFauxAgentToStandardMutation = {
  __typename?: 'ConvertFauxAgentToStandardMutation';
  agent?: Maybe<AgentType>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CopyCampaignMutation = {
  __typename?: 'CopyCampaignMutation';
  campaign?: Maybe<CampaignType>;
};

export type CopyTextAiAgentMutation = {
  __typename?: 'CopyTextAiAgentMutation';
  result?: Maybe<TextAiAgentType>;
};

export type CopyVoiceAiAgentMutation = {
  __typename?: 'CopyVoiceAiAgentMutation';
  result?: Maybe<VoiceAiAgentType>;
};

export type CoreConfigurationStatus = {
  __typename?: 'CoreConfigurationStatus';
  envTokenInUse: Scalars['Boolean']['output'];
  tokenValid: Scalars['Boolean']['output'];
  webhooks: Array<CoreExpectedWebhookStatus>;
};

export type CoreExpectedWebhookStatus = {
  __typename?: 'CoreExpectedWebhookStatus';
  configured: Scalars['Boolean']['output'];
  consecutiveFailures?: Maybe<Scalars['Int']['output']>;
  coreStatus?: Maybe<Scalars['String']['output']>;
  expectedTarget: Scalars['String']['output'];
  totalFailedRequests?: Maybe<Scalars['Int']['output']>;
  totalSuccessfulRequests?: Maybe<Scalars['Int']['output']>;
  trigger: Scalars['String']['output'];
};

export type CoreServerInfoType = {
  __typename?: 'CoreServerInfoType';
  time: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type CreateAcculynxIntegrationMutation = {
  __typename?: 'CreateAcculynxIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAdminUserMutation = {
  __typename?: 'CreateAdminUserMutation';
  admin?: Maybe<AdminType>;
};

export type CreateAdvancedBehaviorMutation = {
  __typename?: 'CreateAdvancedBehaviorMutation';
  result?: Maybe<AdvancedBehaviorType>;
};

export type CreateAdvancedCallRoutingMutation = {
  __typename?: 'CreateAdvancedCallRoutingMutation';
  result?: Maybe<AdvancedCallRoutingType>;
};

export type CreateAgentForBrokerageMutation = {
  __typename?: 'CreateAgentForBrokerageMutation';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CreateAgentForTeamMutation = {
  __typename?: 'CreateAgentForTeamMutation';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CreateAgentLegendIntegrationMutation = {
  __typename?: 'CreateAgentLegendIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAgentMutation = {
  __typename?: 'CreateAgentMutation';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CreateBehaviorMutation = {
  __typename?: 'CreateBehaviorMutation';
  result?: Maybe<BehaviorType>;
};

export type CreateBonzoIntegrationMutation = {
  __typename?: 'CreateBonzoIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateBrokerageMutation = {
  __typename?: 'CreateBrokerageMutation';
  accessToken?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['ID']['output']>;
  brokerageId?: Maybe<Scalars['ID']['output']>;
};

export type CreateCampaignFromAgentsMutation = {
  __typename?: 'CreateCampaignFromAgentsMutation';
  campaign?: Maybe<CampaignType>;
};

export type CreateCampaignMutation = {
  __typename?: 'CreateCampaignMutation';
  campaign?: Maybe<CampaignType>;
};

export type CreateCustomFlowMutation = {
  __typename?: 'CreateCustomFlowMutation';
  customFlow?: Maybe<CustomFlowType>;
};

export type CreateCustomPlanMutation = {
  __typename?: 'CreateCustomPlanMutation';
  plan?: Maybe<PlanType>;
};

export type CreateCustomScriptMutation = {
  __typename?: 'CreateCustomScriptMutation';
  customScript?: Maybe<CustomScriptType>;
};

export type CreateCustomToolMutation = {
  __typename?: 'CreateCustomToolMutation';
  result?: Maybe<CustomToolDefinitionType>;
};

export type CreateCustomizedSlotMutation = {
  __typename?: 'CreateCustomizedSlotMutation';
  slot?: Maybe<CustomizedSlotType>;
};

export type CreateCustomizedStageMutation = {
  __typename?: 'CreateCustomizedStageMutation';
  stage?: Maybe<CustomizedStageType>;
};

export type CreateDialingListFromFilterMutation = {
  __typename?: 'CreateDialingListFromFilterMutation';
  result?: Maybe<LeadListType>;
};

export type CreateDirectApiTokenMutation = {
  __typename?: 'CreateDirectApiTokenMutation';
  result: DirectPlatformTokenType;
};

export type CreateDirectPlatformEmbeddedAppMutation = {
  __typename?: 'CreateDirectPlatformEmbeddedAppMutation';
  result?: Maybe<DirectPlatformEmbeddedAppType>;
};

export type CreateDirectPlatformWebhookMutation = {
  __typename?: 'CreateDirectPlatformWebhookMutation';
  result?: Maybe<DirectPlatformWebhookType>;
};

export type CreateDoorVisitReportInput = {
  filter?: InputMaybe<DoorVisitListFilter>;
  requestId: Scalars['ID']['input'];
  sort?: InputMaybe<DoorVisitListSort>;
};

export type CreateFollowUpBossV2Integration = {
  __typename?: 'CreateFollowUpBossV2Integration';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateFromCustomScriptMutation = {
  __typename?: 'CreateFromCustomScriptMutation';
  customScript?: Maybe<CustomScriptType>;
};

export type CreateFromDefaultIntentMutation = {
  __typename?: 'CreateFromDefaultIntentMutation';
  customIntent?: Maybe<CustomIntentType>;
};

export type CreateFromDefaultScriptMutation = {
  __typename?: 'CreateFromDefaultScriptMutation';
  customScript?: Maybe<CustomScriptType>;
};

export type CreateKnowledgeBaseMutation = {
  __typename?: 'CreateKnowledgeBaseMutation';
  result?: Maybe<KnowledgeBaseType>;
};

export type CreateLeadEnrollmentRuleMutation = {
  __typename?: 'CreateLeadEnrollmentRuleMutation';
  enrollmentRule?: Maybe<LeadEnrollmentRuleType>;
};

export type CreateLeadListMutation = {
  __typename?: 'CreateLeadListMutation';
  result?: Maybe<LeadListType>;
};

export type CreateLeadMutation = {
  __typename?: 'CreateLeadMutation';
  lead?: Maybe<CustomerType>;
};

export type CreateLeadPerfectionIntegrationMutation = {
  __typename?: 'CreateLeadPerfectionIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLeadUploadMappingMutation = {
  __typename?: 'CreateLeadUploadMappingMutation';
  result?: Maybe<LeadUploadMappingType>;
};

export type CreateMarketSharpIntegrationMutation = {
  __typename?: 'CreateMarketSharpIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMarketSharpV2IntegrationMutation = {
  __typename?: 'CreateMarketSharpV2IntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrUpdateInboxLabel = {
  __typename?: 'CreateOrUpdateInboxLabel';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOrUpdateMailboxRule = {
  __typename?: 'CreateOrUpdateMailboxRule';
  result?: Maybe<MailboxRuleType>;
};

export type CreateOrUpdateTwilioCommunicationProfile = {
  __typename?: 'CreateOrUpdateTwilioCommunicationProfile';
  result?: Maybe<CommunicationProfileType>;
};

export type CreateOrUpdateVonageCommunicationProfile = {
  __typename?: 'CreateOrUpdateVonageCommunicationProfile';
  result?: Maybe<CommunicationProfileType>;
};

export type CreatePartnerApiTokenMutation = {
  __typename?: 'CreatePartnerApiTokenMutation';
  result: PartnerApiTokenType;
};

export type CreatePartnerMutation = {
  __typename?: 'CreatePartnerMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreatePartnerUserMutation = {
  __typename?: 'CreatePartnerUserMutation';
  result?: Maybe<PartnerUserType>;
};

export type CreatePartnerWebhookMutation = {
  __typename?: 'CreatePartnerWebhookMutation';
  result?: Maybe<PartnerWebhookType>;
};

export type CreatePromptTemplateMutation = {
  __typename?: 'CreatePromptTemplateMutation';
  result?: Maybe<PromptTemplateType>;
};

export type CreateResellerApiTokenMutation = {
  __typename?: 'CreateResellerApiTokenMutation';
  result: ResellerApiTokenType;
};

export type CreateResellerMutation = {
  __typename?: 'CreateResellerMutation';
  result?: Maybe<ResellerAccountType>;
};

export type CreateResellerUserMutation = {
  __typename?: 'CreateResellerUserMutation';
  result?: Maybe<ResellerAgentType>;
};

export type CreateSeedDataUploadInput = {
  originalFilename: Scalars['String']['input'];
  sizeBytes: Scalars['Float']['input'];
};

export type CreateSeedDataUploadResult = {
  __typename?: 'CreateSeedDataUploadResult';
  import: SeedDataImportDto;
  uploadUrl: Scalars['String']['output'];
  uploadUrlExpiresAt: Scalars['DateTime']['output'];
};

export type CreateTcrBrandInputType = {
  altBusinessId?: InputMaybe<Scalars['String']['input']>;
  altBusinessIdType?: InputMaybe<Scalars['String']['input']>;
  brandRelationship: Scalars['String']['input'];
  businessContactEmail?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['String']['input']>;
  einIssuingCountry?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  mock?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stockExchange?: InputMaybe<Scalars['String']['input']>;
  stockSymbol?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
  vertical?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTcrBrandMutation = {
  __typename?: 'CreateTcrBrandMutation';
  result?: Maybe<TcrBrandType>;
};

export type CreateTcrCampaignInputType = {
  ageGated?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  brandId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  directLending?: InputMaybe<Scalars['Boolean']['input']>;
  embeddedLink?: InputMaybe<Scalars['Boolean']['input']>;
  embeddedLinkSample?: InputMaybe<Scalars['String']['input']>;
  embeddedPhone?: InputMaybe<Scalars['Boolean']['input']>;
  helpKeywords?: InputMaybe<Scalars['String']['input']>;
  helpMessage?: InputMaybe<Scalars['String']['input']>;
  messageFlow: Scalars['String']['input'];
  mnoIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberPool?: InputMaybe<Scalars['Boolean']['input']>;
  optinKeywords?: InputMaybe<Scalars['String']['input']>;
  optinMessage?: InputMaybe<Scalars['String']['input']>;
  optoutKeywords?: InputMaybe<Scalars['String']['input']>;
  optoutMessage?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyLink?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  resellerId?: InputMaybe<Scalars['String']['input']>;
  sample1: Scalars['String']['input'];
  sample2?: InputMaybe<Scalars['String']['input']>;
  sample3?: InputMaybe<Scalars['String']['input']>;
  sample4?: InputMaybe<Scalars['String']['input']>;
  sample5?: InputMaybe<Scalars['String']['input']>;
  subUsecases?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriberHelp?: InputMaybe<Scalars['Boolean']['input']>;
  subscriberOptin?: InputMaybe<Scalars['Boolean']['input']>;
  subscriberOptout?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsLink?: InputMaybe<Scalars['String']['input']>;
  usecase: Scalars['String']['input'];
};

export type CreateTcrCampaignMutation = {
  __typename?: 'CreateTcrCampaignMutation';
  result?: Maybe<TcrCampaignType>;
};

export type CreateTeamForBrokerageMutation = {
  __typename?: 'CreateTeamForBrokerageMutation';
  agentId?: Maybe<Scalars['ID']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type CreateTeamMutation = {
  __typename?: 'CreateTeamMutation';
  accessToken?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['ID']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type CreateTextAiAgentMutation = {
  __typename?: 'CreateTextAiAgentMutation';
  result?: Maybe<TextAiAgentType>;
};

export type CreateVoiceAiAgentMutation = {
  __typename?: 'CreateVoiceAiAgentMutation';
  result?: Maybe<VoiceAiAgentType>;
};

export type CrossLaunchTokenType = {
  __typename?: 'CrossLaunchTokenType';
  agentId?: Maybe<Scalars['ID']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export enum CursorDirection {
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type CursorInputType = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  direction: CursorDirection;
  timestamp?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CustomFlowType = {
  __typename?: 'CustomFlowType';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  qualifiers?: Maybe<FlowQualifiersType>;
  script?: Maybe<FlowScriptType>;
};

export type CustomIntentType = {
  __typename?: 'CustomIntentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultIntentId?: Maybe<Scalars['ID']['output']>;
  hasActiveVersion?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<CustomIntentVersionType>;
};


export type CustomIntentTypeVersionArgs = {
  id: Scalars['ID']['input'];
};

export type CustomIntentVersionType = {
  __typename?: 'CustomIntentVersionType';
  content?: Maybe<IntentContentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CustomSchemaExtractionStatusType {
  EmptyOrUnstructured = 'EmptyOrUnstructured',
  Success = 'Success'
}

export type CustomSchemaResponsePaginationType = {
  __typename?: 'CustomSchemaResponsePaginationType';
  count: Scalars['Int']['output'];
  items: Array<CustomSchemaResponseType>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomSchemaResponseType = {
  __typename?: 'CustomSchemaResponseType';
  annotatedBy?: Maybe<AgentType>;
  annotatedSlots?: Maybe<Array<Maybe<RawSlotValueType>>>;
  annotatedStages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  call?: Maybe<VoiceCallType>;
  chatCompletions?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<CustomerType>;
  extractionStatus?: Maybe<CustomSchemaExtractionStatusType>;
  filledSlots?: Maybe<Array<Maybe<RawSlotValueType>>>;
  filledStages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  includesSlots?: Maybe<Scalars['Boolean']['output']>;
  includesStages?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<MessageType>;
  responseFormat?: Maybe<Scalars['GenericScalar']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useForTraining?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomScriptType = {
  __typename?: 'CustomScriptType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use custom flows to activate a script */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use custom flows to activate a script */
  leadType?: Maybe<ScriptLeadTypes>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom flows to activate a script */
  sourceType?: Maybe<ScriptSourceTypes>;
  version?: Maybe<CustomScriptVersionType>;
  /** @deprecated Versions iterator no longer available */
  versions?: Maybe<Array<Maybe<CustomScriptVersionType>>>;
};


export type CustomScriptTypeVersionArgs = {
  id: Scalars['ID']['input'];
};

export type CustomScriptVersionType = {
  __typename?: 'CustomScriptVersionType';
  content?: Maybe<ScriptContentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomSlot = {
  __typename?: 'CustomSlot';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueLabel: Scalars['String']['output'];
};

export type CustomStageNotificationInputType = {
  emailNotificationBody?: InputMaybe<Scalars['String']['input']>;
  emailNotificationSubject?: InputMaybe<Scalars['String']['input']>;
  emailNotificationTarget?: InputMaybe<NotificationTargetType>;
  smsNotificationMessage?: InputMaybe<Scalars['String']['input']>;
  smsNotificationTarget?: InputMaybe<NotificationTargetType>;
};

export type CustomStageNotificationType = {
  __typename?: 'CustomStageNotificationType';
  emailNotificationBody?: Maybe<Scalars['String']['output']>;
  emailNotificationSubject?: Maybe<Scalars['String']['output']>;
  emailNotificationTarget?: Maybe<NotificationTargetType>;
  smsNotificationMessage?: Maybe<Scalars['String']['output']>;
  smsNotificationTarget?: Maybe<NotificationTargetType>;
};

export type CustomToolAttachmentInputType = {
  enabled: Scalars['Boolean']['input'];
  toolId: Scalars['ID']['input'];
};

export enum CustomToolChannel {
  Text = 'text',
  Voice = 'voice'
}

export type CustomToolDefinitionInputType = {
  channels: Array<CustomToolChannel>;
  description?: InputMaybe<Scalars['String']['input']>;
  functionSchema: Scalars['GenericScalar']['input'];
  httpBodyExtras?: InputMaybe<Array<CustomToolHttpBodyExtraInputType>>;
  httpContentType?: InputMaybe<CustomToolHttpContentType>;
  httpEndpoint: Scalars['String']['input'];
  httpHeaders?: InputMaybe<Array<CustomToolKeyValueInputType>>;
  httpMethod: CustomToolHttpMethod;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycleEvents: Array<CustomToolLifecycleEvent>;
  name: Scalars['String']['input'];
  onSuccessGuidance?: InputMaybe<Scalars['String']['input']>;
  responseNormalizationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  slotMappings?: InputMaybe<Array<CustomToolSlotMappingInputType>>;
};

export type CustomToolDefinitionType = {
  __typename?: 'CustomToolDefinitionType';
  channels: Array<CustomToolChannel>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  functionSchema: Scalars['GenericScalar']['output'];
  httpBodyExtras: Array<CustomToolKeyValueType>;
  httpContentType?: Maybe<CustomToolHttpContentType>;
  httpEndpoint: Scalars['String']['output'];
  httpHeaders: Array<CustomToolKeyValueType>;
  httpMethod: CustomToolHttpMethod;
  id: Scalars['ID']['output'];
  isTerminal: Scalars['Boolean']['output'];
  lifecycleEvents: Array<CustomToolLifecycleEvent>;
  name: Scalars['String']['output'];
  onSuccessGuidance?: Maybe<Scalars['String']['output']>;
  responseNormalizationPaths: Array<Scalars['String']['output']>;
  slotMappings: Array<CustomToolSlotMappingType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomToolDefinitionUpdateInputType = {
  channels?: InputMaybe<Array<CustomToolChannel>>;
  description?: InputMaybe<Scalars['String']['input']>;
  functionSchema?: InputMaybe<Scalars['GenericScalar']['input']>;
  httpBodyExtras?: InputMaybe<Array<CustomToolHttpBodyExtraInputType>>;
  httpContentType?: InputMaybe<CustomToolHttpContentType>;
  httpEndpoint?: InputMaybe<Scalars['String']['input']>;
  httpHeaders?: InputMaybe<Array<CustomToolKeyValueInputType>>;
  httpMethod?: InputMaybe<CustomToolHttpMethod>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycleEvents?: InputMaybe<Array<CustomToolLifecycleEvent>>;
  name?: InputMaybe<Scalars['String']['input']>;
  onSuccessGuidance?: InputMaybe<Scalars['String']['input']>;
  responseNormalizationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  slotMappings?: InputMaybe<Array<CustomToolSlotMappingInputType>>;
};

export type CustomToolHttpBodyExtraDefaultInputType = {
  defaultValue: Scalars['String']['input'];
  targetKey: Scalars['String']['input'];
  targetType: CustomToolHttpBodyExtraDefaultTargetType;
};

export enum CustomToolHttpBodyExtraDefaultTargetType {
  Argument = 'argument',
  Slot = 'slot'
}

export type CustomToolHttpBodyExtraDefaultType = {
  __typename?: 'CustomToolHttpBodyExtraDefaultType';
  defaultValue?: Maybe<Scalars['String']['output']>;
  targetKey?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
};

export type CustomToolHttpBodyExtraInputType = {
  datetimeTransform?: InputMaybe<CustomToolKeyValueDatetimeTransformInputType>;
  defaults?: InputMaybe<Array<CustomToolHttpBodyExtraDefaultInputType>>;
  key: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
  valueType?: InputMaybe<CustomToolKeyValueValueType>;
};

export enum CustomToolHttpContentType {
  Json = 'JSON',
  XWwwFormUrlencoded = 'X_WWW_FORM_URLENCODED'
}

export enum CustomToolHttpMethod {
  Get = 'GET',
  Post = 'POST'
}

export type CustomToolKeyValueDatetimeTransformInputType = {
  outputType: CustomToolKeyValueDatetimeTransformOutputType;
  strftimeFormat?: InputMaybe<Scalars['String']['input']>;
  timezoneOption?: InputMaybe<CustomToolKeyValueDatetimeTransformTimezoneOption>;
};

export enum CustomToolKeyValueDatetimeTransformOutputType {
  Strftime = 'Strftime',
  TimestampMilliseconds = 'TimestampMilliseconds',
  TimestampSeconds = 'TimestampSeconds'
}

export enum CustomToolKeyValueDatetimeTransformTimezoneOption {
  AccountTimezone = 'AccountTimezone',
  Default = 'Default',
  LeadTimezone = 'LeadTimezone',
  Utc = 'UTC'
}

export type CustomToolKeyValueDatetimeTransformType = {
  __typename?: 'CustomToolKeyValueDatetimeTransformType';
  outputType?: Maybe<CustomToolKeyValueDatetimeTransformOutputType>;
  strftimeFormat?: Maybe<Scalars['String']['output']>;
  timezoneOption?: Maybe<CustomToolKeyValueDatetimeTransformTimezoneOption>;
};

export type CustomToolKeyValueInputType = {
  datetimeTransform?: InputMaybe<CustomToolKeyValueDatetimeTransformInputType>;
  defaults?: InputMaybe<Array<CustomToolHttpBodyExtraDefaultInputType>>;
  key: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
  valueType?: InputMaybe<CustomToolKeyValueValueType>;
};

export type CustomToolKeyValueType = {
  __typename?: 'CustomToolKeyValueType';
  datetimeTransform?: Maybe<CustomToolKeyValueDatetimeTransformType>;
  defaults: Array<CustomToolHttpBodyExtraDefaultType>;
  key: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
  valueType: CustomToolKeyValueValueType;
};

export enum CustomToolKeyValueValueType {
  Boolean = 'Boolean',
  Datetime = 'Datetime',
  Number = 'Number',
  String = 'String'
}

export enum CustomToolLifecycleEvent {
  DuringTurn = 'during_turn',
  PreTurn = 'pre_turn'
}

export type CustomToolResultPaginationType = {
  __typename?: 'CustomToolResultPaginationType';
  count: Scalars['Int']['output'];
  items: Array<CustomToolResultType>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomToolResultType = {
  __typename?: 'CustomToolResultType';
  channel: CustomToolChannel;
  createdAt: Scalars['DateTime']['output'];
  customToolId: Scalars['ID']['output'];
  customToolName: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorDetail?: Maybe<Scalars['String']['output']>;
  functionArgs: Scalars['GenericScalar']['output'];
  id: Scalars['ID']['output'];
  latencyMs: Scalars['Float']['output'];
  lifecycle: CustomToolLifecycleEvent;
  normalizedResponse?: Maybe<Scalars['GenericScalar']['output']>;
  requestBody?: Maybe<Scalars['GenericScalar']['output']>;
  requestMethod: Scalars['String']['output'];
  requestUrl: Scalars['String']['output'];
  responseBody?: Maybe<Scalars['GenericScalar']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
  successful: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomToolSlotMappingInputType = {
  canOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  jsonpath: Scalars['String']['input'];
  slotName: Scalars['String']['input'];
};

export type CustomToolSlotMappingType = {
  __typename?: 'CustomToolSlotMappingType';
  canOverwrite: Scalars['Boolean']['output'];
  jsonpath?: Maybe<Scalars['String']['output']>;
  slotName?: Maybe<Scalars['String']['output']>;
};

export type CustomTwilioProfileType = {
  __typename?: 'CustomTwilioProfileType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  twimlAppSid?: Maybe<Scalars['String']['output']>;
};

export type CustomVoiceMailInputType = {
  callAttempt: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type CustomVoiceMailType = {
  __typename?: 'CustomVoiceMailType';
  callAttempt: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CustomVoicePromptAnswerInputType = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type CustomVoicePromptAnswerType = {
  __typename?: 'CustomVoicePromptAnswerType';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type CustomVoicePromptQuestionInputType = {
  question?: InputMaybe<Scalars['String']['input']>;
  slot?: InputMaybe<Scalars['String']['input']>;
};

export type CustomVoicePromptQuestionType = {
  __typename?: 'CustomVoicePromptQuestionType';
  question?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
};

export type CustomerBulkActionInputType = {
  addTags?: InputMaybe<BulkAddTagsInputType>;
  addTask?: InputMaybe<BulkAddTaskInputType>;
  assignAgent?: InputMaybe<BulkAssignAgentInputType>;
  assignTeam?: InputMaybe<BulkAssignTeamInputType>;
  sendMessage?: InputMaybe<BulkSendMessageInputType>;
  type: CustomerBulkActionTypes;
  updateArchived?: InputMaybe<BulkUpdateArchivedInputType>;
  updateMuted?: InputMaybe<BulkUpdateMutedInputType>;
};

export type CustomerBulkActionMutation = {
  __typename?: 'CustomerBulkActionMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum CustomerBulkActionTypes {
  AddTags = 'ADD_TAGS',
  AddTask = 'ADD_TASK',
  AssignAgent = 'ASSIGN_AGENT',
  AssignTeam = 'ASSIGN_TEAM',
  SendMessage = 'SEND_MESSAGE',
  UpdateArchived = 'UPDATE_ARCHIVED',
  UpdateMuted = 'UPDATE_MUTED'
}

export type CustomerCampaignType = {
  __typename?: 'CustomerCampaignType';
  callCount: Scalars['Int']['output'];
  campaign: CampaignType;
  customer: CustomerType;
  disqualificationReason?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNotQualified: Scalars['Boolean']['output'];
  isQualified: Scalars['Boolean']['output'];
  lastInteractionAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  qualificationReason?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Scalars['GenericScalar']['output']>;
  stage: CampaignStageEnum;
  startedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CustomerEventEnum {
  Added = 'ADDED',
  Removed = 'REMOVED',
  Updated = 'UPDATED'
}

export type CustomerFilterInputType = {
  condition?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerFilterType = {
  __typename?: 'CustomerFilterType';
  condition?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerMutation = {
  __typename?: 'CustomerMutation';
  customer?: Maybe<CustomerType>;
};

export type CustomerPaginationType = {
  __typename?: 'CustomerPaginationType';
  items: Array<CustomerType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type CustomerType = {
  __typename?: 'CustomerType';
  agentHasEngaged?: Maybe<Scalars['Boolean']['output']>;
  agentStatus?: Maybe<Scalars['Boolean']['output']>;
  agentStatusPrompted?: Maybe<Scalars['Boolean']['output']>;
  appointment?: Maybe<AppointmentType>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignedAgent?: Maybe<AgentType>;
  assignedLender?: Maybe<AgentType>;
  assignedTeam?: Maybe<TeamType>;
  /** @deprecated Use leadTypes instead */
  autoInsuranceStatus?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use leadTypes instead */
  buyerStatus?: Maybe<Scalars['Boolean']['output']>;
  callById?: Maybe<VoiceCallType>;
  chatbotHistory?: Maybe<Array<Maybe<ChatbotHistoryType>>>;
  chatbotMuted?: Maybe<Scalars['Boolean']['output']>;
  chatbotVoiceMuted?: Maybe<Scalars['Boolean']['output']>;
  clearbit?: Maybe<ClearbitInfoType>;
  contingencyStatus?: Maybe<Scalars['Boolean']['output']>;
  contingencyStatusPrompted?: Maybe<Scalars['Boolean']['output']>;
  conversation?: Maybe<ConversationType>;
  conversationAnalytics?: Maybe<AnalyticsConversationType>;
  currentCampaign?: Maybe<CampaignType>;
  customSlots: Array<RawSlotValueType>;
  customStages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customerCampaign?: Maybe<CustomerCampaignType>;
  customerCampaigns?: Maybe<Array<CustomerCampaignType>>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  financingStatus?: Maybe<Scalars['Boolean']['output']>;
  financingStatusPrompted?: Maybe<Scalars['Boolean']['output']>;
  firstContact?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use leadTypes instead */
  homeRefinanceStatus?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isQualified?: Maybe<Scalars['Boolean']['output']>;
  lastContact?: Maybe<Scalars['DateTime']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  leadTypeSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  leadTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listing?: Maybe<ListingType>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use leadTypes instead */
  newHomeLoanStatus?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  owningEntity?: Maybe<RealtorEntityType>;
  /** @deprecated Use owning_entity.id instead */
  owningEntityId?: Maybe<GenericReferenceType>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneStatus: PhoneStatusType;
  primarySource?: Maybe<Scalars['String']['output']>;
  rawSlots: Array<RawSlotValueType>;
  readiness?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use leadTypes instead */
  renterStatus?: Maybe<Scalars['Boolean']['output']>;
  scheduledActivity?: Maybe<Array<PendingSystemTaskType>>;
  search?: Maybe<SearchType>;
  /** @deprecated Use leadTypes instead */
  sellerStatus?: Maybe<Scalars['Boolean']['output']>;
  sources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  supportsCalling?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<TagsType>;
  tasks?: Maybe<Array<Maybe<TaskType>>>;
  testLead?: Maybe<Scalars['Boolean']['output']>;
  thirdPartyIntegrations?: Maybe<ThirdPartyIntegrationType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timeframe?: Maybe<Scalars['String']['output']>;
  totalCalls?: Maybe<Scalars['Int']['output']>;
  voiceCalls?: Maybe<Array<Maybe<VoiceCallType>>>;
};


export type CustomerTypeCallByIdArgs = {
  callId: Scalars['String']['input'];
};

export enum CustomizedSlotDataType {
  AnniversaryDate = 'ANNIVERSARY_DATE',
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING',
  Time = 'TIME'
}

export type CustomizedSlotInputType = {
  dataOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dataType?: InputMaybe<CustomizedSlotDataType>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  schema: Scalars['GenericScalar']['input'];
  usedForLlmContext?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomizedSlotType = {
  __typename?: 'CustomizedSlotType';
  dataOnly?: Maybe<Scalars['Boolean']['output']>;
  dataType?: Maybe<CustomizedSlotDataType>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  schema: Scalars['GenericScalar']['output'];
  usedForLlmContext?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomizedStageInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  needsFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  notificationConfiguration?: InputMaybe<CustomStageNotificationInputType>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  terminateConversation?: InputMaybe<TerminalStagesType>;
};

export type CustomizedStageType = {
  __typename?: 'CustomizedStageType';
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  isSuccessful?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsFollowup?: Maybe<Scalars['Boolean']['output']>;
  notificationConfiguration?: Maybe<CustomStageNotificationType>;
  priority?: Maybe<Scalars['Int']['output']>;
  terminateConversation?: Maybe<TerminalStagesType>;
};

export type DailyAccountUsageReport = {
  __typename?: 'DailyAccountUsageReport';
  averageCallsPerLead: Scalars['Float']['output'];
  averageEmailsPerLead: Scalars['Float']['output'];
  averageSmsPerLead: Scalars['Float']['output'];
  callTokens: Scalars['Int']['output'];
  currentEnd: Scalars['DateTime']['output'];
  currentStart: Scalars['DateTime']['output'];
  dashboardPeriod: DashboardPeriod;
  emailTokens: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  hasSubscription: Scalars['Boolean']['output'];
  leadOverage: Scalars['Int']['output'];
  reportBucket: Scalars['DateTime']['output'];
  smsTokens: Scalars['Int']['output'];
  tokenBased: Scalars['Boolean']['output'];
  tokenOverage: Scalars['Int']['output'];
  totalAiCallMinutes: Scalars['Int']['output'];
  totalAppointmentsSet: Scalars['Int']['output'];
  totalCallMinutes: Scalars['Int']['output'];
  totalCallbacksScheduled: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalCallsAnswered: Scalars['Int']['output'];
  totalCallsDidNotLeaveVm: Scalars['Int']['output'];
  totalCallsLeftVm: Scalars['Int']['output'];
  totalDoorVisits: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalLeads: Scalars['Int']['output'];
  totalLiveTransfers: Scalars['Int']['output'];
  totalLiveTransfersSuccessful: Scalars['Int']['output'];
  totalSms: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export enum DashboardPeriod {
  Last_30Days = 'LAST_30_DAYS',
  LastBillingPeriod = 'LAST_BILLING_PERIOD',
  ThisBillingCycle = 'THIS_BILLING_CYCLE',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY'
}

export type DeactivateCustomIntentMutation = {
  __typename?: 'DeactivateCustomIntentMutation';
  deactivatedIntent?: Maybe<Scalars['Boolean']['output']>;
  defaultActivatedId?: Maybe<Scalars['ID']['output']>;
};

export type DeactivateCustomScriptMutation = {
  __typename?: 'DeactivateCustomScriptMutation';
  deactivatedScript?: Maybe<Scalars['Boolean']['output']>;
};

export type DeactivateDefaultScriptMutation = {
  __typename?: 'DeactivateDefaultScriptMutation';
  deactivatedScript?: Maybe<Scalars['Boolean']['output']>;
};

export enum DefaultDripCampaignNames {
  AutoInquiry = 'AUTO_INQUIRY',
  AwningInquiry = 'AWNING_INQUIRY',
  BathRemodel = 'BATH_REMODEL',
  Buyer = 'BUYER',
  Buyer_1Month = 'BUYER_1MONTH',
  Buyer_3Month = 'BUYER_3MONTH',
  Buyer_6Month = 'BUYER_6MONTH',
  Buyer_12Month = 'BUYER_12MONTH',
  BuyerCommercial = 'BUYER_COMMERCIAL',
  BuyerContingency = 'BUYER_CONTINGENCY',
  BuyerEmail = 'BUYER_EMAIL',
  BuyerEmailText = 'BUYER_EMAIL_TEXT',
  BuyerOnholdRevival = 'BUYER_ONHOLD_REVIVAL',
  BuyerPastClient = 'BUYER_PAST_CLIENT',
  BuyerPostclose = 'BUYER_POSTCLOSE',
  BuyerPostFirstShowing = 'BUYER_POST_FIRST_SHOWING',
  BuyerPostOffer = 'BUYER_POST_OFFER',
  BuyerPreclose = 'BUYER_PRECLOSE',
  BuyerRevivalEmail = 'BUYER_REVIVAL_EMAIL',
  BuyerRevivalEmailText = 'BUYER_REVIVAL_EMAIL_TEXT',
  CabinetInquiry = 'CABINET_INQUIRY',
  CollinsInsuranceHomeAuto = 'COLLINS_INSURANCE_HOME_AUTO',
  CoverageDirectCrossSell = 'COVERAGE_DIRECT_CROSS_SELL',
  CoverageDirectHomeAuto = 'COVERAGE_DIRECT_HOME_AUTO',
  CoverageDirectMortgage = 'COVERAGE_DIRECT_MORTGAGE',
  DeckReplacement = 'DECK_REPLACEMENT',
  DoorReplacement = 'DOOR_REPLACEMENT',
  DoorSweepstakes = 'DOOR_SWEEPSTAKES',
  FlooringInquiry = 'FLOORING_INQUIRY',
  FreeTrial = 'FREE_TRIAL',
  General = 'GENERAL',
  General_1Month = 'GENERAL_1MONTH',
  General_3Month = 'GENERAL_3MONTH',
  General_6Month = 'GENERAL_6MONTH',
  General_12Month = 'GENERAL_12MONTH',
  GeneralEmail = 'GENERAL_EMAIL',
  GeneralEmailText = 'GENERAL_EMAIL_TEXT',
  GeneralHomeServices = 'GENERAL_HOME_SERVICES',
  GutterGuard = 'GUTTER_GUARD',
  GutterInquiry = 'GUTTER_INQUIRY',
  HomeConsultant = 'HOME_CONSULTANT',
  HomeRefinance = 'HOME_REFINANCE',
  HomeRefinance_1Month = 'HOME_REFINANCE_1MONTH',
  HomeRefinance_3Month = 'HOME_REFINANCE_3MONTH',
  HomeRefinance_6Month = 'HOME_REFINANCE_6MONTH',
  HomeRefinance_12Month = 'HOME_REFINANCE_12MONTH',
  HomeRefinanceEmail = 'HOME_REFINANCE_EMAIL',
  HomeRefinanceEmailText = 'HOME_REFINANCE_EMAIL_TEXT',
  HurricaneProtection = 'HURRICANE_PROTECTION',
  InboundRecruit = 'INBOUND_RECRUIT',
  InboundRecruit_1Month = 'INBOUND_RECRUIT_1MONTH',
  InboundRecruit_3Month = 'INBOUND_RECRUIT_3MONTH',
  InboundRecruit_6Month = 'INBOUND_RECRUIT_6MONTH',
  InboundRecruit_12Month = 'INBOUND_RECRUIT_12MONTH',
  InsuranceLapsedCoverage = 'INSURANCE_LAPSED_COVERAGE',
  InsuranceNewApp = 'INSURANCE_NEW_APP',
  InsuranceOldLead = 'INSURANCE_OLD_LEAD',
  InsurancePolicyReview = 'INSURANCE_POLICY_REVIEW',
  InsuranceQuote = 'INSURANCE_QUOTE',
  InsuranceRecruit = 'INSURANCE_RECRUIT',
  InterestRateInquiry = 'INTEREST_RATE_INQUIRY',
  Investor = 'INVESTOR',
  Investor_1Month = 'INVESTOR_1MONTH',
  Investor_3Month = 'INVESTOR_3MONTH',
  Investor_6Month = 'INVESTOR_6MONTH',
  Investor_12Month = 'INVESTOR_12MONTH',
  KitchenRemodel = 'KITCHEN_REMODEL',
  MobileHomeCashOffer = 'MOBILE_HOME_CASH_OFFER',
  MobileHomeCommunity = 'MOBILE_HOME_COMMUNITY',
  MultiUnitInvestor = 'MULTI_UNIT_INVESTOR',
  MultiUnitInvestorAppointment = 'MULTI_UNIT_INVESTOR_APPOINTMENT',
  MultiUnitInvestorProspect = 'MULTI_UNIT_INVESTOR_PROSPECT',
  NewHomeLoan = 'NEW_HOME_LOAN',
  NewHomeLoan_1Month = 'NEW_HOME_LOAN_1MONTH',
  NewHomeLoan_3Month = 'NEW_HOME_LOAN_3MONTH',
  NewHomeLoan_6Month = 'NEW_HOME_LOAN_6MONTH',
  NewHomeLoan_12Month = 'NEW_HOME_LOAN_12MONTH',
  NewHomeLoanEmail = 'NEW_HOME_LOAN_EMAIL',
  NewHomeLoanEmailText = 'NEW_HOME_LOAN_EMAIL_TEXT',
  NewHomeLoanPreclose = 'NEW_HOME_LOAN_PRECLOSE',
  NoDrips = 'NO_DRIPS',
  OffMarket = 'OFF_MARKET',
  OutboundRecruit = 'OUTBOUND_RECRUIT',
  OutboundRecruit_1Month = 'OUTBOUND_RECRUIT_1MONTH',
  OutboundRecruit_3Month = 'OUTBOUND_RECRUIT_3MONTH',
  OutboundRecruit_6Month = 'OUTBOUND_RECRUIT_6MONTH',
  OutboundRecruit_12Month = 'OUTBOUND_RECRUIT_12MONTH',
  PaintingInquiry = 'PAINTING_INQUIRY',
  PatioInquiry = 'PATIO_INQUIRY',
  PortfolioPrivateLoan = 'PORTFOLIO_PRIVATE_LOAN',
  PostAppointmentRehash = 'POST_APPOINTMENT_REHASH',
  PrecisionRiskManagementSd = 'PRECISION_RISK_MANAGEMENT_SD',
  Preconstruction_3Month = 'PRECONSTRUCTION_3MONTH',
  Preconstruction_6Month = 'PRECONSTRUCTION_6MONTH',
  PropertyManagement = 'PROPERTY_MANAGEMENT',
  Renter = 'RENTER',
  Renter_1Month = 'RENTER_1MONTH',
  Renter_3Month = 'RENTER_3MONTH',
  Renter_6Month = 'RENTER_6MONTH',
  Renter_12Month = 'RENTER_12MONTH',
  RenterCommercial = 'RENTER_COMMERCIAL',
  RenterEmail = 'RENTER_EMAIL',
  RenterEmailText = 'RENTER_EMAIL_TEXT',
  Ren_360 = 'REN_360',
  ReverseMortgage = 'REVERSE_MORTGAGE',
  ReverseMortgage_1Month = 'REVERSE_MORTGAGE_1MONTH',
  ReverseMortgage_3Month = 'REVERSE_MORTGAGE_3MONTH',
  ReverseMortgage_6Month = 'REVERSE_MORTGAGE_6MONTH',
  ReverseMortgage_12Month = 'REVERSE_MORTGAGE_12MONTH',
  ReverseMortgageAprimelending = 'REVERSE_MORTGAGE_APRIMELENDING',
  RoofingInquiry = 'ROOFING_INQUIRY',
  ScreenedPorchSunroomInquiry = 'SCREENED_PORCH_SUNROOM_INQUIRY',
  Seller = 'SELLER',
  Seller_1Month = 'SELLER_1MONTH',
  Seller_3Month = 'SELLER_3MONTH',
  Seller_6Month = 'SELLER_6MONTH',
  Seller_12Month = 'SELLER_12MONTH',
  SellerCashOffer = 'SELLER_CASH_OFFER',
  SellerCashOffer_1Month = 'SELLER_CASH_OFFER_1MONTH',
  SellerCashOffer_3Month = 'SELLER_CASH_OFFER_3MONTH',
  SellerCashOffer_6Month = 'SELLER_CASH_OFFER_6MONTH',
  SellerCashOffer_12Month = 'SELLER_CASH_OFFER_12MONTH',
  SellerContingency = 'SELLER_CONTINGENCY',
  SellerEmail = 'SELLER_EMAIL',
  SellerEmailText = 'SELLER_EMAIL_TEXT',
  SellerOnholdRevival = 'SELLER_ONHOLD_REVIVAL',
  SellerPreclose = 'SELLER_PRECLOSE',
  SellerRevivalEmail = 'SELLER_REVIVAL_EMAIL',
  SellerRevivalEmailText = 'SELLER_REVIVAL_EMAIL_TEXT',
  SellmethehouseOffer = 'SELLMETHEHOUSE_OFFER',
  SidingInquiry = 'SIDING_INQUIRY',
  SmallBusinessLoan = 'SMALL_BUSINESS_LOAN',
  SterlingRiverInsurance = 'STERLING_RIVER_INSURANCE',
  VehicleCashOffer = 'VEHICLE_CASH_OFFER',
  WalkInBath = 'WALK_IN_BATH',
  WetAreaRemodel = 'WET_AREA_REMODEL',
  WinchoiceWindowInquiry = 'WINCHOICE_WINDOW_INQUIRY',
  WinchoiceWindowRehash = 'WINCHOICE_WINDOW_REHASH',
  WindowDoorReplacement = 'WINDOW_DOOR_REPLACEMENT',
  WindowReplacement = 'WINDOW_REPLACEMENT',
  WindowTinting = 'WINDOW_TINTING'
}

export type DefaultDripCampaignType = {
  __typename?: 'DefaultDripCampaignType';
  name?: Maybe<Scalars['String']['output']>;
};

export type DefaultFlowType = {
  __typename?: 'DefaultFlowType';
  domain?: Maybe<Domain>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qualifiers?: Maybe<FlowQualifiersType>;
  script?: Maybe<DefaultScriptType>;
};

export type DefaultIntentType = {
  __typename?: 'DefaultIntentType';
  content?: Maybe<IntentContentType>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DefaultScriptType = {
  __typename?: 'DefaultScriptType';
  content?: Maybe<ScriptContentType>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  defaultFlow?: Maybe<DefaultFlowType>;
  domain?: Maybe<Domain>;
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use custom flows to activate a script */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use custom flows to activate a script */
  leadType?: Maybe<ScriptLeadTypes>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use custom flows to activate a script */
  sourceType?: Maybe<ScriptSourceTypes>;
};

export type DefaultTagType = {
  __typename?: 'DefaultTagType';
  domains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isUpload?: Maybe<Scalars['Boolean']['output']>;
  leadTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeleteAdminUserMutation = {
  __typename?: 'DeleteAdminUserMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAdvancedBehaviorMutation = {
  __typename?: 'DeleteAdvancedBehaviorMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAdvancedCallRoutingMutation = {
  __typename?: 'DeleteAdvancedCallRoutingMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBehaviorMutation = {
  __typename?: 'DeleteBehaviorMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCampaignMutation = {
  __typename?: 'DeleteCampaignMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomFlowMutation = {
  __typename?: 'DeleteCustomFlowMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomIntentMutation = {
  __typename?: 'DeleteCustomIntentMutation';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomScriptMutation = {
  __typename?: 'DeleteCustomScriptMutation';
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  deactivatedCount?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomToolMutation = {
  __typename?: 'DeleteCustomToolMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomizedSlotMutation = {
  __typename?: 'DeleteCustomizedSlotMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomizedStageMutation = {
  __typename?: 'DeleteCustomizedStageMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDirectApiTokenMutation = {
  __typename?: 'DeleteDirectApiTokenMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDirectPlatformWebhookMutation = {
  __typename?: 'DeleteDirectPlatformWebhookMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteKnowledgeBaseMutation = {
  __typename?: 'DeleteKnowledgeBaseMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLeadEnrollmentRuleMutation = {
  __typename?: 'DeleteLeadEnrollmentRuleMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePartnerApiTokenMutation = {
  __typename?: 'DeletePartnerApiTokenMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePartnerUserMutation = {
  __typename?: 'DeletePartnerUserMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePartnerWebhookMutation = {
  __typename?: 'DeletePartnerWebhookMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePromptTemplateMutation = {
  __typename?: 'DeletePromptTemplateMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteResellerApiTokenMutation = {
  __typename?: 'DeleteResellerApiTokenMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTextAiAgentMutation = {
  __typename?: 'DeleteTextAiAgentMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteVoiceAiAgentMutation = {
  __typename?: 'DeleteVoiceAiAgentMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DirectPlatformCustomReportType = {
  __typename?: 'DirectPlatformCustomReportType';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DirectPlatformEmbeddedAppType = {
  __typename?: 'DirectPlatformEmbeddedAppType';
  id: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DirectPlatformTokenType = {
  __typename?: 'DirectPlatformTokenType';
  authorizedScopes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  totalRequests: Scalars['Int']['output'];
};

export type DirectPlatformWebhookEventAckType = {
  __typename?: 'DirectPlatformWebhookEventAckType';
  ack?: Maybe<Scalars['Boolean']['output']>;
  ackAt?: Maybe<Scalars['DateTime']['output']>;
  responses?: Maybe<Array<DirectPlatformWebhookEventResponseType>>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  webhookId: Scalars['String']['output'];
};

export type DirectPlatformWebhookEventPagination = {
  __typename?: 'DirectPlatformWebhookEventPagination';
  count: Scalars['Int']['output'];
  items: Array<DirectPlatformWebhookEventType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
};

export type DirectPlatformWebhookEventResponseType = {
  __typename?: 'DirectPlatformWebhookEventResponseType';
  contentLength?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  requestHeaders?: Maybe<Scalars['String']['output']>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  responseHeaders?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DirectPlatformWebhookEventType = {
  __typename?: 'DirectPlatformWebhookEventType';
  acks: Array<DirectPlatformWebhookEventAckType>;
  customerId?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['GenericScalar']['output'];
  trigger: Scalars['String']['output'];
};

export type DirectPlatformWebhookType = {
  __typename?: 'DirectPlatformWebhookType';
  consecutiveFailures: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  status: WebhookStatusType;
  target: Scalars['String']['output'];
  totalFailedRequests: Scalars['Int']['output'];
  totalSuccessfulRequests: Scalars['Int']['output'];
  triggers: Array<Scalars['String']['output']>;
};

export enum Domain {
  Automotive = 'AUTOMOTIVE',
  FinancialServices = 'FINANCIAL_SERVICES',
  HomeServices = 'HOME_SERVICES',
  Insurance = 'INSURANCE',
  Mortgage = 'MORTGAGE',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Recruiting = 'RECRUITING',
  Software = 'SOFTWARE',
  Solar = 'SOLAR',
  Support = 'SUPPORT',
  Travel = 'TRAVEL'
}

export type DomainType = {
  __typename?: 'DomainType';
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type DoorVisitCoreInsights = {
  __typename?: 'DoorVisitCoreInsights';
  candidateSentiments: Array<CandidateSentiment>;
  conversationSummary?: Maybe<Scalars['String']['output']>;
  conversationalTags: Array<Scalars['String']['output']>;
  customSlots: Array<CustomSlot>;
  hasRecording: Scalars['Boolean']['output'];
  observations: Array<Scalars['String']['output']>;
};

export type DoorVisitCustomSlotFilterOption = {
  __typename?: 'DoorVisitCustomSlotFilterOption';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values: Array<DoorVisitCustomSlotFilterOptionValue>;
};

export type DoorVisitCustomSlotFilterOptionValue = {
  __typename?: 'DoorVisitCustomSlotFilterOptionValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DoorVisitDateRangePreset {
  AllTime = 'ALL_TIME',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export type DoorVisitDetail = {
  __typename?: 'DoorVisitDetail';
  address?: Maybe<Scalars['String']['output']>;
  canvasserId?: Maybe<Scalars['String']['output']>;
  conversationSummary?: Maybe<Scalars['String']['output']>;
  conversationalTags: Array<Scalars['String']['output']>;
  coreCallId?: Maybe<Scalars['String']['output']>;
  coreInsights?: Maybe<DoorVisitCoreInsights>;
  coreLeadId?: Maybe<Scalars['String']['output']>;
  doorVisitId: Scalars['Int']['output'];
  dwellEndedAt: Scalars['DateTime']['output'];
  dwellStartedAt: Scalars['DateTime']['output'];
  foHouseholdId?: Maybe<Scalars['String']['output']>;
  hasClip: Scalars['Boolean']['output'];
  hasSummary: Scalars['Boolean']['output'];
  isPartial: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  matchedHouseholdId?: Maybe<Scalars['String']['output']>;
  observations: Array<Scalars['String']['output']>;
  replayCount: Scalars['Int']['output'];
  reprocessedFromDoorVisitId?: Maybe<Scalars['Int']['output']>;
  sessionId: Scalars['String']['output'];
  visitStatus: Scalars['String']['output'];
  voterName?: Maybe<Scalars['String']['output']>;
};

export type DoorVisitFilterOptions = {
  __typename?: 'DoorVisitFilterOptions';
  canvasserIds: Array<Scalars['String']['output']>;
  customSlots: Array<DoorVisitCustomSlotFilterOption>;
};

export type DoorVisitListFilter = {
  canvasserId?: InputMaybe<Scalars['String']['input']>;
  /** Core custom slot name (calls.slots key) the matched call must have recorded. */
  customSlotName?: InputMaybe<Scalars['String']['input']>;
  /** Narrows customSlotName to a specific raw enum value. Requires customSlotName. */
  customSlotValue?: InputMaybe<Scalars['String']['input']>;
  /** Brokerage-local calendar range. Cannot be combined with dwellStartedFrom or dwellStartedTo. */
  dateRange?: InputMaybe<DoorVisitDateRangePreset>;
  /** Inclusive lower bound (ISO-8601) on dwellStartedAt. */
  dwellStartedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Exclusive upper bound (ISO-8601) on dwellStartedAt. */
  dwellStartedTo?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive brokerage-local calendar date in YYYY-MM-DD format; required for CUSTOM. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive brokerage-local calendar date in YYYY-MM-DD format; required for CUSTOM. */
  throughDate?: InputMaybe<Scalars['String']['input']>;
};

export type DoorVisitListItem = {
  __typename?: 'DoorVisitListItem';
  address?: Maybe<Scalars['String']['output']>;
  canvasserId?: Maybe<Scalars['String']['output']>;
  conversationSummary?: Maybe<Scalars['String']['output']>;
  coreCallId?: Maybe<Scalars['String']['output']>;
  coreLeadId?: Maybe<Scalars['String']['output']>;
  doorVisitId: Scalars['Int']['output'];
  dwellEndedAt: Scalars['DateTime']['output'];
  dwellStartedAt: Scalars['DateTime']['output'];
  foHouseholdId?: Maybe<Scalars['String']['output']>;
  hasClip: Scalars['Boolean']['output'];
  hasSummary: Scalars['Boolean']['output'];
  isPartial: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  matchedHouseholdId?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  visitStatus: Scalars['String']['output'];
  voterName?: Maybe<Scalars['String']['output']>;
};

export type DoorVisitListResult = {
  __typename?: 'DoorVisitListResult';
  calendarTimeZone: Scalars['String']['output'];
  items: Array<DoorVisitListItem>;
  total: Scalars['Int']['output'];
};

export enum DoorVisitListSort {
  Newest = 'NEWEST',
  Oldest = 'OLDEST'
}

export type DoorVisitReportDownload = {
  __typename?: 'DoorVisitReportDownload';
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DoorVisitReportRunResult = {
  __typename?: 'DoorVisitReportRunResult';
  attempt: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureSummary?: Maybe<Scalars['String']['output']>;
  filterSummary: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  processedRows: Scalars['String']['output'];
  requesterName: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: DoorVisitReportStatus;
  totalRows: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DoorVisitReportRunsResult = {
  __typename?: 'DoorVisitReportRunsResult';
  items: Array<DoorVisitReportRunResult>;
  total: Scalars['Int']['output'];
};

export enum DoorVisitReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type DripConfigurationInputType = {
  dripCadence?: InputMaybe<Array<DripResponseInputType>>;
  enableNudge?: InputMaybe<Scalars['Boolean']['input']>;
  suppressedBy?: InputMaybe<BehavioralTriggerInputType>;
};

export type DripConfigurationType = {
  __typename?: 'DripConfigurationType';
  dripCadence?: Maybe<Array<DripResponseType>>;
  enableNudge?: Maybe<Scalars['Boolean']['output']>;
  suppressedBy?: Maybe<BehavioralTriggerType>;
};

export type DripResponseInputType = {
  channel?: InputMaybe<Scalars['String']['input']>;
  delay: BehavioralDelayInputType;
  id?: InputMaybe<Scalars['String']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type DripResponseType = {
  __typename?: 'DripResponseType';
  channel?: Maybe<Scalars['String']['output']>;
  delay?: Maybe<BehavioralDelayType>;
  id?: Maybe<Scalars['ID']['output']>;
  subjectTemplate?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
};

export type EmailIntegrationType = {
  __typename?: 'EmailIntegrationType';
  forwardingEmail?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentActionType = {
  __typename?: 'EnrollmentActionType';
  delay?: Maybe<BehavioralDelayType>;
  fastStart: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export enum EntityCollection {
  Agents = 'AGENTS',
  Brokerages = 'BROKERAGES',
  Teams = 'TEAMS'
}

export enum EntityTypeEnum {
  Account = 'ACCOUNT',
  Team = 'TEAM'
}

export type ExpoDeviceInputType = {
  brand?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  osBuildId?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type FacebookIntegrationType = {
  __typename?: 'FacebookIntegrationType';
  name?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
};

export type FauxIntegrationType = {
  __typename?: 'FauxIntegrationType';
  isEnabled: Scalars['Boolean']['output'];
};

export type FeatureRequestMutationResult = {
  __typename?: 'FeatureRequestMutationResult';
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum FeatureRequestType {
  AiAgentAdvancedTab = 'AI_AGENT_ADVANCED_TAB',
  BiReporting = 'BI_REPORTING'
}

export type FetchTableauEmbedTokenMutation = {
  __typename?: 'FetchTableauEmbedTokenMutation';
  token: Scalars['String']['output'];
};

export type FieldOpsServerInfoType = {
  __typename?: 'FieldOpsServerInfoType';
  time: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type FieldOpsVoter = {
  __typename?: 'FieldOpsVoter';
  firstName?: Maybe<Scalars['String']['output']>;
  household?: Maybe<FieldOpsVoterHousehold>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  voterId: Scalars['String']['output'];
};

export type FieldOpsVoterHousehold = {
  __typename?: 'FieldOpsVoterHousehold';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type FloatSlotValueType = SlotValueType & {
  __typename?: 'FloatSlotValueType';
  fValue?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type FlowQualifiersInputType = {
  condition: Scalars['JSONString']['input'];
};

export type FlowQualifiersType = {
  __typename?: 'FlowQualifiersType';
  condition: Scalars['JSONString']['output'];
};

export type FlowScriptInputType = {
  customScript?: InputMaybe<Scalars['ID']['input']>;
  defaultScript?: InputMaybe<Scalars['ID']['input']>;
  type: FlowScriptTypes;
};

export type FlowScriptType = CustomScriptType | DefaultScriptType;

export enum FlowScriptTypes {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type FollowUpBossCustomFieldType = {
  __typename?: 'FollowUpBossCustomFieldType';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  structurelySlot?: Maybe<Scalars['String']['output']>;
};

export type FollowUpBossOptionsInputType = {
  disableManualLeadImport?: InputMaybe<Scalars['Boolean']['input']>;
  enablePeopleCreatedWebhook?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FollowUpBossOptionsType = {
  __typename?: 'FollowUpBossOptionsType';
  disableManualLeadImport?: Maybe<Scalars['Boolean']['output']>;
  enablePeopleCreatedWebhook?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
};

export type FollowUpBossOptionsV2Type = {
  __typename?: 'FollowUpBossOptionsV2Type';
  accountId?: Maybe<Scalars['String']['output']>;
  autoCreateFauxAgents?: Maybe<Scalars['Boolean']['output']>;
  createContactsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  customFields?: Maybe<Array<Maybe<FollowUpBossCustomFieldType>>>;
  domain?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  searchForLeadsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ForwardEmailsToTargetInbox = {
  __typename?: 'ForwardEmailsToTargetInbox';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateApiKeyMutation = {
  __typename?: 'GenerateApiKeyMutation';
  generatedApiKey?: Maybe<Scalars['String']['output']>;
};

export type GenericReferenceInputType = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type GenericReferenceType = {
  __typename?: 'GenericReferenceType';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeographicBounds = {
  __typename?: 'GeographicBounds';
  east: Scalars['Float']['output'];
  north: Scalars['Float']['output'];
  south: Scalars['Float']['output'];
  west: Scalars['Float']['output'];
};

export type GeographicBoundsInput = {
  east: Scalars['Float']['input'];
  north: Scalars['Float']['input'];
  south: Scalars['Float']['input'];
  west: Scalars['Float']['input'];
};

export type GoHighLevelOptionsType = {
  __typename?: 'GoHighLevelOptionsType';
  autoCreateFauxAgents?: Maybe<Scalars['Boolean']['output']>;
  disableAssignmentMirroringAfterEnrollment?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDisabledByAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  workflowSchemas?: Maybe<Array<Maybe<WorkflowSchemaType>>>;
};

export type GoogleEnrollmentIntegrationType = {
  __typename?: 'GoogleEnrollmentIntegrationType';
  email: Scalars['String']['output'];
  enrolledLeads?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  processedEmails?: Maybe<Scalars['Int']['output']>;
};

export type GoogleIntegrationType = {
  __typename?: 'GoogleIntegrationType';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
};

export type GpsPointInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  capturedAt: Scalars['DateTime']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type HoursOfOperationModeInputType = {
  mode?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
};

export type HoursOfOperationModeType = {
  __typename?: 'HoursOfOperationModeType';
  mode?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
};

export type HubSpotCustomFieldType = {
  __typename?: 'HubSpotCustomFieldType';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  structurelySlot?: Maybe<Scalars['String']['output']>;
};

export type HubSpotOptionsType = {
  __typename?: 'HubSpotOptionsType';
  accountType?: Maybe<Scalars['String']['output']>;
  createContactsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  customFields?: Maybe<Array<Maybe<HubSpotCustomFieldType>>>;
  portalId?: Maybe<Scalars['String']['output']>;
  searchForLeadsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export enum InboundCallRoutingEnum {
  Ai = 'AI',
  BasedOnHours = 'BASED_ON_HOURS',
  Human = 'HUMAN'
}

export type InputAppointmentType = {
  availability?: InputMaybe<Scalars['String']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputBathsType = {
  approx?: InputMaybe<Scalars['Float']['input']>;
  full?: InputMaybe<Scalars['Int']['input']>;
  half?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type InputEntityRefType = {
  collection?: InputMaybe<EntityCollection>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputListingType = {
  address?: InputMaybe<Scalars['String']['input']>;
};

export type InputRangeType = {
  approx?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSearchType = {
  acres?: InputMaybe<InputRangeType>;
  baths?: InputMaybe<InputBathsType>;
  beds?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<InputRangeType>;
  school?: InputMaybe<Scalars['String']['input']>;
  squareFeet?: InputMaybe<InputRangeType>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputSubscriptionSeatBundleType = {
  bundle: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type InputTagsType = {
  bathroom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bedroom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  general?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputTaskType = {
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reminderAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntSlotValueType = SlotValueType & {
  __typename?: 'IntSlotValueType';
  iValue?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type IntegrationProperty = {
  __typename?: 'IntegrationProperty';
  name: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
  value: Scalars['IntegrationId']['output'];
};

export type IntegrationSlotType = {
  __typename?: 'IntegrationSlotType';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationStatusEnum {
  Healthy = 'Healthy',
  NotConfigured = 'NotConfigured',
  NotHealthy = 'NotHealthy'
}

export type IntentContentType = {
  __typename?: 'IntentContentType';
  prePrompts?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  responses?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  slots?: Maybe<Array<Maybe<BlueprintSlotType>>>;
};

export type IntentSlotType = {
  __typename?: 'IntentSlotType';
  name?: Maybe<Scalars['String']['output']>;
  preFilled?: Maybe<Scalars['Boolean']['output']>;
  values?: Maybe<Array<Maybe<SlotValueType>>>;
};

export type IntentType = {
  __typename?: 'IntentType';
  confidence?: Maybe<Scalars['Float']['output']>;
  intentDescription?: Maybe<Scalars['String']['output']>;
  intentName?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<IntentSlotType>>>;
};

export type IntentUpdateContentInputType = {
  inputType: IntentUpdateContentInputTypes;
  slot?: InputMaybe<BlueprintSlotInputType>;
  slotCollection?: InputMaybe<Array<InputMaybe<BlueprintSlotInputType>>>;
  template?: InputMaybe<BlueprintTemplateInputType>;
  templateSet?: InputMaybe<BlueprintTemplateSetInputType>;
  templateSetCollection?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
};

export enum IntentUpdateContentInputTypes {
  Null = 'NULL',
  Slot = 'SLOT',
  SlotCollection = 'SLOT_COLLECTION',
  Template = 'TEMPLATE',
  TemplateSet = 'TEMPLATE_SET',
  TemplateSetCollection = 'TEMPLATE_SET_COLLECTION'
}

export type IntentUpdateFieldInputType = {
  field: Scalars['String']['input'];
  key?: InputMaybe<Scalars['ID']['input']>;
};

export type IntentUpdateOperationInputType = {
  fields: Array<InputMaybe<IntentUpdateFieldInputType>>;
  operation: UpdateOperationTypes;
  options?: InputMaybe<UpdateOptionsInputType>;
  value: IntentUpdateContentInputType;
};

export type InternalPromptTemplateInputType = {
  bedrockNova2Template?: InputMaybe<Scalars['String']['input']>;
  bedrockOpenaiOssTemplate?: InputMaybe<Scalars['String']['input']>;
  gpt41Template?: InputMaybe<Scalars['String']['input']>;
  gpt51Template?: InputMaybe<Scalars['String']['input']>;
  gpt56Template?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type InternalPromptTemplateType = {
  __typename?: 'InternalPromptTemplateType';
  bedrockNova2Template?: Maybe<Scalars['String']['output']>;
  bedrockOpenaiOssTemplate?: Maybe<Scalars['String']['output']>;
  gpt41Template?: Maybe<Scalars['String']['output']>;
  gpt51Template?: Maybe<Scalars['String']['output']>;
  gpt56Template?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  seenMetadataKeys?: Maybe<Array<Scalars['String']['output']>>;
  template?: Maybe<Scalars['String']['output']>;
};

export type InviteAgentsToBrokerageMutation = {
  __typename?: 'InviteAgentsToBrokerageMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteAgentsToTeamMutation = {
  __typename?: 'InviteAgentsToTeamMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteTeamsToBrokerageMutation = {
  __typename?: 'InviteTeamsToBrokerageMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type KnowledgeBaseAnswerInputType = {
  answer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type KnowledgeBaseAnswerType = {
  __typename?: 'KnowledgeBaseAnswerType';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type KnowledgeBaseInputType = {
  customAnswers?: InputMaybe<Array<KnowledgeBaseAnswerInputType>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseType = {
  __typename?: 'KnowledgeBaseType';
  createdAt: Scalars['DateTime']['output'];
  customAnswers?: Maybe<Array<KnowledgeBaseAnswerType>>;
  id?: Maybe<Scalars['ID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadConnectorHqOptionsType = {
  __typename?: 'LeadConnectorHqOptionsType';
  autoCreateFauxAgents?: Maybe<Scalars['Boolean']['output']>;
  disableAssignmentMirroringAfterEnrollment?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDisabledByAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  workflowSchemas?: Maybe<Array<Maybe<WorkflowSchemaType>>>;
};

export type LeadEnrollmentConditionsInputType = {
  condition: Scalars['JSONString']['input'];
};

export type LeadEnrollmentConditionsType = {
  __typename?: 'LeadEnrollmentConditionsType';
  condition: Scalars['JSONString']['output'];
  conditionVersion: Scalars['String']['output'];
};

export type LeadEnrollmentRuleType = {
  __typename?: 'LeadEnrollmentRuleType';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  rule?: Maybe<LeadEnrollmentConditionsType>;
};

export type LeadExportMutation = {
  __typename?: 'LeadExportMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type LeadImportInputType = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalLeadId?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  leadType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optInDate?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['GenericScalar']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadListItemType = {
  __typename?: 'LeadListItemType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemState: Scalars['String']['output'];
  itemStateReason?: Maybe<Scalars['String']['output']>;
  itemType: Scalars['String']['output'];
  leadSource?: Maybe<Scalars['String']['output']>;
  leadType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadListType = {
  __typename?: 'LeadListType';
  bulkActionConcurrency?: Maybe<Scalars['Int']['output']>;
  bulkActionStatus?: Maybe<Scalars['String']['output']>;
  bulkActivityType?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dialerSessionStatus?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  duplicateItems: Scalars['Int']['output'];
  failedItems: Scalars['Int']['output'];
  finishedItems: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  listPurpose: Scalars['String']['output'];
  listType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pauseUntil?: Maybe<Scalars['DateTime']['output']>;
  processingItems: Scalars['Int']['output'];
  remainingItems: Scalars['Int']['output'];
  sortMode: Scalars['String']['output'];
  totalItems: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeadNeedsFollowupReportSummary = {
  __typename?: 'LeadNeedsFollowupReportSummary';
  active: ReportCountWithFilter;
  justLooking: ReportCountWithFilter;
  notInterested: ReportCountWithFilter;
  researching: ReportCountWithFilter;
  total: ReportCountWithFilter;
  unknown: ReportCountWithFilter;
};

export type LeadPerfectionOptionsType = {
  __typename?: 'LeadPerfectionOptionsType';
  clientId?: Maybe<Scalars['String']['output']>;
  dispositionSlots?: Maybe<Array<IntegrationSlotType>>;
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastErrorReason?: Maybe<Scalars['String']['output']>;
  leadSources?: Maybe<Array<Scalars['String']['output']>>;
  leadSubSources?: Maybe<Array<Scalars['String']['output']>>;
  pendingLeadPerfectionApproval?: Maybe<Scalars['Boolean']['output']>;
  productSlots?: Maybe<Array<IntegrationSlotType>>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type LeadQualificationType = {
  __typename?: 'LeadQualificationType';
  agentEngagedCount?: Maybe<Scalars['Int']['output']>;
  agentEngagedPipeline?: Maybe<Scalars['Float']['output']>;
  agentReadyEngagedCount?: Maybe<Scalars['Int']['output']>;
  agentReadyEngagedCountOld?: Maybe<Scalars['Int']['output']>;
  agentReadyNotEngagedCount?: Maybe<Scalars['Int']['output']>;
  appointmentsRequestedCount?: Maybe<Scalars['Int']['output']>;
  appointmentsRequestedPipeline?: Maybe<Scalars['Float']['output']>;
  averageMessagesToResponse?: Maybe<Scalars['Int']['output']>;
  averageMessagesToResponseOld?: Maybe<Scalars['Int']['output']>;
  engagedCount?: Maybe<Scalars['Int']['output']>;
  engagedPipeline?: Maybe<Scalars['Float']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagementRateOld?: Maybe<Scalars['Int']['output']>;
  generalPhoneAppointmentsCount?: Maybe<Scalars['Int']['output']>;
  interestedCount?: Maybe<Scalars['Int']['output']>;
  leadTypeSummary?: Maybe<LeadTypeReportSummary>;
  needsAgentFollowUpCount?: Maybe<Scalars['Int']['output']>;
  needsAgentFollowUpPipeline?: Maybe<Scalars['Float']['output']>;
  needsFollowupSummary?: Maybe<LeadNeedsFollowupReportSummary>;
  notInterestedCount?: Maybe<Scalars['Int']['output']>;
  reportRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  respondedSummary?: Maybe<LeadRespondedReportSummary>;
  showingListingAppointmentsCount?: Maybe<Scalars['Int']['output']>;
  sixMonthsTimeframeCount?: Maybe<Scalars['Int']['output']>;
  threeMonthsTimeframeCount?: Maybe<Scalars['Int']['output']>;
  totalLeadsCount?: Maybe<Scalars['Int']['output']>;
  totalMessagesSent?: Maybe<Scalars['Int']['output']>;
  totalMessagesSentOld?: Maybe<Scalars['Int']['output']>;
};

export type LeadRespondedReportSummary = {
  __typename?: 'LeadRespondedReportSummary';
  interested: ReportCountWithFilter;
  notInterested: ReportCountWithFilter;
  total: ReportCountWithFilter;
  unknownInterested: ReportCountWithFilter;
};

export type LeadRoutingConditionInputType = {
  assignment: GenericReferenceInputType;
  condition: Scalars['JSONString']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type LeadRoutingConditionType = {
  __typename?: 'LeadRoutingConditionType';
  assignment: GenericReferenceType;
  condition: Scalars['JSONString']['output'];
  conditionVersion: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type LeadRoutingSettingsInputType = {
  conditions: Array<LeadRoutingConditionInputType>;
  overwriteAssignedAgent: Scalars['Boolean']['input'];
};

export type LeadRoutingSettingsType = {
  __typename?: 'LeadRoutingSettingsType';
  conditions: Array<LeadRoutingConditionType>;
  overwriteAssignedAgent: Scalars['Boolean']['output'];
};

export type LeadTypeReportSummary = {
  __typename?: 'LeadTypeReportSummary';
  buyer: ReportCountWithFilter;
  homeRefinance: ReportCountWithFilter;
  investor: ReportCountWithFilter;
  justLooking: ReportCountWithFilter;
  newHomeLoan: ReportCountWithFilter;
  pendingSaleInterest: ReportCountWithFilter;
  rentToOwn: ReportCountWithFilter;
  renter: ReportCountWithFilter;
  seller: ReportCountWithFilter;
  total: ReportCountWithFilter;
  unknown: ReportCountWithFilter;
};

export type LeadUploadMappingType = {
  __typename?: 'LeadUploadMappingType';
  id: Scalars['ID']['output'];
  mapping: Array<Maybe<MappingSheetType>>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ListingType = {
  __typename?: 'ListingType';
  address?: Maybe<Scalars['String']['output']>;
};

export type LiteCustomerType = {
  __typename?: 'LiteCustomerType';
  agentHasEngaged?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstContact?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastContact?: Maybe<Scalars['DateTime']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  supportsCalling?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveChatPlatformType = {
  __typename?: 'LiveChatPlatformType';
  accountId?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LiveTextAiAgentConversationMutation = {
  __typename?: 'LiveTextAIAgentConversationMutation';
  conversation?: Maybe<Array<Maybe<ChatCompletionMessageType>>>;
};

export type LiveTransferAnalyticsType = {
  __typename?: 'LiveTransferAnalyticsType';
  analyticsCollected: Scalars['Boolean']['output'];
  callWasLiveTransferred: Scalars['Boolean']['output'];
  collectionFailed?: Maybe<Scalars['Boolean']['output']>;
  collectionFailedReason?: Maybe<Scalars['String']['output']>;
  liveTransferAgentSpoke?: Maybe<Scalars['Boolean']['output']>;
  liveTransferAnsweredBy?: Maybe<Scalars['String']['output']>;
  liveTransferDuration?: Maybe<Scalars['Int']['output']>;
  liveTransferEnd?: Maybe<Scalars['DateTime']['output']>;
  liveTransferLegStatus?: Maybe<Scalars['String']['output']>;
  liveTransferLlmDisposition?: Maybe<Scalars['String']['output']>;
  liveTransferNlpDisposition?: Maybe<Scalars['String']['output']>;
  liveTransferReasoning?: Maybe<Scalars['String']['output']>;
  liveTransferStart?: Maybe<Scalars['DateTime']['output']>;
  liveTransferSuccessful?: Maybe<Scalars['Boolean']['output']>;
  liveTransferVendorCallId?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['String']['output'];
};

export type LocalPresenceConditionInputType = {
  condition: Scalars['JSONString']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  slotActions?: InputMaybe<Array<LocalPresenceSlotActionInputType>>;
  smsChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type LocalPresenceConditionType = {
  __typename?: 'LocalPresenceConditionType';
  condition: Scalars['JSONString']['output'];
  conditionVersion: Scalars['String']['output'];
  controlTextChannel?: Maybe<Scalars['String']['output']>;
  controlVoiceChannel?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slotActions?: Maybe<Array<LocalPresenceSlotActionType>>;
  smsChannel?: Maybe<CommunicationChannelType>;
  smsChannelId?: Maybe<Scalars['String']['output']>;
};

export type LocalPresenceSettingsInputType = {
  conditions: Array<LocalPresenceConditionInputType>;
  isEnabled: Scalars['Boolean']['input'];
  noMatchRejectLead: Scalars['Boolean']['input'];
};

export type LocalPresenceSettingsType = {
  __typename?: 'LocalPresenceSettingsType';
  conditions: Array<LocalPresenceConditionType>;
  isEnabled: Scalars['Boolean']['output'];
  noMatchRejectLead: Scalars['Boolean']['output'];
};

export type LocalPresenceSlotActionInputType = {
  slotName: Scalars['String']['input'];
  slotValue?: InputMaybe<Scalars['String']['input']>;
};

export type LocalPresenceSlotActionType = {
  __typename?: 'LocalPresenceSlotActionType';
  slotName: Scalars['String']['output'];
  slotValue?: Maybe<Scalars['String']['output']>;
};

export type MailboxLabelType = {
  __typename?: 'MailboxLabelType';
  emails?: Maybe<Array<Scalars['ID']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  knownLeadSource?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MailboxRuleInputType = {
  check: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inbox: Scalars['String']['input'];
  label: Scalars['String']['input'];
  rules: Array<MailboxRuleSourceInputType>;
};

export type MailboxRuleNegativeSourceInputType = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type MailboxRuleNegativeSourceType = {
  __typename?: 'MailboxRuleNegativeSourceType';
  body?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type MailboxRuleSourceInputType = {
  body?: InputMaybe<Array<Scalars['String']['input']>>;
  fromAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  negativeRules?: InputMaybe<Array<MailboxRuleNegativeSourceInputType>>;
  subject?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MailboxRuleSourceType = {
  __typename?: 'MailboxRuleSourceType';
  body?: Maybe<Array<Scalars['String']['output']>>;
  fromAddress?: Maybe<Array<Scalars['String']['output']>>;
  negativeRules?: Maybe<Array<MailboxRuleNegativeSourceType>>;
  subject?: Maybe<Array<Scalars['String']['output']>>;
};

export type MailboxRuleType = {
  __typename?: 'MailboxRuleType';
  check?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Scalars['ID']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  inbox?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  labelId?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<MailboxRuleSourceType>>;
};

export type MailgunDomainType = {
  __typename?: 'MailgunDomainType';
  domain?: Maybe<DomainType>;
  sendingDnsRecords?: Maybe<Array<Maybe<SendingDnsRecordType>>>;
};

export type MailgunIntegrationType = {
  __typename?: 'MailgunIntegrationType';
  fromAddress?: Maybe<Scalars['String']['output']>;
  incomingAddress?: Maybe<Scalars['String']['output']>;
};

export type MailgunPlatformType = {
  __typename?: 'MailgunPlatformType';
  channelType: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  incomingAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MapCursorPageInfo = {
  __typename?: 'MapCursorPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type MappingColumnInputType = {
  columnId?: InputMaybe<Scalars['String']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  slotType?: InputMaybe<Scalars['String']['input']>;
  structurelySlot?: InputMaybe<Scalars['String']['input']>;
};

export type MappingColumnType = {
  __typename?: 'MappingColumnType';
  columnId?: Maybe<Scalars['String']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  slotType?: Maybe<Scalars['String']['output']>;
  structurelySlot?: Maybe<Scalars['String']['output']>;
};

export type MappingSheetInputType = {
  columns?: InputMaybe<Array<MappingColumnInputType>>;
  sheetName?: InputMaybe<Scalars['String']['input']>;
};

export type MappingSheetType = {
  __typename?: 'MappingSheetType';
  columns: Array<Maybe<MappingColumnType>>;
  sheetName: Scalars['String']['output'];
};

export type MarketSharpOptionsType = {
  __typename?: 'MarketSharpOptionsType';
  activityResultSlots?: Maybe<Array<IntegrationSlotType>>;
  activityTypes?: Maybe<Array<Scalars['String']['output']>>;
  appointmentResultReasons?: Maybe<Array<Scalars['String']['output']>>;
  appointmentResultSlots?: Maybe<Array<IntegrationSlotType>>;
  appointmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  companyId?: Maybe<Scalars['String']['output']>;
  inquiryDivisions?: Maybe<Array<Scalars['String']['output']>>;
  inquiryStatuses?: Maybe<Array<Scalars['String']['output']>>;
  isV2?: Maybe<Scalars['Boolean']['output']>;
  leadSources?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  secondaryLeadSources?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
};

export type MessageActionType = {
  __typename?: 'MessageActionType';
  id?: Maybe<Scalars['ID']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type MessageBirdIntegrationType = {
  __typename?: 'MessageBirdIntegrationType';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  webhook?: Maybe<Scalars['String']['output']>;
};

export type MessageBirdPlatformType = {
  __typename?: 'MessageBirdPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type MessageMediaType = {
  __typename?: 'MessageMediaType';
  id: Scalars['ID']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  actions?: Maybe<Array<Maybe<MessageActionType>>>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<ChannelTypeEnum>;
  channelType?: Maybe<Scalars['String']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  deliveryStatusReason?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  hasTextAiResponse?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<Array<MessageMediaType>>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  received?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Sender>;
  serviceSource?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textAiResponse?: Maybe<TextAiResponseType>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type MigrateBrokerageMutation = {
  __typename?: 'MigrateBrokerageMutation';
  result?: Maybe<ResellerAccountType>;
};

export type ModifyDirectApiTokenMutation = {
  __typename?: 'ModifyDirectApiTokenMutation';
  result: DirectPlatformTokenType;
};

export type ModifyDirectPlatformWebhookMutation = {
  __typename?: 'ModifyDirectPlatformWebhookMutation';
  result?: Maybe<DirectPlatformWebhookType>;
};

export type ModifyPartnerApiTokenMutation = {
  __typename?: 'ModifyPartnerApiTokenMutation';
  result: PartnerApiTokenType;
};

export type ModifyPartnerUserMutation = {
  __typename?: 'ModifyPartnerUserMutation';
  result?: Maybe<PartnerUserType>;
};

export type ModifyPartnerWebhookMutation = {
  __typename?: 'ModifyPartnerWebhookMutation';
  result?: Maybe<PartnerWebhookType>;
};

export type ModifyResellerApiTokenMutation = {
  __typename?: 'ModifyResellerApiTokenMutation';
  result: ResellerApiTokenType;
};

export type ModifyResellerClientMutation = {
  __typename?: 'ModifyResellerClientMutation';
  result?: Maybe<ResellerClientType>;
};

export type ModifyResellerUserMutation = {
  __typename?: 'ModifyResellerUserMutation';
  result?: Maybe<ResellerAgentType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accountCallSettings?: Maybe<AccountCallSettingsMutation>;
  activateCustomIntent?: Maybe<ActivateCustomIntentMutation>;
  activateCustomIntentVersion?: Maybe<ActivateCustomIntentVersionMutation>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  activateCustomScript?: Maybe<ActivateCustomScriptMutation>;
  activateCustomScriptVersion?: Maybe<ActivateCustomScriptVersionMutation>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  activateDefaultScript?: Maybe<ActivateDefaultScriptMutation>;
  activateFauxAgent?: Maybe<ConvertFauxAgentToStandardMutation>;
  activatePartnerUserTestMode?: Maybe<ActivatePartnerUserTestModeMutation>;
  addAgentToBrokerage?: Maybe<AddAgentToBrokerageMutation>;
  addAgentToTeam?: Maybe<AddAgentToTeamMutation>;
  addBonzoTwilioIntegration?: Maybe<AddBonzoTwilioIntegrationMutation>;
  addCommioIntegration?: Maybe<AddCommioIntegrationMutation>;
  addCustomTwilioIntegration?: Maybe<AddCustomTwilioIntegrationMutation>;
  addCustomerFilter?: Maybe<AddCustomerFilterMutation>;
  addFacebookIntegration?: Maybe<AddFacebookIntegrationMutation>;
  addFauxIntegration?: Maybe<AddFauxIntegrationMutation>;
  addMailgunDomain?: Maybe<AddMailgunDomainMutation>;
  addMailgunIntegration?: Maybe<AddMailgunIntegrationMutation>;
  addMessageBirdIntegration?: Maybe<AddMessageBirdIntegrationMutation>;
  addNote?: Maybe<AddNoteMutation>;
  addTask?: Maybe<AddTaskMutation>;
  addTeamToBrokerage?: Maybe<AddTeamToBrokerageMutation>;
  addTelnyxIntegration?: Maybe<AddTelnyxIntegrationMutation>;
  addTwilioIntegration?: Maybe<AddTwilioIntegrationMutation>;
  addVonageIntegration?: Maybe<AddVonageIntegrationMutation>;
  addWebchatIntegration?: Maybe<AddWebchatIntegrationMutation>;
  adminUpdateInvoiceType?: Maybe<AdminUpdateInvoiceTypeMutation>;
  adminUpdateStripeConfiguration?: Maybe<AdminUpdateStripeConfiguration>;
  agent?: Maybe<AgentMutation>;
  agentDialerSettings?: Maybe<AgentDialerSettingsMutation>;
  agentRemoveAudioRecording?: Maybe<RemoveAgentAudioRecordingMutation>;
  agentUpdateAudioRecording?: Maybe<UpdateAgentAudioRecordingMutation>;
  archiveAgent?: Maybe<ArchiveAgentMutation>;
  archiveBrokerage?: Maybe<ArchiveBrokerageMutation>;
  archiveTeam?: Maybe<ArchiveTeamMutation>;
  assignCampaignToCustomer?: Maybe<AssignCampaignToCustomerMutation>;
  assignCustomerToAgent?: Maybe<AssignCustomerToAgentMutation>;
  assignCustomerToTeam?: Maybe<AssignCustomerToTeamMutation>;
  assignTaskToAgent?: Maybe<AssignTaskToAgentMutation>;
  assignTcrBrand?: Maybe<AssignTcrBrandMutation>;
  assignTcrCampaign?: Maybe<AssignTcrCampaignMutation>;
  assumeUser?: Maybe<AuthenticationType>;
  batchGpsPoints: Scalars['Boolean']['output'];
  brokerage?: Maybe<BrokerageMutation>;
  bulkTranscribeCanvassingSessions: BulkCanvassingSessionTranscriptionStartResult;
  cancelSeedDataUpload: SeedDataImportDto;
  changePassword?: Maybe<ChangePasswordMutation>;
  /** @deprecated MLS plans have been removed */
  changeSubscriptionPackage?: Maybe<ChangeSubscriptionPackageMutation>;
  claimLeadListItem?: Maybe<ClaimLeadListItemMutation>;
  claimTwilioPhoneNumber?: Maybe<AdminClaimTwilioPhoneNumberMutation>;
  claimVonagePhoneNumber?: Maybe<AdminClaimVonagePhoneNumberMutation>;
  clearCustomerCampaign?: Maybe<ClearCustomerCampaignMutation>;
  cloneDoorVisit: CloneDoorVisitResult;
  compileCincLeadReport?: Maybe<CompileCincLeadReport>;
  compileLionDeskLeadReport?: Maybe<CompileLionDeskLeadReport>;
  confirmSeedDataUpload: SeedDataImportDto;
  confirmSegmentUpload: Scalars['Boolean']['output'];
  consumeCrossLaunchToken?: Maybe<AuthenticationType>;
  copyCampaign?: Maybe<CopyCampaignMutation>;
  copyTextAiAgent?: Maybe<CopyTextAiAgentMutation>;
  copyVoiceAiAgent?: Maybe<CopyVoiceAiAgentMutation>;
  createAcculynxIntegration?: Maybe<CreateAcculynxIntegrationMutation>;
  createAdminUser?: Maybe<CreateAdminUserMutation>;
  createAdvancedBehavior?: Maybe<CreateAdvancedBehaviorMutation>;
  createAdvancedCallRouting?: Maybe<CreateAdvancedCallRoutingMutation>;
  createAgent?: Maybe<CreateAgentMutation>;
  createAgentForBrokerage?: Maybe<CreateAgentForBrokerageMutation>;
  createAgentForTeam?: Maybe<CreateAgentForTeamMutation>;
  createAgentLegendIntegration?: Maybe<CreateAgentLegendIntegrationMutation>;
  createBehavior?: Maybe<CreateBehaviorMutation>;
  createBonzoIntegration?: Maybe<CreateBonzoIntegrationMutation>;
  createBrokerage?: Maybe<CreateBrokerageMutation>;
  createBulkAction?: Maybe<LeadListType>;
  createCampaign?: Maybe<CreateCampaignMutation>;
  createCampaignFromAgents?: Maybe<CreateCampaignFromAgentsMutation>;
  createCanvasserOnboardingToken?: Maybe<CanvasserOnboardingTokenType>;
  createCrossLaunchToken?: Maybe<CrossLaunchTokenType>;
  createCustomFlow?: Maybe<CreateCustomFlowMutation>;
  createCustomPlan?: Maybe<CreateCustomPlanMutation>;
  createCustomScript?: Maybe<CreateCustomScriptMutation>;
  createCustomSlot?: Maybe<CreateCustomizedSlotMutation>;
  createCustomStage?: Maybe<CreateCustomizedStageMutation>;
  createCustomTool?: Maybe<CreateCustomToolMutation>;
  createDirectPlatformApiToken?: Maybe<CreateDirectApiTokenMutation>;
  createDirectPlatformEmbeddedApp?: Maybe<CreateDirectPlatformEmbeddedAppMutation>;
  createDirectPlatformWebhook?: Maybe<CreateDirectPlatformWebhookMutation>;
  createDoorVisitReport: DoorVisitReportRunResult;
  createFollowUpBossV2Integration?: Maybe<CreateFollowUpBossV2Integration>;
  createFromCustomScript?: Maybe<CreateFromCustomScriptMutation>;
  createFromDefaultIntent?: Maybe<CreateFromDefaultIntentMutation>;
  createFromDefaultScript?: Maybe<CreateFromDefaultScriptMutation>;
  createKnowledgeBase?: Maybe<CreateKnowledgeBaseMutation>;
  createLead?: Maybe<CreateLeadMutation>;
  createLeadEnrollmentRule?: Maybe<CreateLeadEnrollmentRuleMutation>;
  createLeadList?: Maybe<CreateLeadListMutation>;
  createLeadListFromFilter?: Maybe<CreateDialingListFromFilterMutation>;
  createLeadPerfectionIntegration?: Maybe<CreateLeadPerfectionIntegrationMutation>;
  createLeadUploadMapping?: Maybe<CreateLeadUploadMappingMutation>;
  createMarketSharpIntegration?: Maybe<CreateMarketSharpIntegrationMutation>;
  createMarketSharpV2Integration?: Maybe<CreateMarketSharpV2IntegrationMutation>;
  createOrUpdateInboxLabel?: Maybe<CreateOrUpdateInboxLabel>;
  createOrUpdateMailboxRule?: Maybe<CreateOrUpdateMailboxRule>;
  createOrUpdateTwilioCommunicationProfile?: Maybe<CreateOrUpdateTwilioCommunicationProfile>;
  createOrUpdateVonageCommunicationProfile?: Maybe<CreateOrUpdateVonageCommunicationProfile>;
  createPartner?: Maybe<CreatePartnerMutation>;
  createPartnerApiToken?: Maybe<CreatePartnerApiTokenMutation>;
  createPartnerUser?: Maybe<CreatePartnerUserMutation>;
  createPartnerWebhook?: Maybe<CreatePartnerWebhookMutation>;
  createPromptTemplate?: Maybe<CreatePromptTemplateMutation>;
  createReseller?: Maybe<CreateResellerMutation>;
  createResellerAgent?: Maybe<CreateResellerUserMutation>;
  createResellerApiToken?: Maybe<CreateResellerApiTokenMutation>;
  createResellerBrokerage?: Maybe<ResellerCreateBrokerageMutation>;
  createSeedDataUpload: CreateSeedDataUploadResult;
  createTcrBrand?: Maybe<CreateTcrBrandMutation>;
  createTcrCampaign?: Maybe<CreateTcrCampaignMutation>;
  /** @deprecated Independent teams are going to be removed */
  createTeam?: Maybe<CreateTeamMutation>;
  createTeamForBrokerage?: Maybe<CreateTeamForBrokerageMutation>;
  createTextAiAgent?: Maybe<CreateTextAiAgentMutation>;
  createVoiceAiAgent?: Maybe<CreateVoiceAiAgentMutation>;
  customer?: Maybe<CustomerMutation>;
  customerBulkAction?: Maybe<CustomerBulkActionMutation>;
  deactivateCustomIntent?: Maybe<DeactivateCustomIntentMutation>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  deactivateCustomScript?: Maybe<DeactivateCustomScriptMutation>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  deactivateDefaultScript?: Maybe<DeactivateDefaultScriptMutation>;
  deleteAdminUser?: Maybe<DeleteAdminUserMutation>;
  deleteAdvancedBehavior?: Maybe<DeleteAdvancedBehaviorMutation>;
  deleteAdvancedCallRouting?: Maybe<DeleteAdvancedCallRoutingMutation>;
  deleteBehavior?: Maybe<DeleteBehaviorMutation>;
  deleteCampaign?: Maybe<DeleteCampaignMutation>;
  deleteCanvassingSessionPipelineJob: Scalars['Boolean']['output'];
  deleteCustomFlow?: Maybe<DeleteCustomFlowMutation>;
  deleteCustomIntent?: Maybe<DeleteCustomIntentMutation>;
  deleteCustomScript?: Maybe<DeleteCustomScriptMutation>;
  deleteCustomSlot?: Maybe<DeleteCustomizedSlotMutation>;
  deleteCustomStage?: Maybe<DeleteCustomizedStageMutation>;
  deleteCustomTool?: Maybe<DeleteCustomToolMutation>;
  deleteDirectPlatformApiToken?: Maybe<DeleteDirectApiTokenMutation>;
  deleteDirectPlatformWebhook?: Maybe<DeleteDirectPlatformWebhookMutation>;
  deleteDoorVisitReport: Scalars['Boolean']['output'];
  deleteKnowledgeBase?: Maybe<DeleteKnowledgeBaseMutation>;
  deleteLeadEnrollmentRule?: Maybe<DeleteLeadEnrollmentRuleMutation>;
  deletePartnerApiToken?: Maybe<DeletePartnerApiTokenMutation>;
  deletePartnerUser?: Maybe<DeletePartnerUserMutation>;
  deletePartnerWebhook?: Maybe<DeletePartnerWebhookMutation>;
  deletePromptTemplate?: Maybe<DeletePromptTemplateMutation>;
  deleteResellerApiToken?: Maybe<DeleteResellerApiTokenMutation>;
  deleteTextAiAgent?: Maybe<DeleteTextAiAgentMutation>;
  deleteVoiceAiAgent?: Maybe<DeleteVoiceAiAgentMutation>;
  endSession: SessionResult;
  exportCanvassingSessions: CanvassingSessionExport;
  featureRequest?: Maybe<FeatureRequestMutationResult>;
  fetchTableauEmbedToken?: Maybe<FetchTableauEmbedTokenMutation>;
  forwardEmailsToTargetInbox?: Maybe<ForwardEmailsToTargetInbox>;
  inviteAgentsToBrokerage?: Maybe<InviteAgentsToBrokerageMutation>;
  inviteAgentsToTeam?: Maybe<InviteAgentsToTeamMutation>;
  inviteTeamsToBrokerage?: Maybe<InviteTeamsToBrokerageMutation>;
  leadExport?: Maybe<LeadExportMutation>;
  liveTextAiAgentConversation?: Maybe<LiveTextAiAgentConversationMutation>;
  liveVoiceAiAgentCall?: Maybe<StartVoiceAiWebCallMutation>;
  logout?: Maybe<ClientLogoutMutation>;
  migrateReseller?: Maybe<MigrateBrokerageMutation>;
  modifyDirectPlatformApiToken?: Maybe<ModifyDirectApiTokenMutation>;
  modifyDirectPlatformWebhook?: Maybe<ModifyDirectPlatformWebhookMutation>;
  modifyPartnerApiToken?: Maybe<ModifyPartnerApiTokenMutation>;
  modifyPartnerUser?: Maybe<ModifyPartnerUserMutation>;
  modifyPartnerWebhook?: Maybe<ModifyPartnerWebhookMutation>;
  modifyResellerAgent?: Maybe<ModifyResellerUserMutation>;
  modifyResellerApiToken?: Maybe<ModifyResellerApiTokenMutation>;
  modifyResellerClient?: Maybe<ModifyResellerClientMutation>;
  onboardCanvasser?: Maybe<AuthenticationType>;
  playBackCall?: Maybe<PlayBackCallMutation>;
  provisionCoreApiToken: CoreConfigurationStatus;
  provisionCoreWebhooks: CoreConfigurationStatus;
  provisionTwilioForAllUsNumbers?: Maybe<AdminProvisionAllUsAreaCodesForTwilioMutation>;
  reactivateCoreWebhooks: CoreConfigurationStatus;
  recordSessionTelemetry: SessionTelemetryBatchResult;
  recreateStripeAccount?: Maybe<RecreateStripeAccountMutation>;
  regenerateApiKey?: Maybe<GenerateApiKeyMutation>;
  registerExpoPushNotifications?: Maybe<RegisterExpoPushNotificationsMutation>;
  reinviteResellerBrokerage?: Maybe<ResellerInviteBrokerageMutation>;
  removeAcculynxIntegration?: Maybe<RemoveAcculynxIntegrationMutation>;
  removeAgentLegendIntegration?: Maybe<RemoveAgentLegendIntegrationMutation>;
  removeBonzoIntegration?: Maybe<RemoveBonzoIntegrationMutation>;
  removeBonzoTwilioIntegration?: Maybe<RemoveBonzoTwilioIntegrationMutation>;
  removeBoomTownIntegration?: Maybe<RemoveBoomTownIntegrationMutation>;
  removeCommioIntegration?: Maybe<RemoveCommioIntegrationMutation>;
  removeFacebookIntegration?: Maybe<RemoveFacebookIntegrationMutation>;
  removeFauxIntegration?: Maybe<RemoveFauxIntegrationMutation>;
  removeFollowUpBossV2Integration?: Maybe<RemoveFollowUpBossV2IntegrationMutation>;
  removeGoHighLevelIntegration?: Maybe<RemoveGoHighLevelIntegrationMutation>;
  removeGoogleEnrollmentIntegration?: Maybe<RemoveGoogleEnrollmentIntegrationMutation>;
  removeGoogleIntegration?: Maybe<RemoveGoogleIntegrationMutation>;
  removeHubSpotV2Integration?: Maybe<RemoveHubSpotV2IntegrationMutation>;
  removeLeadList?: Maybe<RemoveLeadListMutation>;
  removeLeadPerfectionIntegration?: Maybe<RemoveLeadPerfectionIntegrationMutation>;
  removeLeadUploadMapping?: Maybe<RemoveLeadUploadMappingMutation>;
  removeLionDeskIntegration?: Maybe<RemoveLionDeskIntegrationMutation>;
  removeMailgunIntegration?: Maybe<RemoveMailgunIntegrationMutation>;
  removeMarketSharpIntegration?: Maybe<RemoveMarketSharpIntegrationMutation>;
  removeMessageBirdIntegration?: Maybe<RemoveMessageBirdIntegrationMutation>;
  removeSalesForceV2Integration?: Maybe<RemoveSalesForceV2IntegrationMutation>;
  removeTask?: Maybe<RemoveTaskMutation>;
  removeTelnyxIntegration?: Maybe<RemoveTelnyxIntegrationMutation>;
  removeTwilioIntegration?: Maybe<RemoveTwilioIntegrationMutation>;
  removeVonageIntegration?: Maybe<RemoveVonageIntegrationMutation>;
  replayDoorVisit: ReplayDoorVisitResult;
  requestPartnerUserPasswordReset?: Maybe<RequestPartnerResetPasswordMutation>;
  requestResellerAgentPasswordReset?: Maybe<RequestResellerResetPasswordMutation>;
  resellerAssumeRole?: Maybe<ResellerAssumeRoleMutation>;
  resendAuthEmail?: Maybe<ResendAuthEmailMutation>;
  resetConversationUnreadCount?: Maybe<ResetConversationUnreadCountMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  retrievePartnerCaasToken?: Maybe<RetrieveCaasServerTokenMutation>;
  retryDeadPipelineJob?: Maybe<CanvassingSessionPipelineJob>;
  retryDoorVisitReport: DoorVisitReportRunResult;
  retrySeedDataImport: SeedDataImportDto;
  sendAiAgentTestingMessage?: Maybe<SendAiAgentTestingMessageMutation>;
  sendCustomPlanInvite?: Maybe<SendCustomPlanInviteMutation>;
  sendMessage?: Maybe<SendMessageMutation>;
  sendResetPassword?: Maybe<SendResetPasswordMutation>;
  setBoomtownUserTag?: Maybe<SetBoomTownUserTagMutation>;
  setDefaultCampaign?: Maybe<SetDefaultCampaignMutation>;
  setFollowUpBossV2CustomField?: Maybe<SetFollowUpBossV2CustomFieldMutation>;
  setHubSpotV2CustomField?: Maybe<SetHubSpotV2CustomFieldMutation>;
  setSalesForceV2CustomField?: Maybe<SetSalesForceV2CustomFieldMutation>;
  signupForStructurely?: Maybe<SignupAgentMutation>;
  startAiAgentTest?: Maybe<StartAiAgentTestMutation>;
  startAiAgentVoiceTest?: Maybe<StartAiAgentVoiceTestMutation>;
  startCall?: Maybe<StartCallMutation>;
  startCallDigitalAgent?: Maybe<StartCallWithDigitalAgentMutation>;
  startNewConvo?: Maybe<StartNewConvoMutation>;
  startSession: SessionResult;
  stripeCustomerPortal?: Maybe<StripeCustomerPortalSession>;
  team?: Maybe<TeamMutation>;
  testCustomTool?: Maybe<TestCustomToolMutation>;
  thirdPartyIntegrationToggleMuteCustomer?: Maybe<ThirdPartyIntegrationToggleMuteCustomerMutation>;
  transcribeCanvassingSession?: Maybe<SessionTranscriptionRunDto>;
  triggerFollowUpBossTagSync?: Maybe<TriggerFollowUpBossTagSyncMutation>;
  triggerPendingActivity?: Maybe<TriggerPendingActivityMutation>;
  twilioRejectCall?: Maybe<TwilioRejectCallMutation>;
  twilioVoiceGrant?: Maybe<NewTwilioVoiceGrantMutation>;
  unarchiveAgent?: Maybe<UnarchiveAgentMutation>;
  unarchiveBrokerage?: Maybe<UnarchiveBrokerageMutation>;
  unarchiveTeam?: Maybe<UnarchiveTeamMutation>;
  unassignCustomerFromAgent?: Maybe<UnassignCustomerFromAgentMutation>;
  unassignCustomerFromTeam?: Maybe<UnassignCustomerFromTeamMutation>;
  unassignTaskFromAgent?: Maybe<UnassignTaskFromAgentMutation>;
  unassignTcrBrand?: Maybe<UnassignTcrBrandMutation>;
  unassignTcrCampaign?: Maybe<UnassignTcrCampaignMutation>;
  unregisterExpoPushNotifications?: Maybe<UnregisterExpoPushNotificationsMutation>;
  updateAdminUser?: Maybe<UpdateAdminUserMutation>;
  updateAdvancedBehavior?: Maybe<UpdateAdvancedBehaviorMutation>;
  updateAdvancedCallRouting?: Maybe<UpdateAdvancedCallRoutingMutation>;
  updateAgentPermissions?: Maybe<UpdateAgentPermissionsMutation>;
  updateAppointmentSchedulingSettings?: Maybe<UpdateAppointmentSchedulingSettingsMutation>;
  updateBehavior?: Maybe<UpdateBehaviorMutation>;
  updateBonzoIntegration?: Maybe<UpdateBonzoSettingsMutation>;
  updateBusinessOps?: Maybe<AdminUpdateAccountOpsMutation>;
  updateCall?: Maybe<UpdateCallMutation>;
  updateCampaign?: Maybe<UpdateCampaignMutation>;
  updateCampaignFromAgents?: Maybe<UpdateCampaignFromAgentsMutation>;
  updateChannelCampaignAttachment?: Maybe<UpdateChannelCampaignAttachmentMutation>;
  updateChannelDigitalVoiceAssistant?: Maybe<UpdateChannelDigitalVoiceAssistantMutation>;
  updateChannelDisabled?: Maybe<UpdateChannelDisabledMutation>;
  updateChannelSetPrimary?: Maybe<UpdateChannelSetPrimary>;
  updateCustomFlow?: Maybe<UpdateCustomFlowMutation>;
  updateCustomIntentVersion?: Maybe<UpdateCustomIntentVersionMutation>;
  updateCustomSchemaResponseAnnotation?: Maybe<UpdateCustomSchemaResponseAnnotation>;
  updateCustomScript?: Maybe<UpdateCustomScriptMutation>;
  updateCustomScriptVersion?: Maybe<UpdateCustomScriptVersionMutation>;
  updateCustomSlot?: Maybe<UpdateCustomizedSlotMutation>;
  updateCustomStage?: Maybe<UpdateCustomizedStageMutation>;
  updateCustomTool?: Maybe<UpdateCustomToolMutation>;
  updateCustomerCampaignStage?: Maybe<UpdateCustomerCampaignStageMutation>;
  updateCustomerFilter?: Maybe<UpdateCustomerFilterMutation>;
  updateFeatureFlags?: Maybe<AdminUpdateFeatureFlagsMutation>;
  updateFollowUpBossV2Settings?: Maybe<UpdateFollowUpBossV2SettingsMutation>;
  updateGoHighLevelIntegration?: Maybe<UpdateGoHighLevelMutation>;
  updateHubSpotV2Settings?: Maybe<UpdateHubSpotV2SettingsMutation>;
  updateInternalPromptTemplate?: Maybe<UpdateInternalPromptTemplateMutation>;
  updateKnowledgeBase?: Maybe<UpdateKnowledgeBaseMutation>;
  updateLeadEnrollmentRule?: Maybe<UpdateLeadEnrollmentRuleMutation>;
  updateLeadList?: Maybe<UpdateLeadListMutation>;
  updateLeadRoutingSettings?: Maybe<UpdateLeadRoutingSettingsMutation>;
  updateLeadUploadMapping?: Maybe<UpdateLeadUploadMappingMutation>;
  updateLocalPresenceSettings?: Maybe<UpdateLocalPresenceSettingsMutation>;
  updatePartnerCaas?: Maybe<UpdateCaasSettingsMutation>;
  updatePromptTemplate?: Maybe<UpdatePromptTemplateMutation>;
  updatePubSubSubscription?: Maybe<UpdatePubSubSubscription>;
  updateSalesForceV2Settings?: Maybe<UpdateSalesForceSettingsMutation>;
  updateSchedulingSettings?: Maybe<UpdateSchedulingSettingsMutation>;
  updateSubscription?: Maybe<UpdateSubscriptionMutation>;
  updateSubscriptionCard?: Maybe<UpdateSubscriptionCardMutation>;
  updateTask?: Maybe<UpdateTaskMutation>;
  updateTextAiAgent?: Maybe<UpdateTextAiAgentMutation>;
  updateTwilioA2pProfile?: Maybe<UpdateTwilioA2PProfile>;
  updateTwilioA2pRequired?: Maybe<UpdateTwilioA2PRequired>;
  updateVoiceAiAgent?: Maybe<UpdateVoiceAiAgentMutation>;
  updateVonageA2pProfile?: Maybe<UpdateVonageA2PProfile>;
  updateVonageChannelCallControlMode?: Maybe<UpdateVonageChannelCallControlMode>;
  uploadUrl: UploadUrlResult;
  validateAgent?: Maybe<ValidateAgentMutation>;
  validatePartnerUserInvitation?: Maybe<ValidatePartnerUserInvitationMutation>;
  validatePartnerUserPasswordReset?: Maybe<ValidatePartnerResetPasswordMutation>;
  validateResellerAgentInvitation?: Maybe<ValidateResellerUserInvitationMutation>;
  validateResellerAgentPasswordReset?: Maybe<ValidateResellerResetPasswordMutation>;
  verifyMailgunDomain?: Maybe<VerifyMailgunDomainMutation>;
  verifyResellerBrokerage?: Maybe<VerifyResellerBrokerageMutation>;
};


export type MutationAccountCallSettingsArgs = {
  callsPerDay?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationActivateCustomIntentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateCustomIntentVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateCustomScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type MutationActivateCustomScriptVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateDefaultScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type MutationActivateFauxAgentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivatePartnerUserTestModeArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAddAgentToBrokerageArgs = {
  accessToken: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddAgentToTeamArgs = {
  accessToken: Scalars['String']['input'];
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddBonzoTwilioIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCommioIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCustomTwilioIntegrationArgs = {
  accountSid: Scalars['String']['input'];
  accountToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddCustomerFilterArgs = {
  agentId: Scalars['ID']['input'];
  customerFilter: CustomerFilterInputType;
};


export type MutationAddFacebookIntegrationArgs = {
  id: Scalars['ID']['input'];
  pageAccessToken: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddFauxIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddMailgunDomainArgs = {
  domain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddMailgunIntegrationArgs = {
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddMessageBirdIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNoteArgs = {
  customerId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationAddTaskArgs = {
  customerId: Scalars['ID']['input'];
  task: InputTaskType;
};


export type MutationAddTeamToBrokerageArgs = {
  accessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAddTelnyxIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddTwilioIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddVonageIntegrationArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddWebchatIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUpdateInvoiceTypeArgs = {
  invoiceId: Scalars['ID']['input'];
  lineItems: Array<BillingInvoiceLineItemInvoiceTypeOverrideInput>;
};


export type MutationAdminUpdateStripeConfigurationArgs = {
  id: Scalars['ID']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
};


export type MutationAgentArgs = {
  agencyName?: InputMaybe<Scalars['String']['input']>;
  allowMultiConversations?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mlsNeeded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mlsProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  priceAvg?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<AgentSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};


export type MutationAgentDialerSettingsArgs = {
  dialerSettings: AgentDialerSettingsInputType;
  id: Scalars['ID']['input'];
};


export type MutationAgentRemoveAudioRecordingArgs = {
  id: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
};


export type MutationAgentUpdateAudioRecordingArgs = {
  id: Scalars['ID']['input'];
  isGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingId: Scalars['ID']['input'];
};


export type MutationArchiveAgentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveBrokerageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignCampaignToCustomerArgs = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  startNew?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAssignCustomerToAgentArgs = {
  agentId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationAssignCustomerToTeamArgs = {
  customerId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAssignTaskToAgentArgs = {
  agentId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationAssignTcrBrandArgs = {
  id: Scalars['ID']['input'];
  tcrBrandId: Scalars['String']['input'];
};


export type MutationAssignTcrCampaignArgs = {
  id: Scalars['ID']['input'];
  tcrCampaignId: Scalars['String']['input'];
};


export type MutationAssumeUserArgs = {
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationBatchGpsPointsArgs = {
  points: Array<GpsPointInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationBrokerageArgs = {
  allowMembersTesting?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultiConversations?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fauxAgentsInheritHoursOfOperation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  priceAvg?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<BrokerageSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};


export type MutationBulkTranscribeCanvassingSessionsArgs = {
  filter: BulkCanvassingSessionTranscriptionFilter;
};


export type MutationCancelSeedDataUploadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChangeSubscriptionPackageArgs = {
  id: Scalars['ID']['input'];
  mlsPlan?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationClaimLeadListItemArgs = {
  id: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};


export type MutationClaimTwilioPhoneNumberArgs = {
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimVonagePhoneNumberArgs = {
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearCustomerCampaignArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationCloneDoorVisitArgs = {
  doorVisitId: Scalars['Int']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationCompileCincLeadReportArgs = {
  clientId: Scalars['Int']['input'];
  recipient: Scalars['String']['input'];
};


export type MutationCompileLionDeskLeadReportArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  recipient: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmSeedDataUploadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmSegmentUploadArgs = {
  input: ConfirmSegmentUploadInput;
};


export type MutationConsumeCrossLaunchTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationCopyCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  campaignName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  textAgentName?: InputMaybe<Scalars['String']['input']>;
  voiceAgentName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyTextAiAgentArgs = {
  agentId: Scalars['ID']['input'];
  agentName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCopyVoiceAiAgentArgs = {
  agentId: Scalars['ID']['input'];
  agentName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateAcculynxIntegrationArgs = {
  apiToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateAdminUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreateAdvancedBehaviorArgs = {
  behavior: AdvancedBehaviorInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateAdvancedCallRoutingArgs = {
  id: Scalars['ID']['input'];
  rule: AdvancedCallRoutingInputType;
};


export type MutationCreateAgentArgs = {
  agencyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mlsNeeded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mlsPlan?: InputMaybe<Scalars['Boolean']['input']>;
  mlsProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<AgentSettingsInputType>;
  stripeCoupon?: InputMaybe<Scalars['String']['input']>;
  stripeCouponToken?: InputMaybe<Scalars['String']['input']>;
  stripeToken: Scalars['String']['input'];
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  useHatchIsaScripts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAgentForBrokerageArgs = {
  accessToken: Scalars['String']['input'];
  agent: AgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateAgentForTeamArgs = {
  accessToken: Scalars['String']['input'];
  agent: AgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateAgentLegendIntegrationArgs = {
  accountId: Scalars['String']['input'];
  authToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateBehaviorArgs = {
  behavior: BehaviorInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateBonzoIntegrationArgs = {
  apiToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateBrokerageArgs = {
  agent: AgentInputType;
  brokerage: BrokerageInputType;
  isFranchise?: InputMaybe<Scalars['Boolean']['input']>;
  isZendesk?: InputMaybe<Scalars['Boolean']['input']>;
  mlsPlan?: InputMaybe<Scalars['Boolean']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planToken?: InputMaybe<Scalars['String']['input']>;
  stripeCoupon?: InputMaybe<Scalars['String']['input']>;
  stripeCouponToken?: InputMaybe<Scalars['String']['input']>;
  stripeToken: Scalars['String']['input'];
  useHatchIsaScripts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBulkActionArgs = {
  action: BulkActionInput;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  leads: Array<Scalars['ID']['input']>;
};


export type MutationCreateCampaignArgs = {
  campaign: CampaignInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateCampaignFromAgentsArgs = {
  campaign: CampaignAgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateCanvasserOnboardingTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateCrossLaunchTokenArgs = {
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateCustomFlowArgs = {
  entity: InputEntityRefType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  qualifiers: FlowQualifiersInputType;
  script: FlowScriptInputType;
};


export type MutationCreateCustomPlanArgs = {
  amount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCustomScriptArgs = {
  entity: InputEntityRefType;
  name: Scalars['String']['input'];
};


export type MutationCreateCustomSlotArgs = {
  id: Scalars['String']['input'];
  slot: CustomizedSlotInputType;
};


export type MutationCreateCustomStageArgs = {
  id: Scalars['String']['input'];
  stage: CustomizedStageInputType;
};


export type MutationCreateCustomToolArgs = {
  id: Scalars['ID']['input'];
  tool: CustomToolDefinitionInputType;
};


export type MutationCreateDirectPlatformApiTokenArgs = {
  id: Scalars['ID']['input'];
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateDirectPlatformEmbeddedAppArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateDirectPlatformWebhookArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  target: Scalars['String']['input'];
  triggers: Array<Scalars['String']['input']>;
};


export type MutationCreateDoorVisitReportArgs = {
  input: CreateDoorVisitReportInput;
};


export type MutationCreateFollowUpBossV2IntegrationArgs = {
  accessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateFromCustomScriptArgs = {
  customScriptId: Scalars['ID']['input'];
  entity: InputEntityRefType;
  name: Scalars['String']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationCreateFromDefaultIntentArgs = {
  defaultIntentId: Scalars['ID']['input'];
  entity: InputEntityRefType;
};


export type MutationCreateFromDefaultScriptArgs = {
  defaultScriptId: Scalars['ID']['input'];
  entity: InputEntityRefType;
  name: Scalars['String']['input'];
};


export type MutationCreateKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  knowledgeBase: KnowledgeBaseInputType;
};


export type MutationCreateLeadArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testPayloadClearDupeLeads?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLeadEnrollmentRuleArgs = {
  entity: InputEntityRefType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  rule: LeadEnrollmentConditionsInputType;
};


export type MutationCreateLeadListArgs = {
  id: Scalars['ID']['input'];
  leads: Array<LeadImportInputType>;
  name: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
};


export type MutationCreateLeadListFromFilterArgs = {
  filterName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateLeadPerfectionIntegrationArgs = {
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreateLeadUploadMappingArgs = {
  id: Scalars['ID']['input'];
  mapping: Array<InputMaybe<MappingSheetInputType>>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateMarketSharpIntegrationArgs = {
  apiKey: Scalars['String']['input'];
  apiSecret: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateMarketSharpV2IntegrationArgs = {
  companyId: Scalars['String']['input'];
  empoid: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCreateOrUpdateInboxLabelArgs = {
  imageUrl: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateOrUpdateMailboxRuleArgs = {
  mailboxRule: MailboxRuleInputType;
};


export type MutationCreateOrUpdateTwilioCommunicationProfileArgs = {
  id: Scalars['ID']['input'];
  profile: TwilioProfileInputType;
};


export type MutationCreateOrUpdateVonageCommunicationProfileArgs = {
  id: Scalars['ID']['input'];
  profile: VonageProfileInputType;
};


export type MutationCreatePartnerArgs = {
  clientAuthToken?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreatePartnerApiTokenArgs = {
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ttl?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationCreatePartnerUserArgs = {
  email: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreatePartnerWebhookArgs = {
  name: Scalars['String']['input'];
  partnerId: Scalars['ID']['input'];
  target: Scalars['String']['input'];
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreatePromptTemplateArgs = {
  associatedEntity?: InputMaybe<Scalars['String']['input']>;
  prompt: PromptTemplateInputType;
};


export type MutationCreateResellerArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  resellerName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateResellerAgentArgs = {
  email: Scalars['String']['input'];
  isResellerAdmin: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateResellerApiTokenArgs = {
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['ID']['input'];
};


export type MutationCreateResellerBrokerageArgs = {
  brokerageName: Scalars['String']['input'];
  conversationOverageCents: Scalars['Int']['input'];
  conversationsPerInterval: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  resellerId: Scalars['ID']['input'];
};


export type MutationCreateSeedDataUploadArgs = {
  input: CreateSeedDataUploadInput;
};


export type MutationCreateTcrBrandArgs = {
  associatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  input: CreateTcrBrandInputType;
};


export type MutationCreateTcrCampaignArgs = {
  associatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  input: CreateTcrCampaignInputType;
};


export type MutationCreateTeamArgs = {
  agent: AgentInputType;
  mlsPlan?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCoupon?: InputMaybe<Scalars['String']['input']>;
  stripeCouponToken?: InputMaybe<Scalars['String']['input']>;
  stripeToken: Scalars['String']['input'];
  team: TeamInputType;
  useHatchIsaScripts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTeamForBrokerageArgs = {
  accessToken: Scalars['String']['input'];
  agent: AgentInputType;
  id: Scalars['ID']['input'];
  team: TeamInputType;
};


export type MutationCreateTextAiAgentArgs = {
  agent: TextAiAgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationCreateVoiceAiAgentArgs = {
  agent: VoiceAiAgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationCustomerArgs = {
  agentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  appointment?: InputMaybe<InputAppointmentType>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  autoInsuranceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  buyerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  chatbotMuted?: InputMaybe<Scalars['Boolean']['input']>;
  chatbotVoiceMuted?: InputMaybe<Scalars['Boolean']['input']>;
  contingencyStatus?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financingStatus?: InputMaybe<Scalars['Boolean']['input']>;
  homeRefinanceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  leadTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listing?: InputMaybe<InputListingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  newHomeLoanStatus?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  readiness?: InputMaybe<Scalars['String']['input']>;
  renterStatus?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<InputSearchType>;
  sellerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<InputTagsType>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomerBulkActionArgs = {
  action: CustomerBulkActionInputType;
  entity: InputEntityRefType;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateCustomIntentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateCustomScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type MutationDeactivateDefaultScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdvancedBehaviorArgs = {
  behaviorId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdvancedCallRoutingArgs = {
  id: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
};


export type MutationDeleteBehaviorArgs = {
  behaviorId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteCanvassingSessionPipelineJobArgs = {
  jobId: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationDeleteCustomFlowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomIntentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomScriptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomSlotArgs = {
  id: Scalars['String']['input'];
  slotId: Scalars['ID']['input'];
};


export type MutationDeleteCustomStageArgs = {
  id: Scalars['String']['input'];
  stageId: Scalars['ID']['input'];
};


export type MutationDeleteCustomToolArgs = {
  id: Scalars['ID']['input'];
  toolId: Scalars['ID']['input'];
};


export type MutationDeleteDirectPlatformApiTokenArgs = {
  id: Scalars['ID']['input'];
  tokenId: Scalars['ID']['input'];
};


export type MutationDeleteDirectPlatformWebhookArgs = {
  id: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};


export type MutationDeleteDoorVisitReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  kbId: Scalars['ID']['input'];
};


export type MutationDeleteLeadEnrollmentRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePartnerApiTokenArgs = {
  tokenId: Scalars['ID']['input'];
};


export type MutationDeletePartnerUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeletePartnerWebhookArgs = {
  webhookId: Scalars['ID']['input'];
};


export type MutationDeletePromptTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResellerApiTokenArgs = {
  tokenId: Scalars['ID']['input'];
};


export type MutationDeleteTextAiAgentArgs = {
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteVoiceAiAgentArgs = {
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationEndSessionArgs = {
  expectedSegmentCount?: InputMaybe<Scalars['Int']['input']>;
  gpsPointCount?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type MutationExportCanvassingSessionsArgs = {
  filter: CanvassingSessionExportFilter;
};


export type MutationFeatureRequestArgs = {
  featureType: FeatureRequestType;
  id: Scalars['ID']['input'];
};


export type MutationFetchTableauEmbedTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationForwardEmailsToTargetInboxArgs = {
  emailIds: Array<Scalars['ID']['input']>;
  targetInbox: Scalars['String']['input'];
};


export type MutationInviteAgentsToBrokerageArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  agents: Array<InputMaybe<AgentInviteType>>;
  id: Scalars['ID']['input'];
};


export type MutationInviteAgentsToTeamArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  agents: Array<InputMaybe<AgentInviteType>>;
  id: Scalars['ID']['input'];
};


export type MutationInviteTeamsToBrokerageArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  teams: Array<InputMaybe<TeamInviteType>>;
};


export type MutationLeadExportArgs = {
  entityId: Scalars['ID']['input'];
  exportConvo?: InputMaybe<Scalars['Boolean']['input']>;
  leadCountFrom?: InputMaybe<Scalars['Int']['input']>;
  leadCountTo?: InputMaybe<Scalars['Int']['input']>;
  notifyEmails: Scalars['String']['input'];
};


export type MutationLiveTextAiAgentConversationArgs = {
  agent: TextAiAgentInputType;
  conversation?: InputMaybe<Array<InputMaybe<ChatCompletionMessageInputType>>>;
  generateDrips?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationLiveVoiceAiAgentCallArgs = {
  agent: VoiceAiAgentInputType;
  id: Scalars['ID']['input'];
};


export type MutationMigrateResellerArgs = {
  brokerageId: Scalars['String']['input'];
};


export type MutationModifyDirectPlatformApiTokenArgs = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  tokenId: Scalars['ID']['input'];
};


export type MutationModifyDirectPlatformWebhookArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WebhookMutationStatusType>;
  target?: InputMaybe<Scalars['String']['input']>;
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
  webhookId: Scalars['ID']['input'];
};


export type MutationModifyPartnerApiTokenArgs = {
  isActive: Scalars['Boolean']['input'];
  tokenId: Scalars['ID']['input'];
};


export type MutationModifyPartnerUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationModifyPartnerWebhookArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
  webhookId: Scalars['ID']['input'];
};


export type MutationModifyResellerAgentArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isResellerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationModifyResellerApiTokenArgs = {
  isActive: Scalars['Boolean']['input'];
  tokenId: Scalars['ID']['input'];
};


export type MutationModifyResellerClientArgs = {
  clientId: Scalars['String']['input'];
  conversationOverageCents?: InputMaybe<Scalars['Int']['input']>;
  conversationsPerInterval?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  resellerId: Scalars['ID']['input'];
};


export type MutationOnboardCanvasserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationPlayBackCallArgs = {
  callId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationProvisionTwilioForAllUsNumbersArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecordSessionTelemetryArgs = {
  input: SessionTelemetryBatchInput;
};


export type MutationRecreateStripeAccountArgs = {
  id: Scalars['ID']['input'];
  testClock?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegenerateApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterExpoPushNotificationsArgs = {
  device?: InputMaybe<ExpoDeviceInputType>;
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationReinviteResellerBrokerageArgs = {
  brokerageId: Scalars['String']['input'];
  resellerId: Scalars['ID']['input'];
};


export type MutationRemoveAcculynxIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveAgentLegendIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveBonzoIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveBonzoTwilioIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRemoveBoomTownIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCommioIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRemoveFacebookIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFauxIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFollowUpBossV2IntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveGoHighLevelIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveGoogleEnrollmentIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveGoogleIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveHubSpotV2IntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveLeadListArgs = {
  id: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};


export type MutationRemoveLeadPerfectionIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveLeadUploadMappingArgs = {
  id: Scalars['ID']['input'];
  mappingId: Scalars['ID']['input'];
};


export type MutationRemoveLionDeskIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMailgunIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMarketSharpIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMessageBirdIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRemoveSalesForceV2IntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveTaskArgs = {
  customerId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationRemoveTelnyxIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRemoveTwilioIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationRemoveVonageIntegrationArgs = {
  id: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationReplayDoorVisitArgs = {
  doorVisitId: Scalars['Int']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationRequestPartnerUserPasswordResetArgs = {
  requestedById: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRequestResellerAgentPasswordResetArgs = {
  requestedById: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResellerAssumeRoleArgs = {
  actingUserId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  resellerId: Scalars['ID']['input'];
};


export type MutationResendAuthEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetConversationUnreadCountArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  accessToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationRetrievePartnerCaasTokenArgs = {
  partnerId: Scalars['ID']['input'];
};


export type MutationRetryDeadPipelineJobArgs = {
  jobId: Scalars['Int']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationRetryDoorVisitReportArgs = {
  reportId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationRetrySeedDataImportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendAiAgentTestingMessageArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['GenericScalar']['input']>;
  text: Scalars['String']['input'];
};


export type MutationSendCustomPlanInviteArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  trialPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendMessageArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  integrationType?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationSendResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetBoomtownUserTagArgs = {
  id: Scalars['ID']['input'];
  tagId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationSetDefaultCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetFollowUpBossV2CustomFieldArgs = {
  customField: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  structurelySlot?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetHubSpotV2CustomFieldArgs = {
  customField: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  structurelySlot?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetSalesForceV2CustomFieldArgs = {
  customField: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  objectType: Scalars['String']['input'];
  structurelyCustomSlot?: InputMaybe<Scalars['String']['input']>;
  structurelySlot?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignupForStructurelyArgs = {
  agent: AgentInputType;
  useHatchIsaScripts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartAiAgentTestArgs = {
  campaignId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  leadName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['GenericScalar']['input']>;
};


export type MutationStartAiAgentVoiceTestArgs = {
  campaignId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationStartCallArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationStartCallDigitalAgentArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  useCase: Scalars['String']['input'];
};


export type MutationStartNewConvoArgs = {
  metadata: StartConversationMetadata;
};


export type MutationStartSessionArgs = {
  clientSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStripeCustomerPortalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTeamArgs = {
  allowMembersTesting?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultiConversations?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  priceAvg?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<TeamSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};


export type MutationTestCustomToolArgs = {
  id: Scalars['ID']['input'];
  input: TestCustomToolInputType;
  payload: TestCustomToolPayload;
};


export type MutationThirdPartyIntegrationToggleMuteCustomerArgs = {
  agentId: Scalars['ID']['input'];
  brokerageId?: InputMaybe<Scalars['ID']['input']>;
  chatbotMuted: Scalars['Boolean']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  thirdPartyIntegration: Scalars['JSONString']['input'];
};


export type MutationTranscribeCanvassingSessionArgs = {
  requestId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationTriggerFollowUpBossTagSyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerPendingActivityArgs = {
  customerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationTwilioRejectCallArgs = {
  callId: Scalars['String']['input'];
  callState: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
};


export type MutationUnarchiveAgentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveBrokerageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnassignCustomerFromAgentArgs = {
  customerId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnassignCustomerFromTeamArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationUnassignTaskFromAgentArgs = {
  customerId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationUnassignTcrBrandArgs = {
  id: Scalars['ID']['input'];
  tcrBrandId: Scalars['String']['input'];
};


export type MutationUnassignTcrCampaignArgs = {
  id: Scalars['ID']['input'];
  tcrCampaignId: Scalars['String']['input'];
};


export type MutationUnregisterExpoPushNotificationsArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateAdminUserArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAdvancedBehaviorArgs = {
  behavior: AdvancedBehaviorInputType;
  behaviorId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateAdvancedCallRoutingArgs = {
  id: Scalars['ID']['input'];
  rule: AdvancedCallRoutingUpdateInputType;
  ruleId: Scalars['ID']['input'];
};


export type MutationUpdateAgentPermissionsArgs = {
  id: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateAppointmentSchedulingSettingsArgs = {
  appointmentDuration: Scalars['Int']['input'];
  chatbotTimezone: Scalars['String']['input'];
  friday: Array<AppointmentSchedulingRuleInputType>;
  id: Scalars['ID']['input'];
  monday: Array<AppointmentSchedulingRuleInputType>;
  saturday: Array<AppointmentSchedulingRuleInputType>;
  sunday: Array<AppointmentSchedulingRuleInputType>;
  thursday: Array<AppointmentSchedulingRuleInputType>;
  tuesday: Array<AppointmentSchedulingRuleInputType>;
  wednesday: Array<AppointmentSchedulingRuleInputType>;
};


export type MutationUpdateBehaviorArgs = {
  behavior: BehaviorInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBonzoIntegrationArgs = {
  autoCreateFauxAgents?: InputMaybe<Scalars['Boolean']['input']>;
  createContactsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  disableAssignmentMirroringAfterEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  searchForLeadsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateBusinessOpsArgs = {
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  intercomCompanyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCallArgs = {
  callDisposition?: InputMaybe<Scalars['String']['input']>;
  callId: Scalars['ID']['input'];
  callNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignArgs = {
  campaign: CampaignInputType;
  campaignId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignFromAgentsArgs = {
  campaign: CampaignAgentInputType;
  campaignId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateChannelCampaignAttachmentArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateChannelDigitalVoiceAssistantArgs = {
  assistantId?: InputMaybe<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateChannelDisabledArgs = {
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  isDisabled: Scalars['Boolean']['input'];
};


export type MutationUpdateChannelSetPrimaryArgs = {
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateCustomFlowArgs = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  qualifiers?: InputMaybe<FlowQualifiersInputType>;
  script?: InputMaybe<FlowScriptInputType>;
};


export type MutationUpdateCustomIntentVersionArgs = {
  id: Scalars['ID']['input'];
  operations?: InputMaybe<Array<InputMaybe<IntentUpdateOperationInputType>>>;
};


export type MutationUpdateCustomSchemaResponseAnnotationArgs = {
  annotatedSlots?: InputMaybe<Array<InputMaybe<RawSlotInputValueType>>>;
  annotatedStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCustomScriptArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomScriptVersionArgs = {
  id: Scalars['ID']['input'];
  operations?: InputMaybe<Array<InputMaybe<ScriptUpdateOperationInputType>>>;
};


export type MutationUpdateCustomSlotArgs = {
  id: Scalars['String']['input'];
  slot: CustomizedSlotInputType;
  slotId: Scalars['ID']['input'];
};


export type MutationUpdateCustomStageArgs = {
  id: Scalars['String']['input'];
  stage: CustomizedStageInputType;
  stageId: Scalars['ID']['input'];
};


export type MutationUpdateCustomToolArgs = {
  id: Scalars['ID']['input'];
  tool: CustomToolDefinitionUpdateInputType;
  toolId: Scalars['ID']['input'];
};


export type MutationUpdateCustomerCampaignStageArgs = {
  customerCampaignId: Scalars['ID']['input'];
  stage: CampaignStageEnum;
};


export type MutationUpdateCustomerFilterArgs = {
  agentId: Scalars['ID']['input'];
  customerFilter: CustomerFilterInputType;
  name: Scalars['String']['input'];
};


export type MutationUpdateFeatureFlagsArgs = {
  a2pRequired?: InputMaybe<Scalars['Boolean']['input']>;
  allowAgentLegendIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  allowAiAgentAdvancedTab?: InputMaybe<Scalars['Boolean']['input']>;
  allowAppointmentSchedulingToInviteLeads?: InputMaybe<Scalars['Boolean']['input']>;
  allowBiReporting?: InputMaybe<Scalars['Boolean']['input']>;
  allowBonzoIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  allowCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomSlots?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomStages?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomTools?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomTwilio?: InputMaybe<Scalars['Boolean']['input']>;
  allowEmailChannel?: InputMaybe<Scalars['Boolean']['input']>;
  allowExperimentalUi?: InputMaybe<Scalars['Boolean']['input']>;
  allowFauxAgentNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultiConversations?: InputMaybe<Scalars['Boolean']['input']>;
  allowPortalBetaAccess?: InputMaybe<Scalars['Boolean']['input']>;
  allowRemarketing?: InputMaybe<Scalars['Boolean']['input']>;
  allowTextAiAgents?: InputMaybe<Scalars['Boolean']['input']>;
  allowTextAnnotations?: InputMaybe<Scalars['Boolean']['input']>;
  allowTextMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  allowVoiceAiAgents?: InputMaybe<Scalars['Boolean']['input']>;
  allowVoiceAnnotations?: InputMaybe<Scalars['Boolean']['input']>;
  asyncAmd?: InputMaybe<Scalars['Boolean']['input']>;
  asyncAmdDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  disableCallRecording?: InputMaybe<Scalars['Boolean']['input']>;
  disableEnrollAndOutreach?: InputMaybe<Scalars['Boolean']['input']>;
  enableCrmCustomSchema?: InputMaybe<Scalars['Boolean']['input']>;
  enableFastEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  enableFastResponses?: InputMaybe<Scalars['Boolean']['input']>;
  enableScheduledCalling?: InputMaybe<Scalars['Boolean']['input']>;
  enableTextAiCampaignEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  externalCampaignMatcher?: InputMaybe<Scalars['String']['input']>;
  fauxAgentsInheritHoursOfOperation?: InputMaybe<Scalars['Boolean']['input']>;
  forceVoiceOrchestration?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  ignoreUnknownCalls?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreUnknownTexts?: InputMaybe<Scalars['Boolean']['input']>;
  isDemoAccount?: InputMaybe<Scalars['Boolean']['input']>;
  leadListEnrollmentRate?: InputMaybe<Scalars['Int']['input']>;
  liveTransferPreservesCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  liveTransferWhisperDelaySeconds?: InputMaybe<Scalars['Float']['input']>;
  machineDetectionSilenceTimeout?: InputMaybe<Scalars['Int']['input']>;
  machineDetectionTimeout?: InputMaybe<Scalars['Int']['input']>;
  scaleTier?: InputMaybe<Scalars['String']['input']>;
  useVoiceAiForScheduledCallbacks?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateFollowUpBossV2SettingsArgs = {
  autoCreateFauxAgents?: InputMaybe<Scalars['Boolean']['input']>;
  createContactsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  searchForLeadsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateGoHighLevelIntegrationArgs = {
  autoCreateFauxAgents?: InputMaybe<Scalars['Boolean']['input']>;
  disableAssignmentMirroringAfterEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateHubSpotV2SettingsArgs = {
  createContactsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  searchForLeadsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateInternalPromptTemplateArgs = {
  id: Scalars['ID']['input'];
  prompt: InternalPromptTemplateInputType;
};


export type MutationUpdateKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  kbId: Scalars['ID']['input'];
  knowledgeBase: KnowledgeBaseInputType;
};


export type MutationUpdateLeadEnrollmentRuleArgs = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rule?: InputMaybe<LeadEnrollmentConditionsInputType>;
};


export type MutationUpdateLeadListArgs = {
  id: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sortMode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLeadRoutingSettingsArgs = {
  entity: InputEntityRefType;
  settings: LeadRoutingSettingsInputType;
};


export type MutationUpdateLeadUploadMappingArgs = {
  id: Scalars['ID']['input'];
  mapping?: InputMaybe<Array<InputMaybe<MappingSheetInputType>>>;
  mappingId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLocalPresenceSettingsArgs = {
  entity: InputEntityRefType;
  settings: LocalPresenceSettingsInputType;
};


export type MutationUpdatePartnerCaasArgs = {
  enforceA2pCompliance?: InputMaybe<Scalars['Boolean']['input']>;
  hoursOfOperation?: InputMaybe<Array<PartnerChatbotHoursOfOperationInputType>>;
  partnerId: Scalars['ID']['input'];
  secureAccountProvisioning?: InputMaybe<Scalars['Boolean']['input']>;
  selfManagedTelco?: InputMaybe<Scalars['Boolean']['input']>;
  sendA2pOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  trustedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  twilioAccountSid?: InputMaybe<Scalars['String']['input']>;
  twilioApiKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePromptTemplateArgs = {
  id: Scalars['ID']['input'];
  prompt: UpdatePromptTemplateInputType;
};


export type MutationUpdatePubSubSubscriptionArgs = {
  id: Scalars['ID']['input'];
  status: PubSubStatus;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationUpdateSalesForceV2SettingsArgs = {
  apiMode?: InputMaybe<ApiModeEnum>;
  autoCreateFauxAgents?: InputMaybe<Scalars['Boolean']['input']>;
  createContactsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  disableAssignmentMirroringAfterEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  enablePubSub?: InputMaybe<Scalars['Boolean']['input']>;
  fauxAgentPhoneField?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  searchForLeadsOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateSchedulingSettingsArgs = {
  id: Scalars['ID']['input'];
  settings: SchedulingSettingsInputType;
};


export type MutationUpdateSubscriptionArgs = {
  cancelPendingDowngrade?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  seatBundles?: InputMaybe<Array<InputMaybe<InputSubscriptionSeatBundleType>>>;
};


export type MutationUpdateSubscriptionCardArgs = {
  id: Scalars['ID']['input'];
  stripeToken: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  customerId: Scalars['ID']['input'];
  task: InputTaskType;
  taskId: Scalars['ID']['input'];
};


export type MutationUpdateTextAiAgentArgs = {
  agent: TextAiAgentInputType;
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateTwilioA2pProfileArgs = {
  id: Scalars['ID']['input'];
  profile: TwilioA2PProfileInputType;
};


export type MutationUpdateTwilioA2pRequiredArgs = {
  id: Scalars['ID']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationUpdateVoiceAiAgentArgs = {
  agent: VoiceAiAgentInputType;
  agentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateVonageA2pProfileArgs = {
  id: Scalars['ID']['input'];
  profile: VonageA2PProfileInputType;
};


export type MutationUpdateVonageChannelCallControlModeArgs = {
  channelId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  mode?: InputMaybe<VonageVoiceCallControlModeEnum>;
};


export type MutationUploadUrlArgs = {
  metadata?: InputMaybe<AudioSegmentUploadMetadataInput>;
  segmentNumber: Scalars['Int']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationValidateAgentArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationValidatePartnerUserInvitationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  validationToken: Scalars['String']['input'];
};


export type MutationValidatePartnerUserPasswordResetArgs = {
  password: Scalars['String']['input'];
  validationToken: Scalars['String']['input'];
};


export type MutationValidateResellerAgentInvitationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  validationToken: Scalars['String']['input'];
};


export type MutationValidateResellerAgentPasswordResetArgs = {
  password: Scalars['String']['input'];
  validationToken: Scalars['String']['input'];
};


export type MutationVerifyMailgunDomainArgs = {
  domain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationVerifyResellerBrokerageArgs = {
  accessToken: Scalars['String']['input'];
  agencyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  settings: AgentSettingsInputType;
};

export type MuteActionType = {
  __typename?: 'MuteActionType';
  chatbotMuted?: Maybe<Scalars['Boolean']['output']>;
  chatbotVoiceMuted?: Maybe<Scalars['Boolean']['output']>;
  delay?: Maybe<BehavioralDelayType>;
  id: Scalars['String']['output'];
};

export type NewTwilioVoiceGrantMutation = {
  __typename?: 'NewTwilioVoiceGrantMutation';
  grant?: Maybe<Scalars['String']['output']>;
};

export enum NotificationTargetType {
  AssignedAgent = 'ASSIGNED_AGENT',
  AssignedAgentAndLeads = 'ASSIGNED_AGENT_AND_LEADS',
  AssignedTeam = 'ASSIGNED_TEAM',
  AssignedTeamAndLeads = 'ASSIGNED_TEAM_AND_LEADS',
  Leads = 'LEADS'
}

export type OperationalMetadataType = {
  __typename?: 'OperationalMetadataType';
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  intercomCompanyId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ParagonTokenType = {
  __typename?: 'ParagonTokenType';
  token?: Maybe<Scalars['String']['output']>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  caas: CaasSettings;
  createdAt: Scalars['DateTime']['output'];
  hoursOfOperation?: Maybe<Array<PartnerChatbotHoursOfOperationType>>;
  id: Scalars['Int']['output'];
  isPortalActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerAccountFullReport = {
  __typename?: 'PartnerAccountFullReport';
  end: Scalars['DateTime']['output'];
  leads: Scalars['Int']['output'];
  leadsAgentFollowUp: Scalars['Int']['output'];
  leadsAgentFollowUpAndMuted: Scalars['Int']['output'];
  leadsAgentFollowUpAndMutedChange: Scalars['Float']['output'];
  leadsAgentFollowUpAndMutedDelta: Scalars['Int']['output'];
  leadsAgentFollowUpChange: Scalars['Float']['output'];
  leadsAgentFollowUpDelta: Scalars['Int']['output'];
  leadsChange: Scalars['Float']['output'];
  leadsDelta: Scalars['Int']['output'];
  leadsInterested: Scalars['Int']['output'];
  leadsInterestedAndMuted: Scalars['Int']['output'];
  leadsInterestedAndMutedChange: Scalars['Float']['output'];
  leadsInterestedAndMutedDelta: Scalars['Int']['output'];
  leadsInterestedChange: Scalars['Float']['output'];
  leadsInterestedDelta: Scalars['Int']['output'];
  leadsMuted: Scalars['Int']['output'];
  leadsMutedChange: Scalars['Float']['output'];
  leadsMutedDelta: Scalars['Int']['output'];
  leadsNotInterested: Scalars['Int']['output'];
  leadsNotInterestedChange: Scalars['Float']['output'];
  leadsNotInterestedDelta: Scalars['Int']['output'];
  leadsWithAppointment: Scalars['Int']['output'];
  leadsWithAppointmentChange: Scalars['Float']['output'];
  leadsWithAppointmentDelta: Scalars['Int']['output'];
  leadsWithResponse: Scalars['Int']['output'];
  leadsWithResponseChange: Scalars['Float']['output'];
  leadsWithResponseDelta: Scalars['Int']['output'];
  start: Scalars['DateTime']['output'];
};

export type PartnerApiRequestPagination = {
  __typename?: 'PartnerApiRequestPagination';
  count: Scalars['Int']['output'];
  items: Array<PartnerApiRequestType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
};

export type PartnerApiRequestType = {
  __typename?: 'PartnerApiRequestType';
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eventTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  requestBody?: Maybe<Scalars['GenericScalar']['output']>;
  requestHeaders: Scalars['GenericScalar']['output'];
  requestMethod: Scalars['String']['output'];
  requestPath: Scalars['String']['output'];
  responseBody?: Maybe<Scalars['GenericScalar']['output']>;
  statusCode: Scalars['Int']['output'];
};

export type PartnerApiTokenType = {
  __typename?: 'PartnerApiTokenType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<PartnerUserType>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSystemToken: Scalars['Boolean']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  totalRequests: Scalars['Int']['output'];
};

export type PartnerChatbotHoursOfOperationInputType = {
  days?: InputMaybe<Array<InputMaybe<Array<InputMaybe<HoursOfOperationModeInputType>>>>>;
  hoursOfOperationPreset: Scalars['String']['input'];
};

export type PartnerChatbotHoursOfOperationType = {
  __typename?: 'PartnerChatbotHoursOfOperationType';
  days?: Maybe<Array<Maybe<Array<Maybe<HoursOfOperationModeType>>>>>;
  hoursOfOperationPreset: Scalars['String']['output'];
};

export type PartnerConversationMessageType = {
  __typename?: 'PartnerConversationMessageType';
  id: Scalars['String']['output'];
  incoming: Scalars['Boolean']['output'];
  received: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
};

export type PartnerConversationPagination = {
  __typename?: 'PartnerConversationPagination';
  count: Scalars['Int']['output'];
  items: Array<PartnerConversationType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
};

export type PartnerConversationSlotType = {
  __typename?: 'PartnerConversationSlotType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PartnerConversationType = {
  __typename?: 'PartnerConversationType';
  email?: Maybe<Scalars['String']['output']>;
  externalAccountId?: Maybe<Scalars['String']['output']>;
  externalLeadId?: Maybe<Scalars['String']['output']>;
  externalTeamId?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  hasResponded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interested: Scalars['Boolean']['output'];
  messages: Array<PartnerConversationMessageType>;
  muted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  needsFollowUp: Scalars['Boolean']['output'];
  notInterested: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  slots: Array<PartnerConversationSlotType>;
  stages: Array<Scalars['String']['output']>;
  started: Scalars['DateTime']['output'];
  totalMessages: Scalars['Int']['output'];
  totalResponses: Scalars['Int']['output'];
  tryItOut?: Maybe<Scalars['Boolean']['output']>;
};

export type PartnerSubAccountFullReport = {
  __typename?: 'PartnerSubAccountFullReport';
  id: Scalars['ID']['output'];
  report: SubAccountFullReport;
};

export type PartnerUserType = {
  __typename?: 'PartnerUserType';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isValidated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PartnerWebhookEventAckType = {
  __typename?: 'PartnerWebhookEventAckType';
  ack?: Maybe<Scalars['Boolean']['output']>;
  ackAt?: Maybe<Scalars['DateTime']['output']>;
  responses?: Maybe<Array<PartnerWebhookEventResponseType>>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  webhookId: Scalars['String']['output'];
  webhookName?: Maybe<Scalars['String']['output']>;
};

export type PartnerWebhookEventPagination = {
  __typename?: 'PartnerWebhookEventPagination';
  count: Scalars['Int']['output'];
  items: Array<PartnerWebhookEventType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
};

export type PartnerWebhookEventResponseType = {
  __typename?: 'PartnerWebhookEventResponseType';
  contentLength?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  requestHeaders?: Maybe<Scalars['String']['output']>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  responseHeaders?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PartnerWebhookEventType = {
  __typename?: 'PartnerWebhookEventType';
  acks: Array<PartnerWebhookEventAckType>;
  conversationId?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['GenericScalar']['output'];
  trigger: Scalars['String']['output'];
};

export type PartnerWebhookType = {
  __typename?: 'PartnerWebhookType';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
  target: Scalars['String']['output'];
  triggers: Array<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PendingDowngradeType = {
  __typename?: 'PendingDowngradeType';
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  newPlan?: Maybe<Scalars['String']['output']>;
  newPlanId?: Maybe<Scalars['String']['output']>;
  newPlanName?: Maybe<Scalars['String']['output']>;
};

export type PendingSystemTaskType = {
  __typename?: 'PendingSystemTaskType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  syntheticTask?: Maybe<Scalars['Boolean']['output']>;
  triggeredBy?: Maybe<Scalars['String']['output']>;
};

export enum PhoneCarrierType {
  Landline = 'LANDLINE',
  Mobile = 'MOBILE',
  NotFound = 'NOT_FOUND',
  NotSet = 'NOT_SET',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN',
  Voip = 'VOIP'
}

export type PhoneStatusType = {
  __typename?: 'PhoneStatusType';
  carrierType: PhoneCarrierType;
  countryCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
};

export type PlanType = {
  __typename?: 'PlanType';
  amount?: Maybe<Scalars['Int']['output']>;
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingIntervalMonths?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  enables?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leadOverageCents?: Maybe<Scalars['Int']['output']>;
  leadsPerInterval?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pricingSchema?: Maybe<Scalars['Int']['output']>;
  tokenPriceOverageCents?: Maybe<Scalars['Float']['output']>;
  tokenPricePlanCents?: Maybe<Scalars['Float']['output']>;
  tokensPerEmail?: Maybe<Scalars['Float']['output']>;
  tokensPerInterval?: Maybe<Scalars['Int']['output']>;
  tokensPerMinute?: Maybe<Scalars['Float']['output']>;
  tokensPerSms?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PlayBackCallMutation = {
  __typename?: 'PlayBackCallMutation';
  playbackUrl?: Maybe<Scalars['String']['output']>;
};

export type PromptTemplateInputType = {
  bedrockNova2Template?: InputMaybe<Scalars['String']['input']>;
  bedrockOpenaiOssTemplate?: InputMaybe<Scalars['String']['input']>;
  gpt41Template?: InputMaybe<Scalars['String']['input']>;
  gpt51Template?: InputMaybe<Scalars['String']['input']>;
  gpt56Template?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  promptType: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type PromptTemplateType = {
  __typename?: 'PromptTemplateType';
  associatedEntity?: Maybe<Scalars['String']['output']>;
  bedrockNova2Template?: Maybe<Scalars['String']['output']>;
  bedrockOpenaiOssTemplate?: Maybe<Scalars['String']['output']>;
  gpt41Template?: Maybe<Scalars['String']['output']>;
  gpt51Template?: Maybe<Scalars['String']['output']>;
  gpt56Template?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  promptType: Scalars['String']['output'];
  supportedLanguages?: Maybe<Array<Scalars['String']['output']>>;
  template?: Maybe<Scalars['String']['output']>;
};

export type PronunciationRuleInputType = {
  find: Scalars['String']['input'];
  replace: Scalars['String']['input'];
};

export type PronunciationRuleType = {
  __typename?: 'PronunciationRuleType';
  find: Scalars['String']['output'];
  replace: Scalars['String']['output'];
};

export enum PubSubStatus {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Paused = 'PAUSED'
}

export type PubSubSubscriptionType = {
  __typename?: 'PubSubSubscriptionType';
  eventName?: Maybe<Scalars['String']['output']>;
  eventsProcessed?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integration?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastEventProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminAuthentication?: Maybe<AdminAuthenticationType>;
  admins?: Maybe<Array<Maybe<AdminType>>>;
  agent?: Maybe<AgentType>;
  agents?: Maybe<Array<Maybe<AgentType>>>;
  analyticsDashboard: AnalyticsDashboard;
  authentication?: Maybe<AuthenticationType>;
  availableMailboxLabels?: Maybe<Array<Maybe<MailboxLabelType>>>;
  billingUsageReport?: Maybe<BillingUsageReport>;
  brokerage?: Maybe<BrokerageType>;
  brokerages?: Maybe<Array<Maybe<BrokerageType>>>;
  builtinScripts?: Maybe<Array<Maybe<DefaultScriptType>>>;
  builtinTags?: Maybe<Array<DefaultTagType>>;
  calendarEvents?: Maybe<CalendarEventsPayloadType>;
  campaignUsageReport?: Maybe<CampaignUsageReport>;
  canvassingSessionDetail?: Maybe<CanvassingSessionDetail>;
  canvassingSessionDoorVisitList?: Maybe<CanvassingSessionDoorVisitListResult>;
  canvassingSessionDoorVisitMap?: Maybe<CanvassingSessionDoorVisitMapResult>;
  canvassingSessionExport?: Maybe<CanvassingSessionExport>;
  canvassingSessionExportDownload: CanvassingSessionExportDownload;
  canvassingSessionExportLatest?: Maybe<CanvassingSessionExport>;
  canvassingSessionFilterOptions: CanvassingSessionFilterOptions;
  canvassingSessionGpsTrace?: Maybe<CanvassingSessionGpsTraceResult>;
  canvassingSessionList: CanvassingSessionListResult;
  canvassingSessionPipelineJobList?: Maybe<CanvassingSessionPipelineJobListResult>;
  canvassingSessionRecording?: Maybe<CanvassingSessionRecordingResult>;
  canvassingSessionTelemetry?: Maybe<CanvassingSessionTelemetryResult>;
  canvassingSessionTranscription?: Maybe<CanvassingSessionTranscriptionDto>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  checkActivateCustomScript?: Maybe<CheckActivateCustomScriptType>;
  /** @deprecated Script activate/deactivate no longer used. See custom flows. */
  checkActivateDefaultScript?: Maybe<CheckActivateDefaultScriptType>;
  connectPortalAssumeRole?: Maybe<ConnectPortalAuthenticationType>;
  connectPortalAssumeRoleToken?: Maybe<Scalars['String']['output']>;
  connectPortalAuthentication?: Maybe<ConnectPortalAuthenticationType>;
  coreConfiguration: CoreConfigurationStatus;
  coreServerInfo: CoreServerInfoType;
  customFlow?: Maybe<CustomFlowType>;
  customIntent?: Maybe<CustomIntentType>;
  customSchemaResponses?: Maybe<CustomSchemaResponsePaginationType>;
  customScript?: Maybe<CustomScriptType>;
  customToolResults?: Maybe<CustomToolResultPaginationType>;
  customer?: Maybe<CustomerType>;
  customerId?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  dailyAccountUsageHistory: Array<DailyAccountUsageReport>;
  defaultDripCampaigns?: Maybe<Array<Maybe<DefaultDripCampaignType>>>;
  defaultFlows?: Maybe<Array<Maybe<DefaultFlowType>>>;
  defaultIntent?: Maybe<DefaultIntentType>;
  defaultIntents?: Maybe<Array<Maybe<DefaultIntentType>>>;
  defaultScript?: Maybe<DefaultScriptType>;
  /** @deprecated Deprecated in favor of builtinScripts */
  defaultScripts?: Maybe<Array<Maybe<DefaultScriptType>>>;
  directPlatformEmbeddedApp?: Maybe<DirectPlatformEmbeddedAppType>;
  directPlatformTokens?: Maybe<Array<DirectPlatformTokenType>>;
  directPlatformWebhookEvents?: Maybe<DirectPlatformWebhookEventPagination>;
  directPlatformWebhooks?: Maybe<Array<DirectPlatformWebhookType>>;
  doorVisitDetail?: Maybe<DoorVisitDetail>;
  doorVisitFilterOptions: DoorVisitFilterOptions;
  doorVisitList: DoorVisitListResult;
  doorVisitReportDownload: DoorVisitReportDownload;
  doorVisitReportRun: DoorVisitReportRunResult;
  doorVisitReportRuns: DoorVisitReportRunsResult;
  email?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  fieldOps: Scalars['String']['output'];
  fieldOpsServerInfo: FieldOpsServerInfoType;
  incomingLeadSources?: Maybe<Array<Maybe<MailboxLabelType>>>;
  internalPromptTemplates?: Maybe<Array<InternalPromptTemplateType>>;
  leadEnrollmentRule?: Maybe<LeadEnrollmentRuleType>;
  leadListItems?: Maybe<Array<LeadListItemType>>;
  leadLists?: Maybe<Array<LeadListType>>;
  leadTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  leadUploadMappings?: Maybe<Array<LeadUploadMappingType>>;
  mailboxRules?: Maybe<Array<MailboxRuleType>>;
  partnerAccounts?: Maybe<Array<PartnerAccount>>;
  partnerApiRequests?: Maybe<PartnerApiRequestPagination>;
  partnerApiServiceToken?: Maybe<Scalars['String']['output']>;
  partnerApiTokens?: Maybe<Array<PartnerApiTokenType>>;
  partnerConversations?: Maybe<PartnerConversationPagination>;
  partnerFullReport?: Maybe<PartnerAccountFullReport>;
  partnerSubAccountFullReport?: Maybe<PartnerSubAccountFullReport>;
  partnerUsers?: Maybe<Array<PartnerUserType>>;
  partnerWebhookEvents?: Maybe<PartnerWebhookEventPagination>;
  partnerWebhooks?: Maybe<Array<PartnerWebhookType>>;
  plans?: Maybe<Array<Maybe<PlanType>>>;
  promptTemplates?: Maybe<Array<PromptTemplateType>>;
  recentActivity?: Maybe<RecentActivityPaginationType>;
  resellerAccounts?: Maybe<Array<ResellerAccountType>>;
  resellerAgents?: Maybe<Array<ResellerAgentType>>;
  resellerApiTokens?: Maybe<Array<ResellerApiTokenType>>;
  resellerClients?: Maybe<Array<ResellerClientType>>;
  resellerFullReport?: Maybe<ResellerAccountReport>;
  seedDataErrorReportUrl?: Maybe<SeedDataErrorReportUrl>;
  seedDataImports: SeedDataImportsResult;
  sessionInfo: SessionInfoType;
  slot?: Maybe<BrainSlotType>;
  slots?: Maybe<Array<Maybe<BrainSlotType>>>;
  systemLogs?: Maybe<Array<Maybe<CloudwatchLog>>>;
  tcrBrands?: Maybe<Array<TcrBrandType>>;
  tcrCampaigns?: Maybe<Array<TcrCampaignType>>;
  team?: Maybe<TeamType>;
  teams?: Maybe<Array<Maybe<TeamType>>>;
  thirdPartyIntegrationCustomer?: Maybe<ThirdPartyIntegrationCustomerType>;
  timezones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  voiceProviders?: Maybe<Array<VoiceProviderType>>;
  voterDetail?: Maybe<FieldOpsVoter>;
  voterDoorVisits?: Maybe<VoterDoorVisitsResult>;
  voterList: VoterListResult;
  voterRegistrationStates: Array<Scalars['String']['output']>;
  votersInBounds: VotersInBoundsResult;
};


export type QueryAdminAuthenticationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  forwardingEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  independent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsDashboardArgs = {
  dateRange?: InputMaybe<AnalyticsDashboardDateRangePreset>;
};


export type QueryAuthenticationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryBillingUsageReportArgs = {
  id: Scalars['ID']['input'];
  period?: InputMaybe<DashboardPeriod>;
};


export type QueryBrokerageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrokeragesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  forwardingEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuiltinScriptsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
  entity: InputEntityRefType;
};


export type QueryBuiltinTagsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
};


export type QueryCalendarEventsArgs = {
  entityId: Scalars['ID']['input'];
  rangeEnd: Scalars['DateTime']['input'];
  rangeStart: Scalars['DateTime']['input'];
};


export type QueryCampaignUsageReportArgs = {
  campaignId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  period?: InputMaybe<DashboardPeriod>;
};


export type QueryCanvassingSessionDetailArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryCanvassingSessionDoorVisitListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryCanvassingSessionDoorVisitMapArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryCanvassingSessionExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanvassingSessionExportDownloadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanvassingSessionGpsTraceArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<CanvassingSessionGpsTraceMode>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
  snapshot?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanvassingSessionListArgs = {
  calendar?: InputMaybe<CanvassingSessionCalendarFilter>;
  canvasserId?: InputMaybe<Scalars['String']['input']>;
  captureStatus?: InputMaybe<CanvassingSessionCaptureStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  processingStatus?: InputMaybe<CanvassingSessionProcessingStatus>;
  sort?: InputMaybe<CanvassingSessionListSort>;
  startedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startedFrom?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCanvassingSessionPipelineJobListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryCanvassingSessionRecordingArgs = {
  purpose: CanvassingSessionRecordingPurpose;
  sessionId: Scalars['ID']['input'];
};


export type QueryCanvassingSessionTelemetryArgs = {
  category?: InputMaybe<SessionTelemetryCategory>;
  failuresOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
  snapshot?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanvassingSessionTranscriptionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryCheckActivateCustomScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type QueryCheckActivateDefaultScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type QueryConnectPortalAssumeRoleArgs = {
  assumeRoleToken: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  resellerId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryConnectPortalAssumeRoleTokenArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  resellerId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryConnectPortalAuthenticationArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryCustomFlowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomIntentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomSchemaResponsesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type QueryCustomToolResultsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  customToolId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerIdArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  brokerageId?: InputMaybe<Scalars['ID']['input']>;
  integration: Scalars['String']['input'];
  payload: Scalars['GenericScalar']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomersArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  smoochUserId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDailyAccountUsageHistoryArgs = {
  id: Scalars['ID']['input'];
  period?: InputMaybe<DashboardPeriod>;
};


export type QueryDefaultDripCampaignsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
};


export type QueryDefaultFlowsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
  entity: InputEntityRefType;
};


export type QueryDefaultIntentArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type QueryDefaultIntentsArgs = {
  entity: InputEntityRefType;
};


export type QueryDefaultScriptArgs = {
  entity: InputEntityRefType;
  id: Scalars['ID']['input'];
};


export type QueryDefaultScriptsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
  entity: InputEntityRefType;
  leadTypes?: InputMaybe<Array<InputMaybe<ScriptLeadTypes>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<ScriptSourceTypes>>>;
};


export type QueryDirectPlatformEmbeddedAppArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDirectPlatformTokensArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDirectPlatformWebhookEventsArgs = {
  cursorId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDirectPlatformWebhooksArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDoorVisitDetailArgs = {
  doorVisitId: Scalars['Int']['input'];
};


export type QueryDoorVisitListArgs = {
  filter?: InputMaybe<DoorVisitListFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DoorVisitListSort>;
};


export type QueryDoorVisitReportDownloadArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryDoorVisitReportRunArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryDoorVisitReportRunsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryFaviconArgs = {
  domain: Scalars['String']['input'];
};


export type QueryLeadEnrollmentRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadListItemsArgs = {
  availableItems?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};


export type QueryLeadListsArgs = {
  id: Scalars['ID']['input'];
  listPurpose: Scalars['String']['input'];
  listType?: InputMaybe<Scalars['String']['input']>;
  remainingLeads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLeadTypesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeadUploadMappingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailboxRulesArgs = {
  labelId: Scalars['String']['input'];
};


export type QueryPartnerAccountsArgs = {
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPartnerApiRequestsArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  cursorId?: InputMaybe<Scalars['String']['input']>;
  hasHttpError?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerApiServiceTokenArgs = {
  authRequest: Scalars['String']['input'];
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerApiTokensArgs = {
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerConversationsArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  cursorId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerFullReportArgs = {
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerSubAccountFullReportArgs = {
  externalAccountId: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPartnerUsersArgs = {
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerWebhookEventsArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  cursorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  partnerId: Scalars['ID']['input'];
};


export type QueryPartnerWebhooksArgs = {
  partnerId: Scalars['ID']['input'];
};


export type QueryPlansArgs = {
  customerView?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPromptTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecentActivityArgs = {
  cursorId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResellerAccountsArgs = {
  resellerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryResellerAgentsArgs = {
  resellerId: Scalars['ID']['input'];
};


export type QueryResellerApiTokensArgs = {
  resellerId: Scalars['ID']['input'];
};


export type QueryResellerClientsArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  resellerId: Scalars['ID']['input'];
};


export type QueryResellerFullReportArgs = {
  resellerId: Scalars['ID']['input'];
};


export type QuerySeedDataErrorReportUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeedDataImportsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySlotArgs = {
  name: Scalars['String']['input'];
};


export type QuerySlotsArgs = {
  domains?: InputMaybe<Array<InputMaybe<Domain>>>;
  isMergeField?: InputMaybe<Scalars['Boolean']['input']>;
  isQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySystemLogsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTcrBrandsArgs = {
  associatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  identityStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  recordsPerPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTcrCampaignsArgs = {
  associatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  recordsPerPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tcrBrandId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  forwardingEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  independent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryThirdPartyIntegrationCustomerArgs = {
  agentId: Scalars['ID']['input'];
  brokerageId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  thirdPartyIntegration: Scalars['JSONString']['input'];
};


export type QueryVoterDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoterDoorVisitsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVoterListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVotersInBoundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  bounds: GeographicBoundsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeType = {
  __typename?: 'RangeType';
  approx?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type RawSlotInputValueType = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RawSlotValueType = {
  __typename?: 'RawSlotValueType';
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type RealtorEntityType = {
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  a2pStatus?: Maybe<A2PStatusEnum>;
  accountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  activeLeadTypes?: Maybe<Array<Scalars['String']['output']>>;
  advancedBehaviors?: Maybe<Array<AdvancedBehaviorType>>;
  advancedCallRouting?: Maybe<Array<AdvancedCallRoutingType>>;
  allowAgentLegendIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowAiAgentAdvancedTab?: Maybe<Scalars['Boolean']['output']>;
  allowAiTextAgents?: Maybe<Scalars['Boolean']['output']>;
  allowAiVoiceAgents?: Maybe<Scalars['Boolean']['output']>;
  allowBiReporting?: Maybe<Scalars['Boolean']['output']>;
  allowBonzoIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowCalendlyScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowCampaigns?: Maybe<Scalars['Boolean']['output']>;
  allowCustomScripts?: Maybe<Scalars['Boolean']['output']>;
  allowCustomSlots?: Maybe<Scalars['Boolean']['output']>;
  allowCustomStages?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTools?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTwilio?: Maybe<Scalars['Boolean']['output']>;
  allowHardAppointmentScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowIntercom?: Maybe<Scalars['Boolean']['output']>;
  allowMailgun?: Maybe<Scalars['Boolean']['output']>;
  allowMessagingChannels?: Maybe<Scalars['Boolean']['output']>;
  allowMultiConversations?: Maybe<Scalars['Boolean']['output']>;
  allowMultiSmsChannels?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialer?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialerExperimentalSettings?: Maybe<Scalars['Boolean']['output']>;
  allowPortalBetaAccess?: Maybe<Scalars['Boolean']['output']>;
  allowRemarketing?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceChannels?: Maybe<Scalars['Boolean']['output']>;
  allowedEmailDomains?: Maybe<Array<Maybe<DomainType>>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  behaviors?: Maybe<Array<BehaviorType>>;
  billingInvoices: Array<BillingInvoiceType>;
  builtinSlots?: Maybe<Array<BrainSlotType>>;
  callDispositions?: Maybe<Array<Scalars['String']['output']>>;
  callsPerDay?: Maybe<Scalars['Int']['output']>;
  campaigns?: Maybe<Array<CampaignType>>;
  communicationChannels?: Maybe<Array<CommunicationChannelType>>;
  communicationProfiles?: Maybe<Array<CommunicationProfileType>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  customIntents?: Maybe<Array<Maybe<CustomIntentType>>>;
  customReportCsvs?: Maybe<Array<DirectPlatformCustomReportType>>;
  customScripts?: Maybe<Array<Maybe<CustomScriptType>>>;
  customSlots?: Maybe<Array<CustomizedSlotType>>;
  customStages?: Maybe<Array<CustomizedStageType>>;
  customTools?: Maybe<Array<CustomToolDefinitionType>>;
  customTwilioToken?: Maybe<TwilioAuthTokenType>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  email?: Maybe<Scalars['String']['output']>;
  enableTextAiCampaignEnrollment?: Maybe<Scalars['Boolean']['output']>;
  externalCampaignMatcher?: Maybe<Scalars['String']['output']>;
  fauxAgentsInheritHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  forceVoiceOrchestration?: Maybe<Scalars['Boolean']['output']>;
  generatedApiKey?: Maybe<Scalars['String']['output']>;
  hasEmailChannel?: Maybe<Scalars['Boolean']['output']>;
  hasSmsChannel?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integrations?: Maybe<AppIntegrationsType>;
  isZendesk?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadEnrollmentRules?: Maybe<Array<Maybe<LeadEnrollmentRuleType>>>;
  leadQualification?: Maybe<LeadQualificationType>;
  leadRouting: LeadRoutingSettingsType;
  listCustomers?: Maybe<CustomerPaginationType>;
  liveTransferAnalytics?: Maybe<Array<VoiceCallType>>;
  liveTransferWhisperDelaySeconds?: Maybe<Scalars['Float']['output']>;
  localPresenceSettings: LocalPresenceSettingsType;
  multiConversationsCanBeActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  paragonConnectJwt?: Maybe<ParagonTokenType>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredAreaCode?: Maybe<Scalars['String']['output']>;
  priceAvg?: Maybe<Scalars['Int']['output']>;
  pubSubSubscriptions?: Maybe<Array<PubSubSubscriptionType>>;
  recentlyCreatedTasks?: Maybe<Array<Maybe<TaskType>>>;
  reseller?: Maybe<ResellerSubscriptionPlanType>;
  scheduledCallingStatus?: Maybe<Scalars['String']['output']>;
  smoochId?: Maybe<Scalars['String']['output']>;
  structurelyRoi?: Maybe<StructurelyRoiType>;
  subscription?: Maybe<SubscriptionType>;
  textAiAgents?: Maybe<Array<TextAiAgentType>>;
  thirdPartyApiKeys?: Maybe<ThirdPartyApiKeysType>;
  thirdPartyOptions?: Maybe<ThirdPartyOptionsType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  totalCustomersCount?: Maybe<Scalars['Int']['output']>;
  totalUnreadCount?: Maybe<Scalars['Int']['output']>;
  upcomingReminderTasks?: Maybe<Array<Maybe<TaskType>>>;
  voiceAiAgents?: Maybe<Array<VoiceAiAgentType>>;
  voiceCallSummary?: Maybe<VoiceCallSummaryType>;
};


export type RealtorEntityTypeAdvancedBehaviorsArgs = {
  integrationName: Scalars['String']['input'];
};


export type RealtorEntityTypeBillingInvoicesArgs = {
  billingInterval?: InputMaybe<BillingInvoiceInterval>;
};


export type RealtorEntityTypeCustomFlowsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type RealtorEntityTypeCustomIntentsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type RealtorEntityTypeCustomScriptsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadTypes?: InputMaybe<Array<InputMaybe<ScriptLeadTypes>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<ScriptSourceTypes>>>;
};


export type RealtorEntityTypeCustomersArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<CursorInputType>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RealtorEntityTypeLeadEnrollmentRulesArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type RealtorEntityTypeLeadQualificationArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RealtorEntityTypeListCustomersArgs = {
  currentCampaign?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  customSlots?: InputMaybe<Scalars['JSONString']['input']>;
  customStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RealtorEntityTypeLiveTransferAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RealtorEntityTypePubSubSubscriptionsArgs = {
  integration: Scalars['String']['input'];
};


export type RealtorEntityTypeRecentlyCreatedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RealtorEntityTypeStructurelyRoiArgs = {
  appointmentSetToCloseRatio?: InputMaybe<Scalars['Float']['input']>;
  averageCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  averageSellingPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type RealtorEntityTypeTotalCustomersCountArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RealtorEntityTypeUpcomingReminderTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type RealtorEntityUnionType = AgentType | BrokerageType | ResellerAccountType | TeamType;

export type RecentActivityItemType = {
  __typename?: 'RecentActivityItemType';
  customerId: Scalars['ID']['output'];
  customerName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  type: RecentActivityTypeEnum;
};

export type RecentActivityPaginationType = {
  __typename?: 'RecentActivityPaginationType';
  count: Scalars['Int']['output'];
  items: Array<RecentActivityItemType>;
  nextCursorId?: Maybe<Scalars['ID']['output']>;
};

export enum RecentActivityTypeEnum {
  AppointmentSet = 'APPOINTMENT_SET',
  CallbackScheduled = 'CALLBACK_SCHEDULED',
  LeadEnrolled = 'LEAD_ENROLLED',
  LiveTransferFailed = 'LIVE_TRANSFER_FAILED',
  LiveTransferSuccess = 'LIVE_TRANSFER_SUCCESS',
  TextAiTriggeredCall = 'TEXT_AI_TRIGGERED_CALL',
  Unknown = 'UNKNOWN'
}

export type RecreateStripeAccountMutation = {
  __typename?: 'RecreateStripeAccountMutation';
  subscription?: Maybe<SubscriptionType>;
};

export type RegisterExpoPushNotificationsMutation = {
  __typename?: 'RegisterExpoPushNotificationsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveAcculynxIntegrationMutation = {
  __typename?: 'RemoveAcculynxIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveAgentAudioRecordingMutation = {
  __typename?: 'RemoveAgentAudioRecordingMutation';
  agent?: Maybe<AgentType>;
};

export type RemoveAgentLegendIntegrationMutation = {
  __typename?: 'RemoveAgentLegendIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveBonzoIntegrationMutation = {
  __typename?: 'RemoveBonzoIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveBonzoTwilioIntegrationMutation = {
  __typename?: 'RemoveBonzoTwilioIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveBoomTownIntegrationMutation = {
  __typename?: 'RemoveBoomTownIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveCommioIntegrationMutation = {
  __typename?: 'RemoveCommioIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveFacebookIntegrationMutation = {
  __typename?: 'RemoveFacebookIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveFauxIntegrationMutation = {
  __typename?: 'RemoveFauxIntegrationMutation';
  agent?: Maybe<AgentType>;
};

export type RemoveFollowUpBossV2IntegrationMutation = {
  __typename?: 'RemoveFollowUpBossV2IntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveGoHighLevelIntegrationMutation = {
  __typename?: 'RemoveGoHighLevelIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveGoogleEnrollmentIntegrationMutation = {
  __typename?: 'RemoveGoogleEnrollmentIntegrationMutation';
  entity?: Maybe<RealtorEntityUnionType>;
};

export type RemoveGoogleIntegrationMutation = {
  __typename?: 'RemoveGoogleIntegrationMutation';
  agent?: Maybe<AgentType>;
};

export type RemoveHubSpotV2IntegrationMutation = {
  __typename?: 'RemoveHubSpotV2IntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLeadListMutation = {
  __typename?: 'RemoveLeadListMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLeadPerfectionIntegrationMutation = {
  __typename?: 'RemoveLeadPerfectionIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLeadUploadMappingMutation = {
  __typename?: 'RemoveLeadUploadMappingMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveLionDeskIntegrationMutation = {
  __typename?: 'RemoveLionDeskIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMailgunIntegrationMutation = {
  __typename?: 'RemoveMailgunIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMarketSharpIntegrationMutation = {
  __typename?: 'RemoveMarketSharpIntegrationMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMessageBirdIntegrationMutation = {
  __typename?: 'RemoveMessageBirdIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSalesForceV2IntegrationMutation = {
  __typename?: 'RemoveSalesForceV2IntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTaskMutation = {
  __typename?: 'RemoveTaskMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTelnyxIntegrationMutation = {
  __typename?: 'RemoveTelnyxIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveTwilioIntegrationMutation = {
  __typename?: 'RemoveTwilioIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveVonageIntegrationMutation = {
  __typename?: 'RemoveVonageIntegrationMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReplayDoorVisitResult = {
  __typename?: 'ReplayDoorVisitResult';
  doorVisitId: Scalars['Int']['output'];
};

export type ReportCountWithFilter = {
  __typename?: 'ReportCountWithFilter';
  count: Scalars['Int']['output'];
  filter: Scalars['String']['output'];
};

export enum RepromptPriority {
  Always = 'ALWAYS',
  AlwaysEvenInSameIntent = 'ALWAYS_EVEN_IN_SAME_INTENT',
  ChallengePreFilled = 'CHALLENGE_PRE_FILLED',
  Default = 'DEFAULT',
  Inherit = 'INHERIT'
}

export type RequestPartnerResetPasswordMutation = {
  __typename?: 'RequestPartnerResetPasswordMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestResellerResetPasswordMutation = {
  __typename?: 'RequestResellerResetPasswordMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ResellerAccountReport = {
  __typename?: 'ResellerAccountReport';
  clients: Scalars['Int']['output'];
  clientsChange: Scalars['Float']['output'];
  clientsDelta: Scalars['Int']['output'];
  generatedAt: Scalars['DateTime']['output'];
  leads: Scalars['Int']['output'];
  leadsAgentFollowUp: Scalars['Int']['output'];
  leadsAgentFollowUpAndMuted: Scalars['Int']['output'];
  leadsAgentFollowUpAndMutedChange: Scalars['Float']['output'];
  leadsAgentFollowUpAndMutedDelta: Scalars['Int']['output'];
  leadsAgentFollowUpChange: Scalars['Float']['output'];
  leadsAgentFollowUpDelta: Scalars['Int']['output'];
  leadsChange: Scalars['Float']['output'];
  leadsDelta: Scalars['Int']['output'];
  leadsInterested: Scalars['Int']['output'];
  leadsInterestedAndMuted: Scalars['Int']['output'];
  leadsInterestedAndMutedChange: Scalars['Float']['output'];
  leadsInterestedAndMutedDelta: Scalars['Int']['output'];
  leadsInterestedChange: Scalars['Float']['output'];
  leadsInterestedDelta: Scalars['Int']['output'];
  leadsMuted: Scalars['Int']['output'];
  leadsMutedChange: Scalars['Float']['output'];
  leadsMutedDelta: Scalars['Int']['output'];
  leadsNotInterested: Scalars['Int']['output'];
  leadsNotInterestedChange: Scalars['Float']['output'];
  leadsNotInterestedDelta: Scalars['Int']['output'];
  leadsWithAppointment: Scalars['Int']['output'];
  leadsWithAppointmentChange: Scalars['Float']['output'];
  leadsWithAppointmentDelta: Scalars['Int']['output'];
  leadsWithResponse: Scalars['Int']['output'];
  leadsWithResponseChange: Scalars['Float']['output'];
  leadsWithResponseDelta: Scalars['Int']['output'];
};

export type ResellerAccountSubscriptionHistory = {
  __typename?: 'ResellerAccountSubscriptionHistory';
  conversationsThisInterval: Scalars['Int']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  totalConversations: Scalars['Int']['output'];
};

export type ResellerAccountType = {
  __typename?: 'ResellerAccountType';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  history: ResellerAccountSubscriptionHistory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subscription?: Maybe<SubscriptionType>;
};

export type ResellerAgentType = {
  __typename?: 'ResellerAgentType';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isResellerAdmin: Scalars['Boolean']['output'];
  isValidated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ResellerApiTokenType = {
  __typename?: 'ResellerApiTokenType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<ResellerAgentType>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  totalRequests: Scalars['Int']['output'];
};

export type ResellerAssumeRoleMutation = {
  __typename?: 'ResellerAssumeRoleMutation';
  assume?: Maybe<AuthenticationType>;
};

export type ResellerClientSubscriptionType = {
  __typename?: 'ResellerClientSubscriptionType';
  conversationOverageCents: Scalars['Int']['output'];
  conversationsPerInterval: Scalars['Int']['output'];
  conversationsThisInterval: Scalars['Int']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  isResellerSubscription: Scalars['Boolean']['output'];
};

export type ResellerClientType = {
  __typename?: 'ResellerClientType';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entityType: EntityTypeEnum;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isLegacy: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subscription?: Maybe<ResellerClientSubscriptionType>;
};

export type ResellerCreateBrokerageMutation = {
  __typename?: 'ResellerCreateBrokerageMutation';
  result?: Maybe<ResellerClientType>;
};

export type ResellerInviteBrokerageMutation = {
  __typename?: 'ResellerInviteBrokerageMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ResellerSubscriptionPlanType = {
  __typename?: 'ResellerSubscriptionPlanType';
  billingInterval: Scalars['String']['output'];
  currentCallCount: Scalars['Int']['output'];
  currentLeadCount: Scalars['Int']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  leadOverageCents: Scalars['Int']['output'];
  leadsPerInterval: Scalars['Int']['output'];
  resellerName: Scalars['String']['output'];
};

export type ResendAuthEmailMutation = {
  __typename?: 'ResendAuthEmailMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetConversationUnreadCountMutation = {
  __typename?: 'ResetConversationUnreadCountMutation';
  conversation?: Maybe<ConversationType>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type RetrieveCaasServerTokenMutation = {
  __typename?: 'RetrieveCaasServerTokenMutation';
  token?: Maybe<Scalars['String']['output']>;
};

export enum RoutingRuleTargetTypeEnum {
  Agent = 'AGENT',
  PhoneNumber = 'PHONE_NUMBER'
}

export type SalesForceCustomFieldType = {
  __typename?: 'SalesForceCustomFieldType';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  structurelyCustomSlot?: Maybe<Scalars['String']['output']>;
  structurelySlot?: Maybe<Scalars['String']['output']>;
};

export type SalesForceOptionsType = {
  __typename?: 'SalesForceOptionsType';
  apiMode?: Maybe<ApiModeEnum>;
  autoCreateFauxAgents?: Maybe<Scalars['Boolean']['output']>;
  contactFields?: Maybe<Array<Maybe<SalesForceCustomFieldType>>>;
  createContactsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  customDomain?: Maybe<Scalars['String']['output']>;
  disableAssignmentMirroringAfterEnrollment?: Maybe<Scalars['Boolean']['output']>;
  enablePubSub?: Maybe<Scalars['Boolean']['output']>;
  fauxAgentPhoneField?: Maybe<Scalars['String']['output']>;
  leadFields?: Maybe<Array<Maybe<SalesForceCustomFieldType>>>;
  opportunityFields?: Maybe<Array<Maybe<SalesForceCustomFieldType>>>;
  organizationId?: Maybe<Scalars['String']['output']>;
  searchForLeadsOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  status: IntegrationStatusEnum;
  statusError?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  userFields?: Maybe<Array<Maybe<SalesForceCustomFieldType>>>;
};

export type SchedulingSettingsInputType = {
  isDisabledByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maximumBusinessDaysBeforeSchedule?: InputMaybe<Scalars['Int']['input']>;
  minimumBusinessDaysUntilSchedule?: InputMaybe<Scalars['Int']['input']>;
  scheduleOnHolidays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulingSettingsType = {
  __typename?: 'SchedulingSettingsType';
  isDisabledByAdmin?: Maybe<Scalars['Boolean']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  maximumBusinessDaysBeforeSchedule?: Maybe<Scalars['Int']['output']>;
  minimumBusinessDaysUntilSchedule?: Maybe<Scalars['Int']['output']>;
  scheduleOnHolidays: Scalars['Boolean']['output'];
};

export type ScriptConclusionInputType = {
  prePrompts?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
  responses?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
  slots?: InputMaybe<Array<InputMaybe<BlueprintSlotInputType>>>;
};

export type ScriptConclusionType = {
  __typename?: 'ScriptConclusionType';
  id?: Maybe<Scalars['ID']['output']>;
  prePrompts?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  responses?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  slots?: Maybe<Array<Maybe<BlueprintSlotType>>>;
};

export type ScriptContentType = {
  __typename?: 'ScriptContentType';
  conclusions?: Maybe<Array<Maybe<ScriptConclusionType>>>;
  dripCampaign?: Maybe<ScriptDripCampaignType>;
  intro?: Maybe<ScriptIntroType>;
  subjects?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  targetedChannels?: Maybe<Array<Maybe<Channel>>>;
};

export type ScriptDripCampaignReferenceInputType = {
  name?: InputMaybe<DefaultDripCampaignNames>;
};

export type ScriptDripCampaignType = DefaultDripCampaignType;

export type ScriptIntroInputType = {
  responses?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
  slots?: InputMaybe<Array<InputMaybe<BlueprintSlotInputType>>>;
};

export type ScriptIntroType = {
  __typename?: 'ScriptIntroType';
  responses?: Maybe<Array<Maybe<BlueprintTemplateSetType>>>;
  slots?: Maybe<Array<Maybe<BlueprintSlotType>>>;
};

export enum ScriptLeadTypes {
  AutoInsuranceLapsedCoverage = 'AUTO_INSURANCE_LAPSED_COVERAGE',
  AutoInsuranceNewApp = 'AUTO_INSURANCE_NEW_APP',
  AutoInsurancePolicyReview = 'AUTO_INSURANCE_POLICY_REVIEW',
  AutoInsuranceQuote = 'AUTO_INSURANCE_QUOTE',
  AutoInsuranceRevival = 'AUTO_INSURANCE_REVIVAL',
  Buyer = 'BUYER',
  BuyerSeller = 'BUYER_SELLER',
  BuyerSpecific = 'BUYER_SPECIFIC',
  BuyerSpecificSeller = 'BUYER_SPECIFIC_SELLER',
  General = 'GENERAL',
  HomeInsuranceLapsedCoverage = 'HOME_INSURANCE_LAPSED_COVERAGE',
  HomeInsuranceNewApp = 'HOME_INSURANCE_NEW_APP',
  HomeInsurancePolicyReview = 'HOME_INSURANCE_POLICY_REVIEW',
  HomeInsuranceQuote = 'HOME_INSURANCE_QUOTE',
  HomeInsuranceRevival = 'HOME_INSURANCE_REVIVAL',
  HomeRefinance = 'HOME_REFINANCE',
  LifeInsuranceLapsedCoverage = 'LIFE_INSURANCE_LAPSED_COVERAGE',
  LifeInsuranceNewApp = 'LIFE_INSURANCE_NEW_APP',
  LifeInsurancePolicyReview = 'LIFE_INSURANCE_POLICY_REVIEW',
  LifeInsuranceQuote = 'LIFE_INSURANCE_QUOTE',
  LifeInsuranceRevival = 'LIFE_INSURANCE_REVIVAL',
  LongTermDisabilityInsuranceLapsedCoverage = 'LONG_TERM_DISABILITY_INSURANCE_LAPSED_COVERAGE',
  LongTermDisabilityInsuranceNewApp = 'LONG_TERM_DISABILITY_INSURANCE_NEW_APP',
  LongTermDisabilityInsurancePolicyReview = 'LONG_TERM_DISABILITY_INSURANCE_POLICY_REVIEW',
  LongTermDisabilityInsuranceQuote = 'LONG_TERM_DISABILITY_INSURANCE_QUOTE',
  LongTermDisabilityInsuranceRevival = 'LONG_TERM_DISABILITY_INSURANCE_REVIVAL',
  NewHomeLoan = 'NEW_HOME_LOAN',
  NewHomeLoanSpecific = 'NEW_HOME_LOAN_SPECIFIC',
  PetInsuranceLapsedCoverage = 'PET_INSURANCE_LAPSED_COVERAGE',
  PetInsuranceNewApp = 'PET_INSURANCE_NEW_APP',
  PetInsurancePolicyReview = 'PET_INSURANCE_POLICY_REVIEW',
  PetInsuranceQuote = 'PET_INSURANCE_QUOTE',
  PetInsuranceRevival = 'PET_INSURANCE_REVIVAL',
  RecruitingInsuranceAgent = 'RECRUITING_INSURANCE_AGENT',
  Renter = 'RENTER',
  RentersInsuranceLapsedCoverage = 'RENTERS_INSURANCE_LAPSED_COVERAGE',
  RentersInsuranceNewApp = 'RENTERS_INSURANCE_NEW_APP',
  RentersInsurancePolicyReview = 'RENTERS_INSURANCE_POLICY_REVIEW',
  RentersInsuranceQuote = 'RENTERS_INSURANCE_QUOTE',
  RentersInsuranceRevival = 'RENTERS_INSURANCE_REVIVAL',
  RenterSeller = 'RENTER_SELLER',
  RenterSpecific = 'RENTER_SPECIFIC',
  RenterSpecificSeller = 'RENTER_SPECIFIC_SELLER',
  Seller = 'SELLER',
  TravelInsuranceNewApp = 'TRAVEL_INSURANCE_NEW_APP',
  TravelInsuranceQuote = 'TRAVEL_INSURANCE_QUOTE',
  UmbrellaInsuranceLapsedCoverage = 'UMBRELLA_INSURANCE_LAPSED_COVERAGE',
  UmbrellaInsuranceNewApp = 'UMBRELLA_INSURANCE_NEW_APP',
  UmbrellaInsurancePolicyReview = 'UMBRELLA_INSURANCE_POLICY_REVIEW',
  UmbrellaInsuranceQuote = 'UMBRELLA_INSURANCE_QUOTE',
  UmbrellaInsuranceRevival = 'UMBRELLA_INSURANCE_REVIVAL'
}

export enum ScriptSourceTypes {
  DirectMessage = 'DIRECT_MESSAGE',
  FormRegistration = 'FORM_REGISTRATION',
  LeadUpload = 'LEAD_UPLOAD'
}

export type ScriptUpdateContentInputType = {
  channelList?: InputMaybe<Array<InputMaybe<Channel>>>;
  conclusion?: InputMaybe<ScriptConclusionInputType>;
  dripCampaign?: InputMaybe<ScriptDripCampaignReferenceInputType>;
  inputType: ScriptUpdateContentInputTypes;
  intro?: InputMaybe<ScriptIntroInputType>;
  slot?: InputMaybe<BlueprintSlotInputType>;
  template?: InputMaybe<BlueprintTemplateInputType>;
  templateSet?: InputMaybe<BlueprintTemplateSetInputType>;
  templateSetCollection?: InputMaybe<Array<InputMaybe<BlueprintTemplateSetInputType>>>;
};

export enum ScriptUpdateContentInputTypes {
  ChannelList = 'CHANNEL_LIST',
  Conclusion = 'CONCLUSION',
  DripCampaign = 'DRIP_CAMPAIGN',
  Intro = 'INTRO',
  Null = 'NULL',
  Slot = 'SLOT',
  Template = 'TEMPLATE',
  TemplateSet = 'TEMPLATE_SET',
  TemplateSetCollection = 'TEMPLATE_SET_COLLECTION'
}

export type ScriptUpdateContentType = BlueprintSlotType | BlueprintTemplateSetType | BlueprintTemplateType | DefaultDripCampaignType | ScriptConclusionType;

export type ScriptUpdateFieldInputType = {
  field: Scalars['String']['input'];
  key?: InputMaybe<Scalars['ID']['input']>;
};

export type ScriptUpdateOperationInputType = {
  fields: Array<InputMaybe<ScriptUpdateFieldInputType>>;
  operation: UpdateOperationTypes;
  options?: InputMaybe<UpdateOptionsInputType>;
  value: ScriptUpdateContentInputType;
};

export type SearchType = {
  __typename?: 'SearchType';
  acres?: Maybe<RangeType>;
  addresses?: Maybe<Array<Maybe<AddressType>>>;
  baths?: Maybe<BathsType>;
  beds?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Location information is no longer accessible by type */
  city?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price?: Maybe<RangeType>;
  /** @deprecated Location information is no longer accessible by type */
  school?: Maybe<Scalars['String']['output']>;
  squareFeet?: Maybe<RangeType>;
  /** @deprecated Location information is no longer accessible by type */
  state?: Maybe<Scalars['String']['output']>;
  /** @deprecated Location information is no longer accessible by type */
  zip?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SeedDataEntityOutcomeSummary = {
  __typename?: 'SeedDataEntityOutcomeSummary';
  created: Scalars['Int']['output'];
  existingUnchanged: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type SeedDataErrorReportUrl = {
  __typename?: 'SeedDataErrorReportUrl';
  expiresAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type SeedDataImportDto = {
  __typename?: 'SeedDataImportDto';
  actualBytes?: Maybe<Scalars['Float']['output']>;
  attempts: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorReportAvailable: Scalars['Boolean']['output'];
  errorSamples: Array<SeedDataImportErrorSampleDto>;
  expiresAt: Scalars['DateTime']['output'];
  householdOutcomes?: Maybe<SeedDataEntityOutcomeSummary>;
  householdsUpserted: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  importedRows: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  pollingRecommended: Scalars['Boolean']['output'];
  processedRows: Scalars['Int']['output'];
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  sizeBytes: Scalars['Float']['output'];
  skippedRows: Scalars['Int']['output'];
  status: SeedDataImportStatus;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  voterOutcomes?: Maybe<SeedDataEntityOutcomeSummary>;
  votersUpserted: Scalars['Int']['output'];
  warningRows: Scalars['Int']['output'];
};

export type SeedDataImportErrorSampleDto = {
  __typename?: 'SeedDataImportErrorSampleDto';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export enum SeedDataImportStatus {
  AwaitingUpload = 'AWAITING_UPLOAD',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Succeeded = 'SUCCEEDED',
  SucceededWithErrors = 'SUCCEEDED_WITH_ERRORS'
}

export type SeedDataImportsResult = {
  __typename?: 'SeedDataImportsResult';
  items: Array<SeedDataImportDto>;
  total: Scalars['Int']['output'];
};

export type SendAiAgentTestingMessageMutation = {
  __typename?: 'SendAiAgentTestingMessageMutation';
  messageId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type SendCustomPlanInviteMutation = {
  __typename?: 'SendCustomPlanInviteMutation';
  inviteLink?: Maybe<Scalars['String']['output']>;
};

export type SendMessageMutation = {
  __typename?: 'SendMessageMutation';
  message?: Maybe<MessageType>;
};

export type SendResetPasswordMutation = {
  __typename?: 'SendResetPasswordMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum Sender {
  Agent = 'AGENT',
  Holmes = 'HOLMES',
  Unknown = 'UNKNOWN'
}

export type SendingDnsRecordType = {
  __typename?: 'SendingDnsRecordType';
  cached?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SessionInfoType = {
  __typename?: 'SessionInfoType';
  accountId?: Maybe<Scalars['ID']['output']>;
  adminId?: Maybe<Scalars['ID']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isElevated: Scalars['Boolean']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SessionResult = {
  __typename?: 'SessionResult';
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  sessionId: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export enum SessionTelemetryAppLifecycle {
  Active = 'ACTIVE',
  Background = 'BACKGROUND',
  Inactive = 'INACTIVE'
}

export enum SessionTelemetryAudioState {
  Failed = 'FAILED',
  Idle = 'IDLE',
  Interrupted = 'INTERRUPTED',
  Recording = 'RECORDING',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING'
}

export type SessionTelemetryBatchInput = {
  clientSessionId?: InputMaybe<Scalars['String']['input']>;
  events: Array<SessionTelemetryEventInput>;
  sessionId: Scalars['ID']['input'];
};

export type SessionTelemetryBatchResult = {
  __typename?: 'SessionTelemetryBatchResult';
  results: Array<SessionTelemetryEventResult>;
};

export enum SessionTelemetryCaptureState {
  Failed = 'FAILED',
  Idle = 'IDLE',
  Interrupted = 'INTERRUPTED',
  Recording = 'RECORDING',
  Recovering = 'RECOVERING',
  Starting = 'STARTING',
  Stopped = 'STOPPED'
}

export enum SessionTelemetryCategory {
  Audio = 'AUDIO',
  Connectivity = 'CONNECTIVITY',
  Gps = 'GPS',
  Heartbeat = 'HEARTBEAT',
  Recovery = 'RECOVERY',
  Session = 'SESSION',
  Synchronization = 'SYNCHRONIZATION'
}

export enum SessionTelemetryConnectivity {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Unknown = 'UNKNOWN'
}

export enum SessionTelemetryDisposition {
  Accepted = 'ACCEPTED',
  Duplicate = 'DUPLICATE',
  Rejected = 'REJECTED'
}

export type SessionTelemetryErrorInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
  truncated: Scalars['Boolean']['input'];
};

export type SessionTelemetryEventDetailsInput = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
  attemptsSinceLastReport?: InputMaybe<Scalars['Int']['input']>;
  captureGeneration?: InputMaybe<Scalars['String']['input']>;
  captureSequence?: InputMaybe<Scalars['Int']['input']>;
  captureState?: InputMaybe<SessionTelemetryCaptureState>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  elapsedMs?: InputMaybe<Scalars['Int']['input']>;
  failureReason?: InputMaybe<SessionTelemetryFailureReason>;
  highestObservedSegmentNumber?: InputMaybe<Scalars['Int']['input']>;
  inputPortType?: InputMaybe<Scalars['String']['input']>;
  interruptionDurationMs?: InputMaybe<Scalars['Int']['input']>;
  interruptionOptionShouldResume?: InputMaybe<Scalars['Boolean']['input']>;
  interruptionType?: InputMaybe<Scalars['String']['input']>;
  metadataVersion?: InputMaybe<Scalars['Int']['input']>;
  nextSegmentNumber?: InputMaybe<Scalars['Int']['input']>;
  outageId?: InputMaybe<Scalars['String']['input']>;
  outputPortTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredInputPortType?: InputMaybe<Scalars['String']['input']>;
  previousNextSegmentNumber?: InputMaybe<Scalars['Int']['input']>;
  recoveryMode?: InputMaybe<SessionTelemetryRecoveryMode>;
  routeChangeReason?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  segmentNumber?: InputMaybe<Scalars['Int']['input']>;
  teardownReason?: InputMaybe<SessionTelemetryFailureReason>;
  terminal?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<SessionTelemetryTrigger>;
  uploadStage?: InputMaybe<SessionTelemetryUploadStage>;
};

export type SessionTelemetryEventInput = {
  details?: InputMaybe<SessionTelemetryEventDetailsInput>;
  error?: InputMaybe<SessionTelemetryErrorInput>;
  eventId: Scalars['String']['input'];
  heartbeat?: InputMaybe<SessionTelemetryHeartbeatInput>;
  occurredAt: Scalars['DateTime']['input'];
  outcome: SessionTelemetryOutcome;
  sequence: Scalars['Int']['input'];
  source: SessionTelemetrySource;
  type: SessionTelemetryEventType;
};

export type SessionTelemetryEventResult = {
  __typename?: 'SessionTelemetryEventResult';
  disposition: SessionTelemetryDisposition;
  eventId: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionCode?: Maybe<SessionTelemetryRejectionCode>;
};

export enum SessionTelemetryEventType {
  AudioCaptureVerified = 'AUDIO_CAPTURE_VERIFIED',
  AudioFileMissing = 'AUDIO_FILE_MISSING',
  AudioInterrupted = 'AUDIO_INTERRUPTED',
  AudioInterruptionProlonged = 'AUDIO_INTERRUPTION_PROLONGED',
  AudioRecorderStarted = 'AUDIO_RECORDER_STARTED',
  AudioRecoveryAttempted = 'AUDIO_RECOVERY_ATTEMPTED',
  AudioRecoveryRetryFailed = 'AUDIO_RECOVERY_RETRY_FAILED',
  AudioResumed = 'AUDIO_RESUMED',
  AudioS3PutSucceeded = 'AUDIO_S3_PUT_SUCCEEDED',
  AudioSegmentCounterRecovered = 'AUDIO_SEGMENT_COUNTER_RECOVERED',
  AudioSegmentFinalized = 'AUDIO_SEGMENT_FINALIZED',
  AudioStartFailed = 'AUDIO_START_FAILED',
  AudioStartRequested = 'AUDIO_START_REQUESTED',
  AudioStoppedUnexpectedly = 'AUDIO_STOPPED_UNEXPECTEDLY',
  AudioStopCompleted = 'AUDIO_STOP_COMPLETED',
  AudioUploadAttempted = 'AUDIO_UPLOAD_ATTEMPTED',
  AudioUploadConfirmed = 'AUDIO_UPLOAD_CONFIRMED',
  AudioUploadFailed = 'AUDIO_UPLOAD_FAILED',
  CaptureTeardownCompleted = 'CAPTURE_TEARDOWN_COMPLETED',
  CaptureTeardownStarted = 'CAPTURE_TEARDOWN_STARTED',
  ConnectivityChanged = 'CONNECTIVITY_CHANGED',
  GpsBatchFailed = 'GPS_BATCH_FAILED',
  GpsBatchSucceeded = 'GPS_BATCH_SUCCEEDED',
  GpsStarted = 'GPS_STARTED',
  GpsStopped = 'GPS_STOPPED',
  GpsStopFailed = 'GPS_STOP_FAILED',
  GpsStopRequested = 'GPS_STOP_REQUESTED',
  Heartbeat = 'HEARTBEAT',
  RecoveryCompleted = 'RECOVERY_COMPLETED',
  RecoveryFailed = 'RECOVERY_FAILED',
  RecoveryStarted = 'RECOVERY_STARTED',
  SessionActive = 'SESSION_ACTIVE',
  SessionComplete = 'SESSION_COMPLETE',
  SessionEndConfirmed = 'SESSION_END_CONFIRMED',
  SessionEndQueued = 'SESSION_END_QUEUED',
  SessionEndRequested = 'SESSION_END_REQUESTED',
  SessionServerBound = 'SESSION_SERVER_BOUND',
  SessionStartRequested = 'SESSION_START_REQUESTED',
  SyncCompleted = 'SYNC_COMPLETED',
  SyncFailed = 'SYNC_FAILED',
  SyncStarted = 'SYNC_STARTED',
  TelemetryFlushRecovered = 'TELEMETRY_FLUSH_RECOVERED'
}

export enum SessionTelemetryFailureReason {
  AudioFocusUnavailable = 'AUDIO_FOCUS_UNAVAILABLE',
  AudioSessionUnavailable = 'AUDIO_SESSION_UNAVAILABLE',
  ConfirmationFailed = 'CONFIRMATION_FAILED',
  DeferredJsUnavailable = 'DEFERRED_JS_UNAVAILABLE',
  FlushTimeout = 'FLUSH_TIMEOUT',
  MetadataInvalid = 'METADATA_INVALID',
  PermissionDenied = 'PERMISSION_DENIED',
  PermissionRevoked = 'PERMISSION_REVOKED',
  RecorderEncodingFailed = 'RECORDER_ENCODING_FAILED',
  RecorderInitFailed = 'RECORDER_INIT_FAILED',
  S3PutFailed = 'S3_PUT_FAILED',
  SigningFailed = 'SIGNING_FAILED',
  StartTimeout = 'START_TIMEOUT',
  StopFailed = 'STOP_FAILED',
  StorageUnavailable = 'STORAGE_UNAVAILABLE',
  UnknownNativeError = 'UNKNOWN_NATIVE_ERROR',
  UserEnd = 'USER_END'
}

export enum SessionTelemetryGpsState {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Idle = 'IDLE',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING'
}

export type SessionTelemetryHeartbeatInput = {
  appBuild?: InputMaybe<Scalars['String']['input']>;
  appLifecycle: SessionTelemetryAppLifecycle;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  audioState: SessionTelemetryAudioState;
  capturedSegmentCount: Scalars['Int']['input'];
  confirmedUploadCount: Scalars['Int']['input'];
  connectivity: SessionTelemetryConnectivity;
  gpsState: SessionTelemetryGpsState;
  lastGpsBatchAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastGpsBatchPointCount: Scalars['Int']['input'];
  lastSegmentCapturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSegmentNumber?: InputMaybe<Scalars['Int']['input']>;
  lastUploadAttemptAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastUploadFailureStage?: InputMaybe<SessionTelemetryUploadStage>;
  lastUploadSuccessAt?: InputMaybe<Scalars['DateTime']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  pendingUploadCount: Scalars['Int']['input'];
  platform?: InputMaybe<SessionTelemetryPlatform>;
  s3PutSuccessCount: Scalars['Int']['input'];
  sessionState: SessionTelemetrySessionState;
  telemetryQueueDepth: Scalars['Int']['input'];
};

export enum SessionTelemetryOutcome {
  Failure = 'FAILURE',
  Info = 'INFO',
  Success = 'SUCCESS'
}

export enum SessionTelemetryPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum SessionTelemetryRecoveryMode {
  Reattached = 'REATTACHED',
  Restarted = 'RESTARTED'
}

export enum SessionTelemetryRejectionCode {
  EventIdConflict = 'EVENT_ID_CONFLICT',
  InvalidEvent = 'INVALID_EVENT',
  SequenceConflict = 'SEQUENCE_CONFLICT',
  SessionNotFound = 'SESSION_NOT_FOUND'
}

export enum SessionTelemetrySessionState {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Ended = 'ENDED',
  Ending = 'ENDING',
  Starting = 'STARTING'
}

export enum SessionTelemetrySource {
  App = 'APP',
  Native = 'NATIVE'
}

export enum SessionTelemetryTrigger {
  Foreground = 'FOREGROUND',
  Interruption = 'INTERRUPTION',
  PermissionChange = 'PERMISSION_CHANGE',
  RecorderError = 'RECORDER_ERROR',
  Relaunch = 'RELAUNCH',
  Start = 'START',
  UserEnd = 'USER_END'
}

export enum SessionTelemetryUploadStage {
  S3Put = 'S3_PUT',
  ServerConfirmation = 'SERVER_CONFIRMATION',
  UploadUrl = 'UPLOAD_URL'
}

export type SessionTranscriptEntryDto = {
  __typename?: 'SessionTranscriptEntryDto';
  confidence: Scalars['Float']['output'];
  occurredAt: Scalars['Float']['output'];
  speaker: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum SessionTranscriptionEligibility {
  Disabled = 'DISABLED',
  Eligible = 'ELIGIBLE',
  InProgress = 'IN_PROGRESS',
  RecordingNotMerged = 'RECORDING_NOT_MERGED',
  SessionActive = 'SESSION_ACTIVE'
}

export enum SessionTranscriptionFailureCode {
  AnalysisTimeout = 'ANALYSIS_TIMEOUT',
  CoreConfigurationRequired = 'CORE_CONFIGURATION_REQUIRED',
  CoreRejected = 'CORE_REJECTED',
  CoreResponseInvalid = 'CORE_RESPONSE_INVALID',
  RecordingIdentityInvalid = 'RECORDING_IDENTITY_INVALID',
  RecordingUnavailable = 'RECORDING_UNAVAILABLE',
  SubmissionFailed = 'SUBMISSION_FAILED'
}

export type SessionTranscriptionResultDto = {
  __typename?: 'SessionTranscriptionResultDto';
  completedAt: Scalars['DateTime']['output'];
  conversationalTags: Array<Scalars['String']['output']>;
  extractedSlots: Scalars['SessionTranscriptionSlots']['output'];
  observations: Array<Scalars['String']['output']>;
  revision: Scalars['Int']['output'];
  runId: Scalars['ID']['output'];
  transcript: Array<SessionTranscriptEntryDto>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SessionTranscriptionRunDto = {
  __typename?: 'SessionTranscriptionRunDto';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  coreCallId?: Maybe<Scalars['String']['output']>;
  coreLeadId?: Maybe<Scalars['String']['output']>;
  coreLeadUrl?: Maybe<Scalars['String']['output']>;
  errorSummary?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<SessionTranscriptionFailureCode>;
  id: Scalars['ID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  status: SessionTranscriptionStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  warnings: Array<CanvassingSessionRecordingWarning>;
};

export enum SessionTranscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Submitting = 'SUBMITTING'
}

export type SetBoomTownUserTagMutation = {
  __typename?: 'SetBoomTownUserTagMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SetDefaultCampaignMutation = {
  __typename?: 'SetDefaultCampaignMutation';
  campaign?: Maybe<CampaignType>;
};

export type SetFollowUpBossV2CustomFieldMutation = {
  __typename?: 'SetFollowUpBossV2CustomFieldMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SetHubSpotV2CustomFieldMutation = {
  __typename?: 'SetHubSpotV2CustomFieldMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SetSalesForceV2CustomFieldMutation = {
  __typename?: 'SetSalesForceV2CustomFieldMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SierraInteractiveEmailPlatformType = {
  __typename?: 'SierraInteractiveEmailPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SierraInteractiveTwilioPlatformType = {
  __typename?: 'SierraInteractiveTwilioPlatformType';
  accountSid: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
};

export type SignupAgentMutation = {
  __typename?: 'SignupAgentMutation';
  agentId?: Maybe<Scalars['ID']['output']>;
};

export type SlotSchemaInputType = {
  description: Scalars['String']['input'];
  enum?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  types: Array<Scalars['String']['input']>;
};

export type SlotSchemaType = {
  __typename?: 'SlotSchemaType';
  description: Scalars['String']['output'];
  enum?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export enum SlotType {
  DateTime = 'DATE_TIME',
  FixedValues = 'FIXED_VALUES',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export type SlotValueType = {
  unit?: Maybe<Scalars['String']['output']>;
};

export type SmoochMailgunPlatformType = {
  __typename?: 'SmoochMailgunPlatformType';
  channelType: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  incomingAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
  smoochId: Scalars['String']['output'];
};

export type SmoochMessageBirdPlatformType = {
  __typename?: 'SmoochMessageBirdPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  smoochId: Scalars['String']['output'];
};

export type SmoochTwilioPlatformType = {
  __typename?: 'SmoochTwilioPlatformType';
  accountSid: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
  smoochId: Scalars['String']['output'];
};

export type StartAiAgentTestMutation = {
  __typename?: 'StartAiAgentTestMutation';
  customerId?: Maybe<Scalars['String']['output']>;
};

export type StartAiAgentVoiceTestMutation = {
  __typename?: 'StartAiAgentVoiceTestMutation';
  callId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  websocketEndpoint: Scalars['String']['output'];
};

export type StartCallMutation = {
  __typename?: 'StartCallMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartCallWithDigitalAgentMutation = {
  __typename?: 'StartCallWithDigitalAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StartConversationIntegrations = {
  integration: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
  value: Scalars['IntegrationId']['input'];
};

export type StartConversationMetadata = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  brokerageId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  integration?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<StartConversationIntegrations>>>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  slots?: InputMaybe<Array<InputMaybe<StartConversationSlots>>>;
  source: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  testPayloadClearDupeLeads?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StartConversationSlots = {
  name: Scalars['String']['input'];
  value: Scalars['SlotValue']['input'];
};

export type StartNewConvoMutation = {
  __typename?: 'StartNewConvoMutation';
  customerId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type StartVoiceAiWebCallMutation = {
  __typename?: 'StartVoiceAiWebCallMutation';
  assistantId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
};

export type StringSlotValueType = SlotValueType & {
  __typename?: 'StringSlotValueType';
  sValue?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type StripeCustomerPortalSession = {
  __typename?: 'StripeCustomerPortalSession';
  session?: Maybe<Scalars['String']['output']>;
};

export type StructurelyRoiType = {
  __typename?: 'StructurelyRoiType';
  appointmentSetToCloseRatio?: Maybe<Scalars['Float']['output']>;
  averageCommissionRate?: Maybe<Scalars['Float']['output']>;
  averageSellingPrice?: Maybe<Scalars['Float']['output']>;
  comissionInfluencedRevenue?: Maybe<Scalars['Float']['output']>;
  isBrokerage?: Maybe<Scalars['Boolean']['output']>;
  pipelineInfluencedRevenue?: Maybe<Scalars['Float']['output']>;
  roi?: Maybe<Scalars['Float']['output']>;
  structurelyPayments?: Maybe<Scalars['Float']['output']>;
  totalAppointmentsSet?: Maybe<Scalars['Int']['output']>;
  totalClosedWon?: Maybe<Scalars['Int']['output']>;
  totalLeadsProcessed?: Maybe<Scalars['Int']['output']>;
};

export type SubAccountFullReport = {
  __typename?: 'SubAccountFullReport';
  end: Scalars['DateTime']['output'];
  leads: Scalars['Int']['output'];
  leadsAgentFollowUp: Scalars['Int']['output'];
  leadsAgentFollowUpAndMuted: Scalars['Int']['output'];
  leadsAgentFollowUpAndMutedChange: Scalars['Float']['output'];
  leadsAgentFollowUpAndMutedDelta: Scalars['Int']['output'];
  leadsAgentFollowUpChange: Scalars['Float']['output'];
  leadsAgentFollowUpDelta: Scalars['Int']['output'];
  leadsChange: Scalars['Float']['output'];
  leadsDelta: Scalars['Int']['output'];
  leadsInterested: Scalars['Int']['output'];
  leadsInterestedAndMuted: Scalars['Int']['output'];
  leadsInterestedAndMutedChange: Scalars['Float']['output'];
  leadsInterestedAndMutedDelta: Scalars['Int']['output'];
  leadsInterestedChange: Scalars['Float']['output'];
  leadsInterestedDelta: Scalars['Int']['output'];
  leadsMuted: Scalars['Int']['output'];
  leadsMutedChange: Scalars['Float']['output'];
  leadsMutedDelta: Scalars['Int']['output'];
  leadsNotInterested: Scalars['Int']['output'];
  leadsNotInterestedChange: Scalars['Float']['output'];
  leadsNotInterestedDelta: Scalars['Int']['output'];
  leadsWithAppointment: Scalars['Int']['output'];
  leadsWithAppointmentChange: Scalars['Float']['output'];
  leadsWithAppointmentDelta: Scalars['Int']['output'];
  leadsWithResponse: Scalars['Int']['output'];
  leadsWithResponseChange: Scalars['Float']['output'];
  leadsWithResponseDelta: Scalars['Int']['output'];
  start: Scalars['DateTime']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  agentCallUpdated?: Maybe<VoiceCallUpdateType>;
  agentCustomerUpdates?: Maybe<AgentCustomerUpdatesType>;
  agentUnreadCountUpdates?: Maybe<UnreadCountUpdateType>;
  brokerageCustomerUpdates?: Maybe<BrokerageCustomerUpdatesType>;
  conversationAnalyticsMessagesAdded?: Maybe<AnalyticsConversationMessageAdditionType>;
  conversationMessagesAdded?: Maybe<ConversationMessageAdditionType>;
  customerCallUpdated?: Maybe<VoiceCallUpdateType>;
  teamCustomerUpdates?: Maybe<TeamCustomerUpdatesType>;
};


export type SubscriptionAgentCallUpdatedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionAgentCustomerUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionAgentUnreadCountUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionBrokerageCustomerUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionConversationAnalyticsMessagesAddedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionConversationMessagesAddedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionCustomerCallUpdatedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionTeamCustomerUpdatesArgs = {
  id: Scalars['ID']['input'];
};

export type SubscriptionCardType = {
  __typename?: 'SubscriptionCardType';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  isPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  linkEmail?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  validBillingAddress?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionSeatBundleType = {
  __typename?: 'SubscriptionSeatBundleType';
  bundle?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Paused = 'PAUSED'
}

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  basePlanType?: Maybe<PlanType>;
  canUsePortalSession?: Maybe<Scalars['Boolean']['output']>;
  card?: Maybe<SubscriptionCardType>;
  currentCallCount?: Maybe<Scalars['Int']['output']>;
  currentLeadCount?: Maybe<Scalars['Int']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use canUsePortalSession instead so we do not need to worry about timeouts */
  customerPortalSession?: Maybe<Scalars['String']['output']>;
  hatchIsaScriptsPlan?: Maybe<Scalars['String']['output']>;
  leadOverageCount?: Maybe<Scalars['Int']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated MLS plans have been removed */
  package?: Maybe<Scalars['String']['output']>;
  pendingDowngrade?: Maybe<PendingDowngradeType>;
  plan?: Maybe<Scalars['String']['output']>;
  scriptCustomizationPlan?: Maybe<Scalars['String']['output']>;
  seatBundles?: Maybe<Array<Maybe<SubscriptionSeatBundleType>>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type SupportedLanguagesInputType = {
  english?: InputMaybe<Scalars['Boolean']['input']>;
  french?: InputMaybe<Scalars['Boolean']['input']>;
  spanish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupportedLanguagesType = {
  __typename?: 'SupportedLanguagesType';
  english?: Maybe<Scalars['Boolean']['output']>;
  french?: Maybe<Scalars['Boolean']['output']>;
  spanish?: Maybe<Scalars['Boolean']['output']>;
};

export type TagsType = {
  __typename?: 'TagsType';
  bathroom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bedroom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  general?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TaskType = {
  __typename?: 'TaskType';
  assignedAgent?: Maybe<AgentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reminderAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TcrBrandType = {
  __typename?: 'TcrBrandType';
  associatedEntities: Array<GenericReferenceType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identityStatus: Scalars['String']['output'];
  mock: Scalars['Boolean']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tcrBrandId: Scalars['String']['output'];
  tcrCreateDate: Scalars['DateTime']['output'];
  tcrCspId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TcrCampaignType = {
  __typename?: 'TcrCampaignType';
  associatedEntities: Array<GenericReferenceType>;
  autoRenewal: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mock: Scalars['Boolean']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tcrBrandId: Scalars['String']['output'];
  tcrCampaignId: Scalars['String']['output'];
  tcrCreateDate: Scalars['DateTime']['output'];
  tcrCspId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usecase: Scalars['String']['output'];
};

export type TeamCustomerUpdatesType = {
  __typename?: 'TeamCustomerUpdatesType';
  agentId?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<CustomerType>;
  type?: Maybe<CustomerEventEnum>;
};

export type TeamInputType = {
  name: Scalars['String']['input'];
  officeLocation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAreaCode?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<TeamSettingsInputType>;
  thirdPartyApiKeys?: InputMaybe<ThirdPartyApiKeysInputType>;
  thirdPartyOptions?: InputMaybe<ThirdPartyOptionsInputType>;
};

export type TeamInviteType = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TeamMutation = {
  __typename?: 'TeamMutation';
  team?: Maybe<TeamType>;
};

export type TeamSettingsInputType = {
  callingHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotAllowedDomains?: InputMaybe<ChatbotAllowedDomainsInputType>;
  chatbotDomains?: InputMaybe<Array<InputMaybe<Domain>>>;
  chatbotDripCampaigns?: InputMaybe<ChatbotDripCampaignsInputType>;
  chatbotEmailResponseDelay?: InputMaybe<Scalars['Int']['input']>;
  chatbotHoursOfOperation?: InputMaybe<ChatbotHoursOfOperationInputType>;
  chatbotLeadTypes?: InputMaybe<ChatbotLeadTypesInputType>;
  chatbotTimezone?: InputMaybe<Scalars['String']['input']>;
  defaultChatbotName?: InputMaybe<Scalars['String']['input']>;
  firstToClaimEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  overrideHoursOfOperation?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
};

export type TeamSettingsType = {
  __typename?: 'TeamSettingsType';
  callingHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  /** @deprecated Use chatbot_domains instead */
  chatbotAllowedDomains?: Maybe<ChatbotAllowedDomainsType>;
  chatbotDomains?: Maybe<Array<Maybe<Domain>>>;
  chatbotDripCampaigns?: Maybe<ChatbotDripCampaignsType>;
  chatbotEmailResponseDelay?: Maybe<Scalars['Int']['output']>;
  chatbotHoursOfOperation?: Maybe<ChatbotHoursOfOperationType>;
  chatbotLeadTypes?: Maybe<ChatbotLeadTypesType>;
  chatbotTimezone?: Maybe<Scalars['String']['output']>;
  defaultChatbotName?: Maybe<Scalars['String']['output']>;
  firstToClaimEnabled?: Maybe<Scalars['Boolean']['output']>;
  overrideHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  schedulingLink?: Maybe<Scalars['String']['output']>;
};

export type TeamType = RealtorEntityType & {
  __typename?: 'TeamType';
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  a2pStatus?: Maybe<A2PStatusEnum>;
  accountCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  activeLeadTypes?: Maybe<Array<Scalars['String']['output']>>;
  advancedBehaviors?: Maybe<Array<AdvancedBehaviorType>>;
  advancedCallRouting?: Maybe<Array<AdvancedCallRoutingType>>;
  agents?: Maybe<Array<Maybe<AgentType>>>;
  allowAgentLegendIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowAiAgentAdvancedTab?: Maybe<Scalars['Boolean']['output']>;
  allowAiTextAgents?: Maybe<Scalars['Boolean']['output']>;
  allowAiVoiceAgents?: Maybe<Scalars['Boolean']['output']>;
  allowBiReporting?: Maybe<Scalars['Boolean']['output']>;
  allowBonzoIntegration?: Maybe<Scalars['Boolean']['output']>;
  allowCalendlyScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowCampaigns?: Maybe<Scalars['Boolean']['output']>;
  allowCustomScripts?: Maybe<Scalars['Boolean']['output']>;
  allowCustomSlots?: Maybe<Scalars['Boolean']['output']>;
  allowCustomStages?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTools?: Maybe<Scalars['Boolean']['output']>;
  allowCustomTwilio?: Maybe<Scalars['Boolean']['output']>;
  allowExperimentalUi?: Maybe<Scalars['Boolean']['output']>;
  allowHardAppointmentScheduling?: Maybe<Scalars['Boolean']['output']>;
  allowIntercom?: Maybe<Scalars['Boolean']['output']>;
  allowMailgun?: Maybe<Scalars['Boolean']['output']>;
  allowMembersTesting?: Maybe<Scalars['Boolean']['output']>;
  allowMessagingChannels?: Maybe<Scalars['Boolean']['output']>;
  allowMultiConversations?: Maybe<Scalars['Boolean']['output']>;
  allowMultiSmsChannels?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialer?: Maybe<Scalars['Boolean']['output']>;
  allowPlatformDialerExperimentalSettings?: Maybe<Scalars['Boolean']['output']>;
  allowPortalBetaAccess?: Maybe<Scalars['Boolean']['output']>;
  allowRemarketing?: Maybe<Scalars['Boolean']['output']>;
  allowVoiceChannels?: Maybe<Scalars['Boolean']['output']>;
  allowedEmailDomains?: Maybe<Array<Maybe<DomainType>>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  behaviors?: Maybe<Array<BehaviorType>>;
  billingInvoices: Array<BillingInvoiceType>;
  builtinSlots?: Maybe<Array<BrainSlotType>>;
  callDispositions?: Maybe<Array<Scalars['String']['output']>>;
  callsPerDay?: Maybe<Scalars['Int']['output']>;
  campaigns?: Maybe<Array<CampaignType>>;
  communicationChannels?: Maybe<Array<CommunicationChannelType>>;
  communicationProfiles?: Maybe<Array<CommunicationProfileType>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFlows?: Maybe<Array<Maybe<CustomFlowType>>>;
  customIntents?: Maybe<Array<Maybe<CustomIntentType>>>;
  customReportCsvs?: Maybe<Array<DirectPlatformCustomReportType>>;
  customScripts?: Maybe<Array<Maybe<CustomScriptType>>>;
  customSlots?: Maybe<Array<CustomizedSlotType>>;
  customStages?: Maybe<Array<CustomizedStageType>>;
  customTools?: Maybe<Array<CustomToolDefinitionType>>;
  customTwilioToken?: Maybe<TwilioAuthTokenType>;
  customers?: Maybe<Array<Maybe<CustomerType>>>;
  email?: Maybe<Scalars['String']['output']>;
  enableTextAiCampaignEnrollment?: Maybe<Scalars['Boolean']['output']>;
  externalCampaignMatcher?: Maybe<Scalars['String']['output']>;
  fauxAgentsInheritHoursOfOperation?: Maybe<Scalars['Boolean']['output']>;
  forceVoiceOrchestration?: Maybe<Scalars['Boolean']['output']>;
  generatedApiKey?: Maybe<Scalars['String']['output']>;
  hasEmailChannel?: Maybe<Scalars['Boolean']['output']>;
  hasSmsChannel?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integrations?: Maybe<AppIntegrationsType>;
  isHighScale?: Maybe<Scalars['Boolean']['output']>;
  isZendesk?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadEnrollmentRules?: Maybe<Array<Maybe<LeadEnrollmentRuleType>>>;
  leadQualification?: Maybe<LeadQualificationType>;
  leadRouting: LeadRoutingSettingsType;
  listCustomers?: Maybe<CustomerPaginationType>;
  liveTransferAnalytics?: Maybe<Array<VoiceCallType>>;
  liveTransferWhisperDelaySeconds?: Maybe<Scalars['Float']['output']>;
  localPresenceSettings: LocalPresenceSettingsType;
  /** @deprecated Use the joined list `agents` instead */
  members?: Maybe<Array<Maybe<AgentType>>>;
  multiConversationsCanBeActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  paragonConnectJwt?: Maybe<ParagonTokenType>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredAreaCode?: Maybe<Scalars['String']['output']>;
  priceAvg?: Maybe<Scalars['Int']['output']>;
  pubSubSubscriptions?: Maybe<Array<PubSubSubscriptionType>>;
  recentlyCreatedTasks?: Maybe<Array<Maybe<TaskType>>>;
  reseller?: Maybe<ResellerSubscriptionPlanType>;
  scheduledCallingStatus?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<TeamSettingsType>;
  smoochId?: Maybe<Scalars['String']['output']>;
  structurelyRoi?: Maybe<StructurelyRoiType>;
  subscription?: Maybe<SubscriptionType>;
  /** @deprecated Use the joined list `agents` instead */
  teamLeads?: Maybe<Array<Maybe<AgentType>>>;
  textAiAgents?: Maybe<Array<TextAiAgentType>>;
  thirdPartyApiKeys?: Maybe<ThirdPartyApiKeysType>;
  thirdPartyOptions?: Maybe<ThirdPartyOptionsType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  totalCustomersCount?: Maybe<Scalars['Int']['output']>;
  totalUnreadCount?: Maybe<Scalars['Int']['output']>;
  upcomingReminderTasks?: Maybe<Array<Maybe<TaskType>>>;
  userIntegrations: UserIntegrationsType;
  voiceAiAgents?: Maybe<Array<VoiceAiAgentType>>;
  voiceCallSummary?: Maybe<VoiceCallSummaryType>;
};


export type TeamTypeAdvancedBehaviorsArgs = {
  integrationName: Scalars['String']['input'];
};


export type TeamTypeBillingInvoicesArgs = {
  billingInterval?: InputMaybe<BillingInvoiceInterval>;
};


export type TeamTypeCustomFlowsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type TeamTypeCustomIntentsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type TeamTypeCustomScriptsArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  leadTypes?: InputMaybe<Array<InputMaybe<ScriptLeadTypes>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<ScriptSourceTypes>>>;
};


export type TeamTypeCustomersArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cursor?: InputMaybe<CursorInputType>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TeamTypeLeadEnrollmentRulesArgs = {
  isActives?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};


export type TeamTypeLeadQualificationArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  assignedAgentId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeamTypeListCustomersArgs = {
  currentCampaign?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  customSlots?: InputMaybe<Scalars['JSONString']['input']>;
  customStages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeLiveTransferAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type TeamTypePubSubSubscriptionsArgs = {
  integration: Scalars['String']['input'];
};


export type TeamTypeRecentlyCreatedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamTypeStructurelyRoiArgs = {
  appointmentSetToCloseRatio?: InputMaybe<Scalars['Float']['input']>;
  averageCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  averageSellingPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type TeamTypeTotalCustomersCountArgs = {
  agentEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  callDispositions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customerEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSONString']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TeamTypeUpcomingReminderTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum TelcoType {
  LiveTesting = 'LIVE_TESTING',
  MessageBird = 'MESSAGE_BIRD',
  Partner = 'PARTNER',
  RingCentral = 'RING_CENTRAL',
  Telnyx = 'TELNYX',
  Twilio = 'TWILIO',
  Unknown = 'UNKNOWN',
  Vonage = 'VONAGE'
}

export type TelnyxPlatformType = {
  __typename?: 'TelnyxPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type TelnyxProfileType = {
  __typename?: 'TelnyxProfileType';
  callControlId?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  messagingId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outboundVoiceProfileId?: Maybe<Scalars['String']['output']>;
};

export enum TerminalStagesType {
  NoTermination = 'NO_TERMINATION',
  TextAi = 'TEXT_AI',
  VoiceAi = 'VOICE_AI',
  VoiceAndTextAi = 'VOICE_AND_TEXT_AI'
}

export type TestCustomToolInputType = {
  channel: CustomToolChannel;
  sampleFunctionArguments?: InputMaybe<Scalars['GenericScalar']['input']>;
  sampleMergeFields?: InputMaybe<Scalars['GenericScalar']['input']>;
};

export type TestCustomToolMutation = {
  __typename?: 'TestCustomToolMutation';
  result: TestCustomToolResultType;
};

export type TestCustomToolPayload = {
  channels?: InputMaybe<Array<CustomToolChannel>>;
  functionSchema?: InputMaybe<Scalars['GenericScalar']['input']>;
  httpBodyExtras?: InputMaybe<Array<CustomToolHttpBodyExtraInputType>>;
  httpContentType?: InputMaybe<CustomToolHttpContentType>;
  httpEndpoint: Scalars['String']['input'];
  httpHeaders?: InputMaybe<Array<CustomToolKeyValueInputType>>;
  httpMethod: CustomToolHttpMethod;
  responseNormalizationPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  slotMappings?: InputMaybe<Array<CustomToolSlotMappingInputType>>;
};

export type TestCustomToolRawResponseType = {
  __typename?: 'TestCustomToolRawResponseType';
  bodyJson?: Maybe<Scalars['GenericScalar']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  headers: Scalars['GenericScalar']['output'];
};

export type TestCustomToolRequestPreviewType = {
  __typename?: 'TestCustomToolRequestPreviewType';
  channel: CustomToolChannel;
  headers: Scalars['GenericScalar']['output'];
  method: CustomToolHttpMethod;
  resolvedBody?: Maybe<Scalars['GenericScalar']['output']>;
  timeoutMs: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type TestCustomToolResultType = {
  __typename?: 'TestCustomToolResultType';
  completionMessage: Scalars['String']['output'];
  elapsedMs: Scalars['Float']['output'];
  mappedSlots: Scalars['GenericScalar']['output'];
  normalizedResponse?: Maybe<Scalars['GenericScalar']['output']>;
  rawResponse?: Maybe<TestCustomToolRawResponseType>;
  requestPreview: TestCustomToolRequestPreviewType;
  responseStatusCode?: Maybe<Scalars['Int']['output']>;
};

export type TestingPlatformType = {
  __typename?: 'TestingPlatformType';
  channelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TextAiAgentInputType = {
  allowSpellingErrors?: InputMaybe<Scalars['Boolean']['input']>;
  clientWhisperTemplate?: InputMaybe<Scalars['String']['input']>;
  communicationStyle: Scalars['String']['input'];
  conversationalIntent?: InputMaybe<Scalars['String']['input']>;
  customAnswers?: InputMaybe<Array<CustomVoicePromptAnswerInputType>>;
  customGreeting?: InputMaybe<Scalars['String']['input']>;
  customQuestions?: InputMaybe<Array<CustomVoicePromptQuestionInputType>>;
  customToolAttachments?: InputMaybe<Array<CustomToolAttachmentInputType>>;
  disqualificationCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  dripConfiguration: DripConfigurationInputType;
  emailSubjectTemplate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTitle: Scalars['String']['input'];
  knowledgeBases?: InputMaybe<Array<Scalars['String']['input']>>;
  leadType?: InputMaybe<Scalars['String']['input']>;
  liveTransferTemplate?: InputMaybe<Scalars['String']['input']>;
  llmModelFamily?: InputMaybe<VendorModelFamilyEnum>;
  name: Scalars['String']['input'];
  nurtureCampaign?: InputMaybe<Array<InputMaybe<DripResponseInputType>>>;
  outcomeConfiguration?: InputMaybe<TextOutcomeConfigurationInputType>;
  persona: Scalars['String']['input'];
  promptTemplate: Scalars['String']['input'];
  specializedGuidance?: InputMaybe<Scalars['String']['input']>;
  supportedLanguages?: InputMaybe<SupportedLanguagesInputType>;
  suppressSmsAfterCallMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TextAiAgentType = {
  __typename?: 'TextAiAgentType';
  allowSpellingErrors?: Maybe<Scalars['Boolean']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  clientWhisperTemplate?: Maybe<Scalars['String']['output']>;
  communicationStyle: Scalars['String']['output'];
  conversationalIntent?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customAnswers?: Maybe<Array<CustomVoicePromptAnswerType>>;
  customGreeting?: Maybe<Scalars['String']['output']>;
  customQuestions?: Maybe<Array<CustomVoicePromptQuestionType>>;
  customToolAttachments?: Maybe<Array<AiAgentCustomToolAttachmentType>>;
  disqualificationCriteria?: Maybe<Array<Scalars['String']['output']>>;
  dripConfiguration: DripConfigurationType;
  emailSubjectTemplate?: Maybe<Scalars['String']['output']>;
  hasCampaign: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Scalars['String']['output'];
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadType?: Maybe<Scalars['String']['output']>;
  liveTransferTemplate?: Maybe<Scalars['String']['output']>;
  llmModelFamily?: Maybe<VendorModelFamilyEnum>;
  name: Scalars['String']['output'];
  nurtureCampaign?: Maybe<Array<Maybe<DripResponseType>>>;
  outcomeConfiguration?: Maybe<TextOutcomeConfigurationType>;
  persona: Scalars['String']['output'];
  promptTemplate: PromptTemplateType;
  specializedGuidance?: Maybe<Scalars['String']['output']>;
  supportedLanguages?: Maybe<SupportedLanguagesType>;
  suppressSmsAfterCallMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TextAiResponseType = {
  __typename?: 'TextAiResponseType';
  completionResponse?: Maybe<Scalars['GenericScalar']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  messageContext?: Maybe<Array<Scalars['GenericScalar']['output']>>;
  requestPayload?: Maybe<Scalars['GenericScalar']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  tools?: Maybe<Array<Scalars['GenericScalar']['output']>>;
};

export type TextOutcomeConfigurationInputType = {
  externalSchedulingLink?: InputMaybe<Scalars['String']['input']>;
  liveTransferToAi?: InputMaybe<Scalars['String']['input']>;
  liveTransferToHuman?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleCalendarAppointment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextOutcomeConfigurationType = {
  __typename?: 'TextOutcomeConfigurationType';
  externalSchedulingLink?: Maybe<Scalars['String']['output']>;
  liveTransferToAi?: Maybe<Scalars['String']['output']>;
  liveTransferToHuman?: Maybe<Scalars['Boolean']['output']>;
  scheduleCalendarAppointment?: Maybe<Scalars['Boolean']['output']>;
};

export type ThirdPartyApiKeysInputType = {
  chime?: InputMaybe<Scalars['String']['input']>;
  followupboss?: InputMaybe<Scalars['String']['input']>;
  realsynch?: InputMaybe<Scalars['String']['input']>;
  sierrainteractive?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyApiKeysType = {
  __typename?: 'ThirdPartyAPIKeysType';
  boomtown?: Maybe<Scalars['Boolean']['output']>;
  chime?: Maybe<Scalars['String']['output']>;
  followupboss?: Maybe<Scalars['String']['output']>;
  liondesk?: Maybe<Scalars['Boolean']['output']>;
  realsynch?: Maybe<Scalars['String']['output']>;
  sierrainteractive?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyIntegrationCustomerType = {
  __typename?: 'ThirdPartyIntegrationCustomerType';
  chatbotMuted?: Maybe<Scalars['Boolean']['output']>;
};

export type ThirdPartyIntegrationToggleMuteCustomerMutation = {
  __typename?: 'ThirdPartyIntegrationToggleMuteCustomerMutation';
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type ThirdPartyIntegrationType = {
  __typename?: 'ThirdPartyIntegrationType';
  boomtown: Array<Maybe<IntegrationProperty>>;
  followupboss: Array<Maybe<IntegrationProperty>>;
  hubspot: Array<Maybe<IntegrationProperty>>;
};

export type ThirdPartyOptionsInputType = {
  followupboss?: InputMaybe<FollowUpBossOptionsInputType>;
};

export type ThirdPartyOptionsType = {
  __typename?: 'ThirdPartyOptionsType';
  acculynx?: Maybe<AcculynxOptionsType>;
  agentLegend?: Maybe<AgentLegendOptionsType>;
  bonzo?: Maybe<BonzoOptionsType>;
  boomtown?: Maybe<BoomtownOptionsType>;
  followupboss?: Maybe<FollowUpBossOptionsType>;
  followupbossV2?: Maybe<FollowUpBossOptionsV2Type>;
  gohighlevel?: Maybe<GoHighLevelOptionsType>;
  hubspot?: Maybe<HubSpotOptionsType>;
  leadconnectorhq?: Maybe<LeadConnectorHqOptionsType>;
  leadperfection?: Maybe<LeadPerfectionOptionsType>;
  marketsharp?: Maybe<MarketSharpOptionsType>;
  salesforce?: Maybe<SalesForceOptionsType>;
};

export type TranscriptionEventType = {
  __typename?: 'TranscriptionEventType';
  confidence: Scalars['Float']['output'];
  occurredAt: Scalars['DateTime']['output'];
  speaker: Scalars['String']['output'];
  transcript: Scalars['String']['output'];
};

export type TriggerFollowUpBossTagSyncMutation = {
  __typename?: 'TriggerFollowUpBossTagSyncMutation';
  entityId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  queued?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerPendingActivityMutation = {
  __typename?: 'TriggerPendingActivityMutation';
  dispatched: Scalars['Boolean']['output'];
  result: Scalars['Boolean']['output'];
  taskId: Scalars['ID']['output'];
};

export type TwilioA2PProfileInputType = {
  allFormsHaveOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  authorizedRepBusinessTitle?: InputMaybe<Scalars['String']['input']>;
  authorizedRepEmail?: InputMaybe<Scalars['String']['input']>;
  authorizedRepFirstName?: InputMaybe<Scalars['String']['input']>;
  authorizedRepJobPosition?: InputMaybe<Scalars['String']['input']>;
  authorizedRepLastName?: InputMaybe<Scalars['String']['input']>;
  authorizedRepPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessAddressCity?: InputMaybe<Scalars['String']['input']>;
  businessAddressCountry?: InputMaybe<Scalars['String']['input']>;
  businessAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  businessAddressState?: InputMaybe<Scalars['String']['input']>;
  businessAddressStreet?: InputMaybe<Scalars['String']['input']>;
  businessAddressStreetSecondary?: InputMaybe<Scalars['String']['input']>;
  businessCountry?: InputMaybe<Scalars['String']['input']>;
  businessEin?: InputMaybe<Scalars['String']['input']>;
  businessLegalName?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  businessWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  optInLanguageElementsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  powerOfAttorneyDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyNoSharing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TwilioAuthTokenType = {
  __typename?: 'TwilioAuthTokenType';
  accountSid: Scalars['String']['output'];
  accountToken: Scalars['String']['output'];
};

export type TwilioIntegrationType = {
  __typename?: 'TwilioIntegrationType';
  accountSid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid?: Maybe<Scalars['String']['output']>;
};

export type TwilioPlatformType = {
  __typename?: 'TwilioPlatformType';
  accountSid: Scalars['String']['output'];
  channelType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
};

export type TwilioProfileInputType = {
  a2pBrandRegistrationSid?: InputMaybe<Scalars['String']['input']>;
  a2pCampaignSids?: InputMaybe<Array<Scalars['String']['input']>>;
  a2pMessagingServiceSid?: InputMaybe<Scalars['String']['input']>;
  businessProfileSid?: InputMaybe<Scalars['String']['input']>;
  cnamDisplayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  voiceIntegrityAverageBusinessDayCallVolume?: InputMaybe<Scalars['String']['input']>;
  voiceIntegrityBusinessEmployeeCount?: InputMaybe<Scalars['String']['input']>;
  voiceIntegrityNotes?: InputMaybe<Scalars['String']['input']>;
  voiceIntegrityUseCase?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioProfileType = {
  __typename?: 'TwilioProfileType';
  a2pBrandRegistrationSid?: Maybe<Scalars['String']['output']>;
  a2pCampaignSids?: Maybe<Array<Scalars['String']['output']>>;
  a2pEndUserSid?: Maybe<Scalars['String']['output']>;
  a2pFailureReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  a2pMessagingServiceSid?: Maybe<Scalars['String']['output']>;
  a2pRequired?: Maybe<Scalars['Boolean']['output']>;
  a2pStatus?: Maybe<A2PStatusEnum>;
  a2pTrustProductSid?: Maybe<Scalars['String']['output']>;
  allFormsHaveOptIn?: Maybe<Scalars['Boolean']['output']>;
  authorizedRepBusinessTitle?: Maybe<Scalars['String']['output']>;
  authorizedRepEmail?: Maybe<Scalars['String']['output']>;
  authorizedRepFirstName?: Maybe<Scalars['String']['output']>;
  authorizedRepJobPosition?: Maybe<Scalars['String']['output']>;
  authorizedRepLastName?: Maybe<Scalars['String']['output']>;
  authorizedRepPhoneNumber?: Maybe<Scalars['String']['output']>;
  brandRegistrationStatus?: Maybe<Scalars['String']['output']>;
  businessAddressCity?: Maybe<Scalars['String']['output']>;
  businessAddressCountry?: Maybe<Scalars['String']['output']>;
  businessAddressPostalCode?: Maybe<Scalars['String']['output']>;
  businessAddressState?: Maybe<Scalars['String']['output']>;
  businessAddressStreet?: Maybe<Scalars['String']['output']>;
  businessAddressStreetSecondary?: Maybe<Scalars['String']['output']>;
  businessCountry?: Maybe<Scalars['String']['output']>;
  businessEin?: Maybe<Scalars['String']['output']>;
  businessLegalName?: Maybe<Scalars['String']['output']>;
  businessProfileSid?: Maybe<Scalars['String']['output']>;
  businessRegistrationDocumentUrl?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  businessWebsiteUrl?: Maybe<Scalars['String']['output']>;
  campaignStatus?: Maybe<Scalars['String']['output']>;
  canModifyA2p?: Maybe<Scalars['Boolean']['output']>;
  channelType: Scalars['String']['output'];
  cnamDisplayName?: Maybe<Scalars['String']['output']>;
  cnamEndUserSid?: Maybe<Scalars['String']['output']>;
  cnamTrustProductSid?: Maybe<Scalars['String']['output']>;
  cnamTrustProductStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optInLanguageElementsIncluded?: Maybe<Scalars['Boolean']['output']>;
  powerOfAttorneyDocumentUrl?: Maybe<Scalars['String']['output']>;
  privacyPolicyNoSharing?: Maybe<Scalars['Boolean']['output']>;
  secondaryCustomerProfileSid?: Maybe<Scalars['String']['output']>;
  secondaryCustomerProfileStatus?: Maybe<Scalars['String']['output']>;
  shakenStirTrustProductSid?: Maybe<Scalars['String']['output']>;
  shakenStirTrustProductStatus?: Maybe<Scalars['String']['output']>;
  twimlAppSid?: Maybe<Scalars['String']['output']>;
  voiceIntegrityAverageBusinessDayCallVolume?: Maybe<Scalars['String']['output']>;
  voiceIntegrityBusinessEmployeeCount?: Maybe<Scalars['String']['output']>;
  voiceIntegrityEndUserSid?: Maybe<Scalars['String']['output']>;
  voiceIntegrityNotes?: Maybe<Scalars['String']['output']>;
  voiceIntegrityTrustProductSid?: Maybe<Scalars['String']['output']>;
  voiceIntegrityTrustProductStatus?: Maybe<Scalars['String']['output']>;
  voiceIntegrityUseCase?: Maybe<Scalars['String']['output']>;
};

export type TwilioRejectCallMutation = {
  __typename?: 'TwilioRejectCallMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnarchiveAgentMutation = {
  __typename?: 'UnarchiveAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnarchiveBrokerageMutation = {
  __typename?: 'UnarchiveBrokerageMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnarchiveTeamMutation = {
  __typename?: 'UnarchiveTeamMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassignCustomerFromAgentMutation = {
  __typename?: 'UnassignCustomerFromAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassignCustomerFromTeamMutation = {
  __typename?: 'UnassignCustomerFromTeamMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassignTaskFromAgentMutation = {
  __typename?: 'UnassignTaskFromAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassignTcrBrandMutation = {
  __typename?: 'UnassignTcrBrandMutation';
  result?: Maybe<TcrBrandType>;
};

export type UnassignTcrCampaignMutation = {
  __typename?: 'UnassignTcrCampaignMutation';
  result?: Maybe<TcrCampaignType>;
};

export type UnreadCountUpdateType = {
  __typename?: 'UnreadCountUpdateType';
  agentId?: Maybe<Scalars['ID']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  unreadCountUpdate?: Maybe<Scalars['Int']['output']>;
};

export type UnregisterExpoPushNotificationsMutation = {
  __typename?: 'UnregisterExpoPushNotificationsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAdminUserMutation = {
  __typename?: 'UpdateAdminUserMutation';
  admin?: Maybe<AdminType>;
};

export type UpdateAdvancedBehaviorMutation = {
  __typename?: 'UpdateAdvancedBehaviorMutation';
  result?: Maybe<AdvancedBehaviorType>;
};

export type UpdateAdvancedCallRoutingMutation = {
  __typename?: 'UpdateAdvancedCallRoutingMutation';
  result?: Maybe<AdvancedCallRoutingType>;
};

export type UpdateAgentAudioRecordingMutation = {
  __typename?: 'UpdateAgentAudioRecordingMutation';
  agent?: Maybe<AgentType>;
};

export type UpdateAgentPermissionsMutation = {
  __typename?: 'UpdateAgentPermissionsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAppointmentSchedulingSettingsMutation = {
  __typename?: 'UpdateAppointmentSchedulingSettingsMutation';
  agent?: Maybe<AgentType>;
};

export type UpdateBehaviorMutation = {
  __typename?: 'UpdateBehaviorMutation';
  result?: Maybe<BehaviorType>;
};

export type UpdateBonzoSettingsMutation = {
  __typename?: 'UpdateBonzoSettingsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCaasSettingsMutation = {
  __typename?: 'UpdateCaasSettingsMutation';
  result?: Maybe<PartnerAccount>;
};

export type UpdateCallMutation = {
  __typename?: 'UpdateCallMutation';
  result?: Maybe<VoiceCallType>;
};

export type UpdateCampaignFromAgentsMutation = {
  __typename?: 'UpdateCampaignFromAgentsMutation';
  campaign?: Maybe<CampaignType>;
};

export type UpdateCampaignMutation = {
  __typename?: 'UpdateCampaignMutation';
  campaign?: Maybe<CampaignType>;
};

export type UpdateChannelCampaignAttachmentMutation = {
  __typename?: 'UpdateChannelCampaignAttachmentMutation';
  result?: Maybe<CommunicationChannelType>;
};

export type UpdateChannelDigitalVoiceAssistantMutation = {
  __typename?: 'UpdateChannelDigitalVoiceAssistantMutation';
  result?: Maybe<CommunicationChannelType>;
};

export type UpdateChannelDisabledMutation = {
  __typename?: 'UpdateChannelDisabledMutation';
  result?: Maybe<CommunicationChannelType>;
};

export type UpdateChannelSetPrimary = {
  __typename?: 'UpdateChannelSetPrimary';
  result?: Maybe<CommunicationChannelType>;
};

export type UpdateCustomFlowMutation = {
  __typename?: 'UpdateCustomFlowMutation';
  customFlow?: Maybe<CustomFlowType>;
};

export type UpdateCustomIntentVersionMutation = {
  __typename?: 'UpdateCustomIntentVersionMutation';
  createdVersionId?: Maybe<Scalars['ID']['output']>;
  latestVersionId?: Maybe<Scalars['ID']['output']>;
  version?: Maybe<CustomIntentVersionType>;
};

export type UpdateCustomSchemaResponseAnnotation = {
  __typename?: 'UpdateCustomSchemaResponseAnnotation';
  result?: Maybe<CustomSchemaResponseType>;
};

export type UpdateCustomScriptMutation = {
  __typename?: 'UpdateCustomScriptMutation';
  customScript?: Maybe<CustomScriptType>;
};

export type UpdateCustomScriptVersionMutation = {
  __typename?: 'UpdateCustomScriptVersionMutation';
  createdVersionId?: Maybe<Scalars['ID']['output']>;
  latestVersionId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use version instead of individual results updates */
  results?: Maybe<Array<Maybe<ScriptUpdateContentType>>>;
  version?: Maybe<CustomScriptVersionType>;
};

export type UpdateCustomToolMutation = {
  __typename?: 'UpdateCustomToolMutation';
  result?: Maybe<CustomToolDefinitionType>;
};

export type UpdateCustomerCampaignStageMutation = {
  __typename?: 'UpdateCustomerCampaignStageMutation';
  customerCampaign?: Maybe<CustomerCampaignType>;
};

export type UpdateCustomerFilterMutation = {
  __typename?: 'UpdateCustomerFilterMutation';
  customerFilter?: Maybe<CustomerFilterType>;
};

export type UpdateCustomizedSlotMutation = {
  __typename?: 'UpdateCustomizedSlotMutation';
  slot?: Maybe<CustomizedSlotType>;
};

export type UpdateCustomizedStageMutation = {
  __typename?: 'UpdateCustomizedStageMutation';
  stage?: Maybe<CustomizedStageType>;
};

export type UpdateFollowUpBossV2SettingsMutation = {
  __typename?: 'UpdateFollowUpBossV2SettingsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateGoHighLevelMutation = {
  __typename?: 'UpdateGoHighLevelMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateHubSpotV2SettingsMutation = {
  __typename?: 'UpdateHubSpotV2SettingsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateInternalPromptTemplateMutation = {
  __typename?: 'UpdateInternalPromptTemplateMutation';
  result?: Maybe<InternalPromptTemplateType>;
};

export type UpdateKnowledgeBaseMutation = {
  __typename?: 'UpdateKnowledgeBaseMutation';
  result?: Maybe<KnowledgeBaseType>;
};

export type UpdateLeadEnrollmentRuleMutation = {
  __typename?: 'UpdateLeadEnrollmentRuleMutation';
  enrollmentRule?: Maybe<LeadEnrollmentRuleType>;
};

export type UpdateLeadListMutation = {
  __typename?: 'UpdateLeadListMutation';
  result?: Maybe<LeadListType>;
};

export type UpdateLeadRoutingSettingsMutation = {
  __typename?: 'UpdateLeadRoutingSettingsMutation';
  settings?: Maybe<LeadRoutingSettingsType>;
};

export type UpdateLeadUploadMappingMutation = {
  __typename?: 'UpdateLeadUploadMappingMutation';
  result?: Maybe<LeadUploadMappingType>;
};

export type UpdateLocalPresenceSettingsMutation = {
  __typename?: 'UpdateLocalPresenceSettingsMutation';
  settings?: Maybe<LocalPresenceSettingsType>;
};

export enum UpdateOperationTypes {
  Pull = 'PULL',
  Push = 'PUSH',
  Set = 'SET',
  Unset = 'UNSET'
}

export type UpdateOptionsInputType = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromptTemplateInputType = {
  bedrockNova2Template?: InputMaybe<Scalars['String']['input']>;
  bedrockOpenaiOssTemplate?: InputMaybe<Scalars['String']['input']>;
  gpt41Template?: InputMaybe<Scalars['String']['input']>;
  gpt51Template?: InputMaybe<Scalars['String']['input']>;
  gpt56Template?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promptType?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromptTemplateMutation = {
  __typename?: 'UpdatePromptTemplateMutation';
  result?: Maybe<PromptTemplateType>;
};

export type UpdatePubSubSubscription = {
  __typename?: 'UpdatePubSubSubscription';
  result?: Maybe<PubSubSubscriptionType>;
};

export type UpdateSalesForceSettingsMutation = {
  __typename?: 'UpdateSalesForceSettingsMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSchedulingSettingsMutation = {
  __typename?: 'UpdateSchedulingSettingsMutation';
  schedulingSettings?: Maybe<SchedulingSettingsType>;
};

export type UpdateSubscriptionCardMutation = {
  __typename?: 'UpdateSubscriptionCardMutation';
  subscription?: Maybe<SubscriptionType>;
};

export type UpdateSubscriptionMutation = {
  __typename?: 'UpdateSubscriptionMutation';
  authJwt?: Maybe<Scalars['String']['output']>;
  brokerageId?: Maybe<Scalars['ID']['output']>;
  subscription?: Maybe<SubscriptionType>;
  teamId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateTaskMutation = {
  __typename?: 'UpdateTaskMutation';
  task?: Maybe<TaskType>;
};

export type UpdateTextAiAgentMutation = {
  __typename?: 'UpdateTextAiAgentMutation';
  result?: Maybe<TextAiAgentType>;
};

export type UpdateTwilioA2PProfile = {
  __typename?: 'UpdateTwilioA2PProfile';
  result?: Maybe<CommunicationProfileType>;
};

export type UpdateTwilioA2PRequired = {
  __typename?: 'UpdateTwilioA2PRequired';
  brokerage?: Maybe<BrokerageType>;
  communicationProfile?: Maybe<CommunicationProfileType>;
};

export type UpdateVoiceAiAgentMutation = {
  __typename?: 'UpdateVoiceAiAgentMutation';
  result?: Maybe<VoiceAiAgentType>;
};

export type UpdateVonageA2PProfile = {
  __typename?: 'UpdateVonageA2PProfile';
  result?: Maybe<CommunicationProfileType>;
};

export type UpdateVonageChannelCallControlMode = {
  __typename?: 'UpdateVonageChannelCallControlMode';
  result?: Maybe<CommunicationChannelType>;
};

export type UploadRequiredHeader = {
  __typename?: 'UploadRequiredHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UploadUrlResult = {
  __typename?: 'UploadUrlResult';
  expiresAt: Scalars['DateTime']['output'];
  requiredHeaders: Array<UploadRequiredHeader>;
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UserIntegrationsType = {
  __typename?: 'UserIntegrationsType';
  faux?: Maybe<FauxIntegrationType>;
  google?: Maybe<GoogleIntegrationType>;
  googleEnrollment?: Maybe<GoogleEnrollmentIntegrationType>;
  schedulingSettings: AppointmentSchedulingSettingsType;
};

export type ValidateAgentMutation = {
  __typename?: 'ValidateAgentMutation';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidatePartnerResetPasswordMutation = {
  __typename?: 'ValidatePartnerResetPasswordMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidatePartnerUserInvitationMutation = {
  __typename?: 'ValidatePartnerUserInvitationMutation';
  result?: Maybe<PartnerUserType>;
};

export type ValidateResellerResetPasswordMutation = {
  __typename?: 'ValidateResellerResetPasswordMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateResellerUserInvitationMutation = {
  __typename?: 'ValidateResellerUserInvitationMutation';
  result?: Maybe<ResellerAgentType>;
};

export enum VendorModelFamilyEnum {
  BedrockAnthropicClaudeV3 = 'BEDROCK_ANTHROPIC_CLAUDE_V3',
  BedrockMetaLlamaV3 = 'BEDROCK_META_LLAMA_V3',
  BedrockNovaV2 = 'BEDROCK_NOVA_V2',
  BedrockOpenAiOss = 'BEDROCK_OPEN_AI_OSS',
  BedrockOpenAiOss_20B = 'BEDROCK_OPEN_AI_OSS_20B',
  OpenAiGpt_4_1 = 'OPEN_AI_GPT_4_1',
  OpenAiGpt_5_0 = 'OPEN_AI_GPT_5_0',
  OpenAiGpt_5_1 = 'OPEN_AI_GPT_5_1',
  OpenAiGpt_5_2 = 'OPEN_AI_GPT_5_2',
  OpenAiGpt_5_6Luna = 'OPEN_AI_GPT_5_6_LUNA',
  OpenAiGpt_5_6Sol = 'OPEN_AI_GPT_5_6_SOL',
  OpenAiGpt_5_6Terra = 'OPEN_AI_GPT_5_6_TERRA',
  StructurelyOmni = 'STRUCTURELY_OMNI'
}

export type VerifyMailgunDomainMutation = {
  __typename?: 'VerifyMailgunDomainMutation';
  mailgunDomains?: Maybe<MailgunDomainType>;
};

export type VerifyResellerBrokerageMutation = {
  __typename?: 'VerifyResellerBrokerageMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type VoiceAiAgentInputType = {
  advancedCallRoutingId?: InputMaybe<Scalars['ID']['input']>;
  callIntent?: InputMaybe<Scalars['String']['input']>;
  clientWhisperTemplate?: InputMaybe<Scalars['String']['input']>;
  communicationStyle: Scalars['String']['input'];
  customAnswers?: InputMaybe<Array<CustomVoicePromptAnswerInputType>>;
  customGreeting?: InputMaybe<Scalars['String']['input']>;
  customGreetingOutbound?: InputMaybe<Scalars['String']['input']>;
  customGreetingTextAi?: InputMaybe<Scalars['String']['input']>;
  customQuestions?: InputMaybe<Array<CustomVoicePromptQuestionInputType>>;
  customToolAttachments?: InputMaybe<Array<CustomToolAttachmentInputType>>;
  disqualificationCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAgentPinning?: InputMaybe<Scalars['Boolean']['input']>;
  endCallMessageInbound?: InputMaybe<Scalars['String']['input']>;
  endCallMessageOutbound?: InputMaybe<Scalars['String']['input']>;
  generateAiGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['String']['input'];
  knowledgeBases?: InputMaybe<Array<Scalars['String']['input']>>;
  leadType?: InputMaybe<Scalars['String']['input']>;
  liveTransferTemplate?: InputMaybe<Scalars['String']['input']>;
  llmModelFamily?: InputMaybe<VendorModelFamilyEnum>;
  name: Scalars['String']['input'];
  persona: Scalars['String']['input'];
  promptTemplate: Scalars['String']['input'];
  pronunciationRules?: InputMaybe<Array<PronunciationRuleInputType>>;
  slotSchema?: InputMaybe<Array<SlotSchemaInputType>>;
  specializedGuidance?: InputMaybe<Scalars['String']['input']>;
  successfulOutcomes?: InputMaybe<CallSuccessOutcomesInputType>;
  supportedLanguages?: InputMaybe<SupportedLanguagesInputType>;
  transcriptionOverrides?: InputMaybe<Scalars['GenericScalar']['input']>;
  voiceMailMessages?: InputMaybe<Array<CustomVoiceMailInputType>>;
  voiceOrchestrationProvider?: InputMaybe<VoiceOrchestrationProviderEnum>;
  voiceProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceAiAgentType = {
  __typename?: 'VoiceAiAgentType';
  advancedCallRouting?: Maybe<AdvancedCallRoutingType>;
  assistantId?: Maybe<Scalars['String']['output']>;
  callIntent?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  clientWhisperTemplate?: Maybe<Scalars['String']['output']>;
  communicationStyle: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customAnswers?: Maybe<Array<CustomVoicePromptAnswerType>>;
  customGreeting?: Maybe<Scalars['String']['output']>;
  customGreetingOutbound?: Maybe<Scalars['String']['output']>;
  customGreetingTextAi?: Maybe<Scalars['String']['output']>;
  customQuestions?: Maybe<Array<CustomVoicePromptQuestionType>>;
  customToolAttachments?: Maybe<Array<AiAgentCustomToolAttachmentType>>;
  disqualificationCriteria?: Maybe<Array<Scalars['String']['output']>>;
  enableAgentPinning?: Maybe<Scalars['Boolean']['output']>;
  endCallMessageInbound?: Maybe<Scalars['String']['output']>;
  endCallMessageOutbound?: Maybe<Scalars['String']['output']>;
  generateAiGreeting?: Maybe<Scalars['Boolean']['output']>;
  hasCampaign: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDisabledByAdmin?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isUsedByWorkflow?: Maybe<Scalars['Boolean']['output']>;
  jobTitle: Scalars['String']['output'];
  knowledgeBases?: Maybe<Array<KnowledgeBaseType>>;
  leadType?: Maybe<Scalars['String']['output']>;
  liveTransferTemplate?: Maybe<Scalars['String']['output']>;
  llmModelFamily?: Maybe<VendorModelFamilyEnum>;
  name: Scalars['String']['output'];
  persona: Scalars['String']['output'];
  promptTemplate: PromptTemplateType;
  pronunciationRules?: Maybe<Array<PronunciationRuleType>>;
  slotSchema?: Maybe<Array<SlotSchemaType>>;
  specializedGuidance?: Maybe<Scalars['String']['output']>;
  successfulOutcomes?: Maybe<CallSuccessOutcomesType>;
  supportedLanguages?: Maybe<SupportedLanguagesType>;
  transcriptionOverrides?: Maybe<Scalars['GenericScalar']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useCase: Scalars['String']['output'];
  useInsteadOfLiveTransfer?: Maybe<Scalars['Boolean']['output']>;
  voiceMailMessages?: Maybe<Array<CustomVoiceMailType>>;
  voiceOrchestrationProvider?: Maybe<VoiceOrchestrationProviderEnum>;
  voiceProviderId?: Maybe<Scalars['String']['output']>;
};

export type VoiceCallPagination = {
  __typename?: 'VoiceCallPagination';
  count: Scalars['Int']['output'];
  items: Array<VoiceCallType>;
  nextCursorId?: Maybe<Scalars['String']['output']>;
};

export type VoiceCallSummaryType = {
  __typename?: 'VoiceCallSummaryType';
  callsThisInterval: Scalars['Int']['output'];
  doorVisitsThisInterval: Scalars['Int']['output'];
  inboundAiCallsThisInterval: Scalars['Int']['output'];
  inboundCallsThisInterval: Scalars['Int']['output'];
  liveTransferCallsThisInterval: Scalars['Int']['output'];
  outboundAiCallsThisInterval: Scalars['Int']['output'];
  outboundCallsThisInterval: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalDoorVisits: Scalars['Int']['output'];
  totalInboundAiCalls: Scalars['Int']['output'];
  totalInboundCalls: Scalars['Int']['output'];
  totalLiveTransferCalls: Scalars['Int']['output'];
  totalOutboundAiCalls: Scalars['Int']['output'];
  totalOutboundCalls: Scalars['Int']['output'];
};

export type VoiceCallType = {
  __typename?: 'VoiceCallType';
  agentCallStatus: Scalars['String']['output'];
  agentName?: Maybe<Scalars['String']['output']>;
  aiCallEndMessage?: Maybe<Scalars['String']['output']>;
  aiCallGreeting?: Maybe<Scalars['String']['output']>;
  aiCallId?: Maybe<Scalars['String']['output']>;
  aiCallPrompt?: Maybe<Scalars['String']['output']>;
  aiCallVoicemail?: Maybe<Scalars['String']['output']>;
  aiChatCompletions?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  aiOrchestrationProvider?: Maybe<Scalars['String']['output']>;
  aiTools?: Maybe<Array<Maybe<Scalars['GenericScalar']['output']>>>;
  analysis?: Maybe<CallInsightsType>;
  analyzedAt?: Maybe<Scalars['DateTime']['output']>;
  callDisposition?: Maybe<CallDispositionType>;
  callNotes?: Maybe<Scalars['String']['output']>;
  callType: Scalars['String']['output'];
  customer?: Maybe<LiteCustomerType>;
  customerCallStatus: Scalars['String']['output'];
  destinationNumber: Scalars['String']['output'];
  digitalVoiceUseCase?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAnalysis: Scalars['Boolean']['output'];
  hasRecording: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  liveTransferAnalytics?: Maybe<LiveTransferAnalyticsType>;
  outboundCall: Scalars['Boolean']['output'];
  sourceNumber: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  systemNumber?: Maybe<Scalars['String']['output']>;
  telcoProvider?: Maybe<TelcoType>;
  textAiAgent?: Maybe<TextAiAgentType>;
  transcription?: Maybe<Array<TranscriptionEventType>>;
  triggeredByTextAi?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendorCallId: Scalars['String']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
  voiceAiAgent?: Maybe<VoiceAiAgentType>;
};

export type VoiceCallUpdateType = {
  __typename?: 'VoiceCallUpdateType';
  voiceCall?: Maybe<VoiceCallType>;
};

export enum VoiceOrchestrationProviderEnum {
  Structurely = 'STRUCTURELY',
  Vapi = 'VAPI'
}

export type VoiceProviderType = {
  __typename?: 'VoiceProviderType';
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  style: Scalars['String']['output'];
};

export type VonageA2PProfileInputType = {
  a2pBrandId?: InputMaybe<Scalars['String']['input']>;
  a2pBrandStatus?: InputMaybe<Scalars['String']['input']>;
  a2pCampaignId?: InputMaybe<Scalars['String']['input']>;
  a2pCampaignStatus?: InputMaybe<Scalars['String']['input']>;
  a2pFailureReason?: InputMaybe<Scalars['String']['input']>;
};

export type VonagePlatformType = {
  __typename?: 'VonagePlatformType';
  a2pAssignmentFailureReason?: Maybe<Scalars['String']['output']>;
  a2pAssignmentStatus?: Maybe<Scalars['String']['output']>;
  byocTrunkSid?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  msisdn: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  voiceCallControlModeOverride?: Maybe<VonageVoiceCallControlModeEnum>;
};

export type VonageProfileInputType = {
  cnamDisplayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VonageProfileType = {
  __typename?: 'VonageProfileType';
  a2pBrandId?: Maybe<Scalars['String']['output']>;
  a2pBrandStatus?: Maybe<Scalars['String']['output']>;
  a2pCampaignId?: Maybe<Scalars['String']['output']>;
  a2pCampaignStatus?: Maybe<Scalars['String']['output']>;
  a2pFailureReason?: Maybe<Scalars['String']['output']>;
  byocTrunkSid?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  cnamDisplayName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subaccountApiKey: Scalars['String']['output'];
  /** @deprecated Use VonagePlatform.voiceCallControlModeOverride on individual communication channels (ENG-3569). Per-channel control gives the safer blast radius for Vonage Direct rollout. */
  voiceCallControlMode?: Maybe<VonageVoiceCallControlModeEnum>;
};

export enum VonageVoiceCallControlModeEnum {
  Byoc = 'BYOC',
  Direct = 'DIRECT'
}

export enum VoterDoorVisitAssociation {
  Both = 'BOTH',
  CurrentHousehold = 'CURRENT_HOUSEHOLD',
  DirectVoter = 'DIRECT_VOTER'
}

export type VoterDoorVisitItem = {
  __typename?: 'VoterDoorVisitItem';
  association: VoterDoorVisitAssociation;
  visit: DoorVisitListItem;
};

export type VoterDoorVisitsResult = {
  __typename?: 'VoterDoorVisitsResult';
  items: Array<VoterDoorVisitItem>;
  total: Scalars['Int']['output'];
};

export type VoterListResult = {
  __typename?: 'VoterListResult';
  items: Array<FieldOpsVoter>;
  total: Scalars['Int']['output'];
};

export type VoterMapPoint = {
  __typename?: 'VoterMapPoint';
  address?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  householdId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type VotersInBoundsResult = {
  __typename?: 'VotersInBoundsResult';
  effectiveBounds: BufferedGeographicBounds;
  items: Array<VoterMapPoint>;
  pageInfo: MapCursorPageInfo;
};

export type WebchatIntegrationType = {
  __typename?: 'WebchatIntegrationType';
  appId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated appToken is being replaced with appId in smooch webchat */
  appToken?: Maybe<Scalars['String']['output']>;
};

export enum WebhookMutationStatusType {
  Active = 'active',
  Disabled = 'disabled'
}

export enum WebhookStatusType {
  Active = 'active',
  Disabled = 'disabled',
  Failed = 'failed'
}

export type WeeklyCommunicationChannelMetricsType = {
  __typename?: 'WeeklyCommunicationChannelMetricsType';
  calls: Scalars['Int']['output'];
  messageDeliveryRate: Scalars['Float']['output'];
  messages: Scalars['Int']['output'];
  outboundFailedMessages: Scalars['Int']['output'];
  outboundMessages: Scalars['Int']['output'];
};

export enum WorkflowActionTypeEnum {
  MuteStateChannelAction = 'MUTE_STATE_CHANNEL_ACTION',
  StartCallAction = 'START_CALL_ACTION',
  StartConversationAction = 'START_CONVERSATION_ACTION'
}

export enum WorkflowConditionConstraintEnum {
  RequireAnd = 'REQUIRE_AND',
  RequireOr = 'REQUIRE_OR'
}

export type WorkflowPropertyFixedValueType = {
  __typename?: 'WorkflowPropertyFixedValueType';
  answer?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WorkflowPropertySchemaType = {
  __typename?: 'WorkflowPropertySchemaType';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<WorkflowPropertyFixedValueType>>;
  type: WorkflowPropertyTypeEnum;
};

export enum WorkflowPropertyTypeEnum {
  Boolean = 'BOOLEAN',
  BuiltIn = 'BUILT_IN',
  Datetime = 'DATETIME',
  Fixed = 'FIXED',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export type WorkflowSchemaType = {
  __typename?: 'WorkflowSchemaType';
  allowedActions: Array<WorkflowActionTypeEnum>;
  description: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  properties: Array<WorkflowPropertySchemaType>;
  systemSuppressedBy?: Maybe<WorkflowTriggerType>;
  systemTriggeredBy?: Maybe<WorkflowTriggerType>;
};

export type WorkflowTriggerType = {
  __typename?: 'WorkflowTriggerType';
  condition?: Maybe<Scalars['GenericScalar']['output']>;
  constraint?: Maybe<WorkflowConditionConstraintEnum>;
};
